/* tslint:disable */
/* eslint-disable */
/**
 * Measurement Service API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

export interface RHIMAPOCoreWebProblemDetailsApoProblemDetails {
    [key: string]: any;

    'errorCode'?: string | null;
    'data'?: any | null;
    'type'?: string | null;
    'title'?: string | null;
    'status'?: number | null;
    'detail'?: string | null;
    'instance'?: string | null;
}

export const RHIMContractsColorScaleType = {
    Rbl: 'RBL',
    Wear: 'Wear',
    WearRate: 'WearRate',
} as const;

export type RHIMContractsColorScaleType = typeof RHIMContractsColorScaleType[keyof typeof RHIMContractsColorScaleType];



export const RHIMContractsCoordinateSystem2D = {
    Xy: 'XY',
    RTheta: 'RTheta',
    ThetaZ: 'ThetaZ',
} as const;

export type RHIMContractsCoordinateSystem2D = typeof RHIMContractsCoordinateSystem2D[keyof typeof RHIMContractsCoordinateSystem2D];



export const RHIMContractsFileType = {
    PostMortem: 'PostMortem',
    ProcessData: 'ProcessData',
    ProcessMetrixFiltered: 'ProcessMetrixFiltered',
    ProcessMetrixRaw: 'ProcessMetrixRaw',
    ProcessMetrixVertex: 'ProcessMetrixVertex',
    ProcessMetrixSummary: 'ProcessMetrixSummary',
    ProcessMetrixZip: 'ProcessMetrixZip',
    Stl: 'STL',
    HarmonizedSummary: 'HarmonizedSummary',
    ProcessDataSplit: 'ProcessDataSplit',
    Pts: 'PTS',
    Clinker: 'Clinker',
    KilnFeed: 'KilnFeed',
    HotMeal: 'HotMeal',
    Lignite: 'Lignite',
    StopLogs: 'StopLogs',
    IrScan: 'IRScan',
    KilnShellCooling: 'KilnShellCooling',
    KilnProcessData: 'KilnProcessData',
    FerrotronSummary: 'FerrotronSummary',
} as const;

export type RHIMContractsFileType = typeof RHIMContractsFileType[keyof typeof RHIMContractsFileType];



export const RHIMContractsFunctionalProductType = {
    Taphole: 'Taphole',
    PurgePlug: 'PurgePlug',
    Trunnion: 'Trunnion',
    Tyre: 'Tyre',
    Drive: 'Drive',
} as const;

export type RHIMContractsFunctionalProductType = typeof RHIMContractsFunctionalProductType[keyof typeof RHIMContractsFunctionalProductType];



export const RHIMContractsIndustry = {
    Steel: 'Steel',
    CementAndLime: 'CementAndLime',
    Nfm: 'NFM',
    Eec: 'EEC',
    Glass: 'Glass',
    Foundry: 'Foundry',
    Minerals: 'Minerals',
    ProcessIndustries: 'ProcessIndustries',
    Internal: 'Internal',
} as const;

export type RHIMContractsIndustry = typeof RHIMContractsIndustry[keyof typeof RHIMContractsIndustry];


export interface RHIMContractsPoint2D {
    'r'?: number | null;
    'theta'?: number | null;
    'z'?: number | null;
    'x'?: number | null;
    'y'?: number | null;
}

export const RHIMContractsRegionLocation = {
    Bottom: 'Bottom',
    Barrel: 'Barrel',
    Cone: 'Cone',
    ThroatIn: 'ThroatIn',
    ThroatOut: 'ThroatOut',
    Side0: 'Side0',
    Side1: 'Side1',
    Side2: 'Side2',
    Side3: 'Side3',
} as const;

export type RHIMContractsRegionLocation = typeof RHIMContractsRegionLocation[keyof typeof RHIMContractsRegionLocation];



export const RHIMContractsVesselType = {
    Bof: 'BOF',
    Rh: 'RH',
    Eaf: 'EAF',
    Ladle: 'Ladle',
    Crk: 'CRK',
    Rhl: 'RHL',
    Aod: 'AOD',
    Bfr: 'BFR',
    Srf: 'SRF',
    Cou: 'COU',
    Hml: 'HML',
    Cco: 'CCO',
    Ccy: 'CCY',
    Cca: 'CCA',
    Tun: 'TUN',
    Pcg: 'PCG',
    Hof: 'HOF',
    Anf: 'ANF',
    Maf: 'MAF',
    Tif: 'TIF',
    Shf: 'SHF',
    Tlc: 'TLC',
} as const;

export type RHIMContractsVesselType = typeof RHIMContractsVesselType[keyof typeof RHIMContractsVesselType];


export interface RHIMHMDCustomerManagementContractsV1VesselColorscaleDto {
    'vesselType': string;
    'colorScaleType'?: RHIMContractsColorScaleType | null;
    'thresholdsAndColors': Array<RHIMHMDCustomerManagementContractsV1VesselThresholdAndColorDto>;
}


export interface RHIMHMDCustomerManagementContractsV1VesselOrientationLabelDto {
    'angle': number;
    'displayText': string;
}
export interface RHIMHMDCustomerManagementContractsV1VesselThresholdAndColorDto {
    'threshold': number;
    'color': string;
}
export interface RHIMHMDCustomerManagementContractsV1VesselVesselDto {
    'id': string;
    'shortName': string;
    'displayName': string;
    'vesselType': string;
    'customerId': string;
    'customerShortName': string;
}
export interface RHIMHMDCustomerManagementContractsV1VesselVesselFunctionalProductDto {
    'id': string;
    'vesselId': string;
    'name': string;
    'type': RHIMContractsFunctionalProductType;
    'regionLocation': RHIMContractsRegionLocation;
    'area': object;
    'tiltAngle': number;
}


export interface RHIMMeasurementServiceApiV1ModelsBottomPlotDto {
    'data'?: Array<RHIMMeasurementServiceDataCylindricalBottomPlotData> | null;
    'dataCartesian'?: RHIMMeasurementServiceDataCartesianBottomPlot | null;
    'wallPlotThroatIn'?: RHIMMeasurementServiceDataWallPlot | null;
    'wallPlotThroatOut'?: RHIMMeasurementServiceDataWallPlot | null;
    'metadata': RHIMMeasurementServiceDataCylindricalBottomPlotMetadata;
}
export interface RHIMMeasurementServiceApiV1ModelsCalculateTransformPointsDto {
    'sourcePoints': Array<Array<number>>;
    'targetPoints': Array<Array<number>>;
    'transformationMatrix': Array<number>;
}
export interface RHIMMeasurementServiceApiV1ModelsCalculateTransformPointsResultDto {
    'transformationMatrix': Array<number>;
}
export interface RHIMMeasurementServiceApiV1ModelsCampaignDto {
    'id': number;
    'vesselId': string;
    'displayText': string;
}
export interface RHIMMeasurementServiceApiV1ModelsGunningEventDto {
    'id': string;
    'timestamp': string;
    'vesselId'?: string | null;
    'measurementId'?: string | null;
    'campaign': number;
    'heat': number;
    'materialId': string;
    'amount': number;
}
export interface RHIMMeasurementServiceApiV1ModelsGunningEventMaterialDataDto {
    'eventTimestamp': string;
    'materialId': string;
    'amount': number;
    'measurementId': string;
}
export interface RHIMMeasurementServiceApiV1ModelsGunningMaterialLookupDto {
    'id': string;
    'name': string;
}
export interface RHIMMeasurementServiceApiV1ModelsMaintenanceRequestDto {
    'token'?: string | null;
}
export interface RHIMMeasurementServiceApiV1ModelsMaintenanceResponseDto {
    'token': string | null;
    'success': boolean;
    'reason': string | null;
}
export interface RHIMMeasurementServiceApiV1ModelsMaterialDto {
    'id': string;
    'name': string;
    'density': number;
}
export interface RHIMMeasurementServiceApiV1ModelsMeasurementBaseDataDto {
    'id': string;
    'campaign': number;
    'heat': number;
    'measurementTaken': string;
    'vesselLining': string;
    'isHotMeasurement': boolean;
    'liningCondition': string;
    'isReferable': boolean;
    'liningMaintenanceType'?: string | null;
    'status': RHIMMeasurementServiceContractsDataMeasurementState;
    'measurementSystem'?: string | null;
}


export interface RHIMMeasurementServiceApiV1ModelsMeasurementDetailedDataDto {
    'id': string;
    'campaign': number;
    'heat': number;
    'measurementTaken': string;
    'vesselLining': string;
    'isHotMeasurement': boolean;
    'liningCondition': string;
    'isViewOnly': boolean;
    'responsible': string;
    'notes': string;
    'liningMaintenanceType'?: string | null;
    'status': RHIMMeasurementServiceContractsDataMeasurementState;
    'isScheduled': boolean;
    'statusOnUtc': string;
    'statusReason': string;
    'measurementSystem': string;
    'createdBy': string;
    'createdOnUtc': string;
    'measurementFilesCount': number;
    'measurementFiles': Array<RHIMMeasurementServiceApiV1ModelsMeasurementFileDto>;
}


export interface RHIMMeasurementServiceApiV1ModelsMeasurementDto {
    'vesselId': string;
    'notes'?: string | null;
    'responsible'?: string | null;
    'measurementFiles': Array<RHIMMeasurementServiceApiV1ModelsMeasurementFileDto>;
    'id': string;
    'campaign': number;
    'heat': number;
    'measurementTaken': string;
    'vesselLining': string;
    'isHotMeasurement': boolean;
    'liningCondition': string;
    'isReferable': boolean;
    'liningMaintenanceType'?: string | null;
    'status': RHIMMeasurementServiceContractsDataMeasurementState;
    'measurementSystem'?: string | null;
}


export interface RHIMMeasurementServiceApiV1ModelsMeasurementFileDto {
    'id': string;
    'name': string;
    'originalFileName'?: string | null;
    'measurementFileType': string;
    'size': number;
    'lastModified': string;
    'contentType': string;
}
export interface RHIMMeasurementServiceApiV1ModelsMeasurementMetadataDto {
    'measurementSystem'?: string | null;
    'vesselHeight': number;
    'vesselLength': number;
    'vesselWidth': number;
    'vesselInnerDiameter': number;
    'vesselOuterDiameter': number;
    'bottomDepth'?: number | null;
    'topDepth'?: number | null;
    'bottomPosition'?: number | null;
    'bottomDistance'?: number | null;
    'volumeStartDepth'?: number | null;
    'snorkelIn'?: RHIMMeasurementServiceDataSnorkelPosition | null;
    'snorkelOut'?: RHIMMeasurementServiceDataSnorkelPosition | null;
    'snorkelHeight': number;
    'throatHeight': number;
    'throatDistance': number;
    'snorkelInOuterDiameter': number;
    'snorkelInInnerDiameter': number;
    'snorkelOutOuterDiameter': number;
    'snorkelOutInnerDiameter': number;
    'wallplotStepSizeDepth': number;
    'wallplotStepSizeAngle': number;
    'wallplotStepSizeHeight': number;
    'wallplotStepSizeLength': number;
    'snorkelWallplotStepSizeDepth': number;
    'snorkelWallplotStepSizeAngle': number;
    'bottomplotStepSizeRadius': number;
    'bottomplotStepSizeAngle': number;
    'bottomplotStepSizeLength': number;
    'bottomplotStepSizeWidth': number;
    'bottomplotAngleStepSizePerRadius': { [key: string]: number; };
    'vesselBendParams': Array<RHIMMeasurementServiceDataVesselBendParameter>;
    'sectionCutsStepSizeDepth': number;
    'sectionCutsStepSizeAngle': number;
    'sectionCutsStepSizeLength': number;
    'statisticalUnits': RHIMMeasurementServiceDataMeasurementPlotUnits;
    'depthUnits': RHIMMeasurementServiceDataMeasurementPlotUnits;
    'angleUnits': RHIMMeasurementServiceDataMeasurementPlotUnits;
    'wallDistanceMin': number;
    'wallDistanceMax': number;
    'reducedPointCloudFactor': number;
    'unitsFactor': number;
    'minimumCorrespondentPoints': number;
    'maximumCorrespondentPoints': number;
    'correspondentPointClusterRadius': number;
    'slaglineDepth': number;
    'ironlineDepth': number;
    'distancesNullThreshold': number;
    'negativeRblNullThreshold': number;
    'cutMeshAboveZeroHeight': boolean;
    'hotspotAreaHeight': number;
    'uvAspectRatio': number;
    'uvSegmentSize'?: number | null;
    'uvZeroHeightSide0V'?: number | null;
    'uvZeroHeightSide1V'?: number | null;
}


export interface RHIMMeasurementServiceApiV1ModelsMeasurementOverviewStateDataDto {
    'isLocked': boolean;
    'id': string;
    'campaign': number;
    'heat': number;
    'measurementTaken': string;
    'vesselLining': string;
    'isHotMeasurement': boolean;
    'liningCondition': string;
    'isReferable': boolean;
    'liningMaintenanceType'?: string | null;
    'status': RHIMMeasurementServiceContractsDataMeasurementState;
    'measurementSystem'?: string | null;
}


export interface RHIMMeasurementServiceApiV1ModelsMeasurementPointcloudViewDto {
    'hasPotree': boolean;
    'hasPanoramaImage': boolean;
    'id': string;
    'campaign': number;
    'heat': number;
    'measurementTaken': string;
    'vesselLining': string;
    'isHotMeasurement': boolean;
    'liningCondition': string;
    'isViewOnly': boolean;
    'responsible': string;
    'notes': string;
    'liningMaintenanceType'?: string | null;
    'status': RHIMMeasurementServiceContractsDataMeasurementState;
    'isScheduled': boolean;
    'statusOnUtc': string;
    'statusReason': string;
    'measurementSystem': string;
    'createdBy': string;
    'createdOnUtc': string;
    'measurementFilesCount': number;
    'measurementFiles': Array<RHIMMeasurementServiceApiV1ModelsMeasurementFileDto>;
}


export interface RHIMMeasurementServiceApiV1ModelsMeasurementStatusDto {
    'id': string;
    'state': RHIMMeasurementServiceContractsDataMeasurementState;
    'reason'?: string | null;
    'createdOn': string;
}


export interface RHIMMeasurementServiceApiV1ModelsMeasurementTriggerTaskDto {
    'wallPlots': boolean;
    'sectionCuts': boolean;
    'distances': boolean;
    'volume': boolean;
    'regions': boolean;
    'metadataUpdate': boolean;
    'wearRates': boolean;
}
export interface RHIMMeasurementServiceApiV1ModelsMeasurementViewDataDto {
    'regions': Array<RHIMMeasurementServiceApiV1ModelsPlotRegionDto>;
    'excludedRegions': Array<RHIMMeasurementServiceApiV1ModelsPlotRegionDto>;
    'brickSuppliersPerRegion': Array<RHIMMeasurementServiceApiV1ModelsRegionBrickSupplierDto>;
    'hasView3d': boolean;
    'hasViewPointCloud': boolean;
    'hasRbl': boolean;
    'hasWear': boolean;
    'hasWearRateBas': boolean;
    'hasWearRateInst': boolean;
    'hasWearRateEff': boolean;
    'hasWallPlot': boolean;
    'hasBottomPlot': boolean;
    'hasMetadata': boolean;
    'hasSectionCuts': boolean;
    'hasVolumes': boolean;
    'vesselId': string;
    'notes'?: string | null;
    'responsible'?: string | null;
    'measurementFiles': Array<RHIMMeasurementServiceApiV1ModelsMeasurementFileDto>;
    'id': string;
    'campaign': number;
    'heat': number;
    'measurementTaken': string;
    'vesselLining': string;
    'isHotMeasurement': boolean;
    'liningCondition': string;
    'isReferable': boolean;
    'liningMaintenanceType'?: string | null;
    'status': RHIMMeasurementServiceContractsDataMeasurementState;
    'measurementSystem'?: string | null;
}


export interface RHIMMeasurementServiceApiV1ModelsMeasurementViewDto {
    'hasView3d': boolean;
    'hasViewPointCloud': boolean;
    'hasRbl': boolean;
    'hasWear': boolean;
    'hasWearRateBas': boolean;
    'hasWearRateInst': boolean;
    'hasWearRateEff': boolean;
    'hasWallPlot': boolean;
    'hasBottomPlot': boolean;
    'hasMetadata': boolean;
    'hasSectionCuts': boolean;
    'hasVolumes': boolean;
    'vesselId': string;
    'notes'?: string | null;
    'responsible'?: string | null;
    'measurementFiles': Array<RHIMMeasurementServiceApiV1ModelsMeasurementFileDto>;
    'id': string;
    'campaign': number;
    'heat': number;
    'measurementTaken': string;
    'vesselLining': string;
    'isHotMeasurement': boolean;
    'liningCondition': string;
    'isReferable': boolean;
    'liningMaintenanceType'?: string | null;
    'status': RHIMMeasurementServiceContractsDataMeasurementState;
    'measurementSystem'?: string | null;
}


export interface RHIMMeasurementServiceApiV1ModelsMeasurementViewVesselDataDto {
    'vesselFunctionalProducts': Array<RHIMHMDCustomerManagementContractsV1VesselVesselFunctionalProductDto>;
    'colorscaleRbl': RHIMHMDCustomerManagementContractsV1VesselColorscaleDto;
    'colorscaleWear': RHIMHMDCustomerManagementContractsV1VesselColorscaleDto;
    'colorscaleWearRate': RHIMHMDCustomerManagementContractsV1VesselColorscaleDto;
    'regions': Array<RHIMMeasurementServiceApiV1ModelsPlotRegionDto>;
    'excludedRegions': Array<RHIMMeasurementServiceApiV1ModelsPlotRegionDto>;
    'orientationLabels': Array<RHIMHMDCustomerManagementContractsV1VesselOrientationLabelDto>;
}
export interface RHIMMeasurementServiceApiV1ModelsMeasurementsOfCampaignOverviewDto {
    'previousCampaignMeasurement'?: RHIMMeasurementServiceApiV1ModelsMeasurementOverviewStateDataDto | null;
    'shellLiningMeasurement'?: RHIMMeasurementServiceApiV1ModelsMeasurementOverviewStateDataDto | null;
    'permanentLiningMeasurement'?: RHIMMeasurementServiceApiV1ModelsMeasurementOverviewStateDataDto | null;
    'wearLiningInitialMeasurement'?: RHIMMeasurementServiceApiV1ModelsMeasurementOverviewStateDataDto | null;
    'wearLiningUsedMeasurement'?: RHIMMeasurementServiceApiV1ModelsMeasurementOverviewStateDataDto | null;
    'shellLiningCount': number;
    'permanentLiningCount': number;
    'wearLiningInitialCount': number;
    'wearLiningUsedCount': number;
    'recommendation': RHIMMeasurementServiceContractsDataVesselLiningAndCondition | null;
    'measurements': Array<RHIMMeasurementServiceApiV1ModelsMeasurementBaseDataDto>;
}


export interface RHIMMeasurementServiceApiV1ModelsPlotRegionDto {
    'id'?: string | null;
    'name': string;
    'displayName': string;
    'location': RHIMContractsRegionLocation;
    'coordinateSystem': RHIMContractsCoordinateSystem2D;
    'area': Array<RHIMContractsPoint2D>;
}


export interface RHIMMeasurementServiceApiV1ModelsPlotRegionValueDto {
    'regionName': string;
    'location': RHIMContractsRegionLocation;
    'rbl'?: RHIMMeasurementServiceContractsDataPlotValues | null;
    'wear'?: RHIMMeasurementServiceContractsDataPlotValues | null;
    'rblMinPoint'?: RHIMContractsPoint2D | null;
    'rblMaxPoint'?: RHIMContractsPoint2D | null;
    'wearMinPoint'?: RHIMContractsPoint2D | null;
    'wearMaxPoint'?: RHIMContractsPoint2D | null;
    'rblMinPoint3D'?: RHIMContractsPoint2D | null;
    'rblMaxPoint3D'?: RHIMContractsPoint2D | null;
    'wearMinPoint3D'?: RHIMContractsPoint2D | null;
    'wearMaxPoint3D'?: RHIMContractsPoint2D | null;
    'wearAfterRepair'?: RHIMMeasurementServiceContractsDataPlotValues | null;
    'minRbl'?: RHIMMeasurementServiceContractsDataPlotValues | null;
    'minRblHeat'?: number | null;
    'wearRateBas'?: RHIMMeasurementServiceContractsDataPlotValues | null;
    'wearRateInst'?: RHIMMeasurementServiceContractsDataPlotValues | null;
    'wearRateEff'?: RHIMMeasurementServiceContractsDataPlotValues | null;
    'wearAfterRepairMinPoint'?: RHIMContractsPoint2D | null;
    'wearAfterRepairMaxPoint'?: RHIMContractsPoint2D | null;
    'wearAfterRepairMinPoint3D'?: RHIMContractsPoint2D | null;
    'wearAfterRepairMaxPoint3D'?: RHIMContractsPoint2D | null;
    'coordinateSystem': RHIMContractsCoordinateSystem2D;
}


export interface RHIMMeasurementServiceApiV1ModelsPointCloudModificationsDto {
    'pointCloudFileId': string;
    'withRegistration': boolean;
    'transformationMatrix': Array<number>;
    'topDepth'?: number | null;
    'vesselLength'?: number | null;
    'bottomPosition'?: number | null;
    'bottomDistance'?: number | null;
    'snorkelIn'?: RHIMMeasurementServiceDataSnorkelPosition | null;
    'snorkelOut'?: RHIMMeasurementServiceDataSnorkelPosition | null;
}
export interface RHIMMeasurementServiceApiV1ModelsPointCloudRegisterDto {
    'pointCloudFileId': string;
    'referenceMeasurementId': string;
    'sourcePoints': Array<Array<number>>;
    'targetPoints': Array<Array<number>>;
}
export interface RHIMMeasurementServiceApiV1ModelsRegionBrickSupplierDto {
    'regionId': string;
    'regionName': string;
    'brickSuppliers': Array<string>;
}
export interface RHIMMeasurementServiceApiV1ModelsSectionCutsDto {
    'vessel'?: RHIMMeasurementServiceDataCylindricalSectionCuts | null;
    'vesselHotspots'?: RHIMMeasurementServiceDataCylindricalSectionCuts | null;
    'side0'?: RHIMMeasurementServiceDataCartesianSectionCuts | null;
    'side0Hotspots'?: RHIMMeasurementServiceDataCartesianSectionCuts | null;
    'side1'?: RHIMMeasurementServiceDataCartesianSectionCuts | null;
    'side1Hotspots'?: RHIMMeasurementServiceDataCartesianSectionCuts | null;
}
export interface RHIMMeasurementServiceApiV1ModelsUploadFileChunkDto {
    'chunkNumber': number;
    'chunkSize': number;
}
export interface RHIMMeasurementServiceApiV1ModelsUploadMeasurementFileDto {
    'fileName': string;
    'fileSize': number;
    'chunkSize': number;
    'fileCompression'?: string | null;
    'measurementId'?: string | null;
    'referenceMeasurementId'?: string | null;
    'processingHint'?: string | null;
    'measurementSystem': string;
    'campaign': number;
    'heat': number;
    'measurementTaken': string;
    'viewOnly': boolean;
    'vesselLining': string;
    'liningCondition': string;
    'liningMaintenanceType'?: string | null;
    'hotMeasurement': boolean;
    'notes'?: string | null;
    'responsible'?: string | null;
}
export interface RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto {
    'campaign': number;
    'heat': number;
    'measurementTaken': string;
    'viewOnly': boolean;
    'vesselLining': string;
    'liningCondition': string;
    'liningMaintenanceType'?: string | null;
    'hotMeasurement': boolean;
    'notes'?: string | null;
    'responsible'?: string | null;
}
export interface RHIMMeasurementServiceApiV1ModelsValidatePointCloudFileDto {
    'usePermanentLiningPreviousCampaign': boolean;
    'campaign': number;
    'heat': number;
    'measurementTaken': string;
    'viewOnly': boolean;
    'vesselLining': string;
    'liningCondition': string;
    'liningMaintenanceType'?: string | null;
    'hotMeasurement': boolean;
    'notes'?: string | null;
    'responsible'?: string | null;
}
export interface RHIMMeasurementServiceApiV1ModelsView3dSettingsDto {
    'wallplotStepSizeDepth': number;
    'wallplotStepSizeAngle': number;
    'wallplotStepSizeHeight': number;
    'wallplotStepSizeLength': number;
    'snorkelWallplotStepSizeDepth': number;
    'snorkelWallplotStepSizeAngle': number;
    'bottomplotStepSizeRadius': number;
    'bottomplotStepSizeAngle': number;
    'bottomplotStepSizeLength': number;
    'bottomplotStepSizeWidth': number;
    'bottomplotAngleStepSizePerRadius': { [key: string]: number; };
    'vesselBendParams': Array<RHIMMeasurementServiceDataVesselBendParameter>;
    'sectionCutsStepSizeDepth': number;
    'sectionCutsStepSizeAngle': number;
    'sectionCutsStepSizeLength': number;
    'reducedPointCloudFactor': number;
    'unitsFactor': number;
    'minimumCorrespondentPoints': number;
    'maximumCorrespondentPoints': number;
    'correspondentPointClusterRadius': number;
    'wallDistanceMin': number;
    'wallDistanceMax': number;
    'bottomPositionSelection': boolean;
    'volumeCalculation': boolean;
    'volumeStartDepth': number;
    'bottomDepth': number;
    'slaglineDepth': number;
    'ironlineDepth': number;
    'side0DisplayName': string;
    'side1DisplayName': string;
    'side2DisplayName': string;
    'side3DisplayName': string;
    'hotspotAreaHeight': number;
    'distancesNullThreshold': number;
    'negativeRblNullThreshold': number;
    'cutMeshAboveZeroHeight': boolean;
}
export interface RHIMMeasurementServiceApiV1ModelsView3dSettingsVesselDto {
    'wallplotStepSizeDepthDefault': number;
    'wallplotStepSizeAngleDefault': number;
    'wallplotStepSizeHeightDefault': number;
    'wallplotStepSizeLengthDefault': number;
    'snorkelWallplotStepSizeDepthDefault': number;
    'snorkelWallplotStepSizeAngleDefault': number;
    'bottomplotStepSizeRadiusDefault': number;
    'bottomplotStepSizeAngleDefault': number;
    'bottomplotStepSizeLengthDefault': number;
    'bottomplotStepSizeWidthDefault': number;
    'bottomplotAngleStepSizePerRadiusDefault': { [key: string]: number; };
    'vesselBendParamsDefault': Array<RHIMMeasurementServiceDataVesselBendParameter>;
    'sectionCutsStepSizeDepthDefault': number;
    'sectionCutsStepSizeAngleDefault': number;
    'sectionCutsStepSizeLengthDefault': number;
    'reducedPointCloudFactorDefault': number;
    'unitsFactorDefault': number;
    'minimumCorrespondentPointsDefault': number;
    'maximumCorrespondentPointsDefault': number;
    'correspondentPointClusterRadiusDefault': number;
    'wallDistanceMinDefault': number;
    'wallDistanceMaxDefault': number;
    'bottomPositionSelectionDefault': boolean;
    'volumeCalculationDefault': boolean;
    'volumeStartDepthDefault': number;
    'bottomDepthDefault': number;
    'slaglineDepthDefault': number;
    'ironlineDepthDefault': number;
    'side0DisplayNameDefault': string;
    'side1DisplayNameDefault': string;
    'side2DisplayNameDefault': string;
    'side3DisplayNameDefault': string;
    'hotspotAreaHeightDefault': number;
    'distancesNullThresholdDefault': number;
    'negativeRblNullThresholdDefault': number;
    'cutMeshAboveZeroHeightDefault': boolean;
    'wallplotStepSizeDepth'?: number | null;
    'wallplotStepSizeAngle'?: number | null;
    'wallplotStepSizeHeight'?: number | null;
    'wallplotStepSizeLength'?: number | null;
    'snorkelWallplotStepSizeDepth'?: number | null;
    'snorkelWallplotStepSizeAngle'?: number | null;
    'bottomplotStepSizeRadius'?: number | null;
    'bottomplotStepSizeAngle'?: number | null;
    'bottomplotStepSizeLength'?: number | null;
    'bottomplotStepSizeWidth'?: number | null;
    'bottomplotAngleStepSizePerRadius'?: { [key: string]: number | null; } | null;
    'vesselBendParams'?: Array<RHIMMeasurementServiceDataVesselBendParameter> | null;
    'sectionCutsStepSizeDepth'?: number | null;
    'sectionCutsStepSizeAngle'?: number | null;
    'sectionCutsStepSizeLength'?: number | null;
    'reducedPointCloudFactor'?: number | null;
    'unitsFactor'?: number | null;
    'minimumCorrespondentPoints'?: number | null;
    'maximumCorrespondentPoints'?: number | null;
    'correspondentPointClusterRadius'?: number | null;
    'wallDistanceMin'?: number | null;
    'wallDistanceMax'?: number | null;
    'bottomPositionSelection'?: boolean | null;
    'volumeCalculation'?: boolean | null;
    'volumeStartDepth'?: number | null;
    'bottomDepth'?: number | null;
    'slaglineDepth'?: number | null;
    'ironlineDepth'?: number | null;
    'side0DisplayName'?: string | null;
    'side1DisplayName'?: string | null;
    'side2DisplayName'?: string | null;
    'side3DisplayName'?: string | null;
    'hotspotAreaHeight'?: number | null;
    'distancesNullThreshold'?: number | null;
    'negativeRblNullThreshold'?: number | null;
    'cutMeshAboveZeroHeight'?: boolean | null;
}
export interface RHIMMeasurementServiceApiV1ModelsView3dSettingsVesselUpdateDto {
    'wallplotStepSizeDepth'?: number | null;
    'wallplotStepSizeAngle'?: number | null;
    'wallplotStepSizeHeight'?: number | null;
    'wallplotStepSizeLength'?: number | null;
    'snorkelWallplotStepSizeDepth'?: number | null;
    'snorkelWallplotStepSizeAngle'?: number | null;
    'bottomplotStepSizeRadius'?: number | null;
    'bottomplotStepSizeAngle'?: number | null;
    'bottomplotStepSizeLength'?: number | null;
    'bottomplotStepSizeWidth'?: number | null;
    'bottomplotAngleStepSizePerRadius'?: { [key: string]: number | null; } | null;
    'vesselBendParams'?: Array<RHIMMeasurementServiceDataVesselBendParameter> | null;
    'sectionCutsStepSizeDepth'?: number | null;
    'sectionCutsStepSizeAngle'?: number | null;
    'sectionCutsStepSizeLength'?: number | null;
    'reducedPointCloudFactor'?: number | null;
    'unitsFactor'?: number | null;
    'minimumCorrespondentPoints'?: number | null;
    'maximumCorrespondentPoints'?: number | null;
    'correspondentPointClusterRadius'?: number | null;
    'wallDistanceMin'?: number | null;
    'wallDistanceMax'?: number | null;
    'bottomPositionSelection'?: boolean | null;
    'volumeCalculation'?: boolean | null;
    'volumeStartDepth'?: number | null;
    'bottomDepth'?: number | null;
    'slaglineDepth'?: number | null;
    'ironlineDepth'?: number | null;
    'side0DisplayName'?: string | null;
    'side1DisplayName'?: string | null;
    'side2DisplayName'?: string | null;
    'side3DisplayName'?: string | null;
    'hotspotAreaHeight'?: number | null;
    'distancesNullThreshold'?: number | null;
    'negativeRblNullThreshold'?: number | null;
    'cutMeshAboveZeroHeight'?: boolean | null;
}
export interface RHIMMeasurementServiceApiV1ModelsVolumesPlotDto {
    'volumes': Array<RHIMMeasurementServiceDataVolumeValue>;
}
export interface RHIMMeasurementServiceApiV1ModelsWallPlotDto {
    'data'?: Array<RHIMMeasurementServiceDataCylindricalPlotData> | null;
    'dataSide0'?: Array<RHIMMeasurementServiceDataCartesianPlotData> | null;
    'dataSide1'?: Array<RHIMMeasurementServiceDataCartesianPlotData> | null;
    'metadata': RHIMMeasurementServiceDataWallPlotMetadata;
}

export const RHIMMeasurementServiceContractsDataInternalPlotRegionName = {
    RgWall: 'RG_WALL',
    RgVolume: 'RG_VOLUME',
    RgBottom: 'RG_BOTTOM',
    RgSlagline: 'RG_SLAGLINE',
    RgIronline: 'RG_IRONLINE',
    RgVessel: 'RG_VESSEL',
} as const;

export type RHIMMeasurementServiceContractsDataInternalPlotRegionName = typeof RHIMMeasurementServiceContractsDataInternalPlotRegionName[keyof typeof RHIMMeasurementServiceContractsDataInternalPlotRegionName];



export const RHIMMeasurementServiceContractsDataLiningCondition = {
    Initial: 'Initial',
    NormalUsed: 'NormalUsed',
    AfterRepair: 'AfterRepair',
} as const;

export type RHIMMeasurementServiceContractsDataLiningCondition = typeof RHIMMeasurementServiceContractsDataLiningCondition[keyof typeof RHIMMeasurementServiceContractsDataLiningCondition];



export const RHIMMeasurementServiceContractsDataLiningMaintenanceType = {
    BricksChanged: 'BricksChanged',
    Gunning: 'Gunning',
    Fettling: 'Fettling',
    SlagSplashing: 'SlagSplashing',
} as const;

export type RHIMMeasurementServiceContractsDataLiningMaintenanceType = typeof RHIMMeasurementServiceContractsDataLiningMaintenanceType[keyof typeof RHIMMeasurementServiceContractsDataLiningMaintenanceType];



export const RHIMMeasurementServiceContractsDataMeasurementFileType = {
    _3d: '3d',
    Stl: 'stl',
    Pcraw: 'pcraw',
    Pcaligned: 'pcaligned',
    Pcprerendered: 'pcprerendered',
    Pcreduced: 'pcreduced',
    Rbl: 'rbl',
    Wear: 'wear',
    Pctrans: 'pctrans',
    Pcfiltered: 'pcfiltered',
    Hrrbl: 'hrrbl',
    Hrwear: 'hrwear',
    Filteredrbl: 'filteredrbl',
    Filteredhrrbl: 'filteredhrrbl',
    Filteredwear: 'filteredwear',
    Filteredhrwear: 'filteredhrwear',
    Wallplot: 'wallplot',
    Bottomplot: 'bottomplot',
    Meta: 'meta',
    Statistics: 'statistics',
    Sectioncuts: 'sectioncuts',
    Distancesplot: 'distancesplot',
    Video: 'video',
    Image: 'image',
    Segmentation: 'segmentation',
    Hrsegmentation: 'hrsegmentation',
    Report: 'report',
    Lcsvertex: 'lcsvertex',
    Ferrotronv1pointdata: 'ferrotronv1pointdata',
    Ferrotronv2pointdata: 'ferrotronv2pointdata',
    Imsipointdata: 'imsipointdata',
    Latitudepointdata: 'latitudepointdata',
    Lcssummary: 'lcssummary',
    Volumes: 'volumes',
    Watertightmesh: 'watertightmesh',
    Regionvalues: 'regionvalues',
    Regions: 'regions',
    Leicacsv: 'leicacsv',
    Las: 'las',
    E57: 'e57',
    Potree: 'potree',
    Panorama: 'panorama',
    Ply: 'ply',
    Hypraw: 'hypraw',
    Wearrate: 'wearrate',
} as const;

export type RHIMMeasurementServiceContractsDataMeasurementFileType = typeof RHIMMeasurementServiceContractsDataMeasurementFileType[keyof typeof RHIMMeasurementServiceContractsDataMeasurementFileType];



export const RHIMMeasurementServiceContractsDataMeasurementProcessingHint = {
    None: 'None',
    Modify: 'Modify',
    Register: 'Register',
    Convert: 'Convert',
    Potree: 'Potree',
} as const;

export type RHIMMeasurementServiceContractsDataMeasurementProcessingHint = typeof RHIMMeasurementServiceContractsDataMeasurementProcessingHint[keyof typeof RHIMMeasurementServiceContractsDataMeasurementProcessingHint];



export const RHIMMeasurementServiceContractsDataMeasurementState = {
    Ingressing: 'Ingressing',
    Processing: 'Processing',
    Complete: 'Complete',
    PostProcessing: 'PostProcessing',
    Error: 'Error',
} as const;

export type RHIMMeasurementServiceContractsDataMeasurementState = typeof RHIMMeasurementServiceContractsDataMeasurementState[keyof typeof RHIMMeasurementServiceContractsDataMeasurementState];



export const RHIMMeasurementServiceContractsDataMeasurementSystems = {
    LeicaV1: 'LeicaV1',
    Lcsv1: 'LCSV1',
    FaroV1: 'FaroV1',
    FerrotronV1: 'FerrotronV1',
    FerrotronV2: 'FerrotronV2',
    HyperionV1: 'HyperionV1',
    Imsiv1: 'IMSIV1',
    LatitudeV1: 'LatitudeV1',
    Leica3drV1: 'Leica3drV1',
    ScaniverseV1: 'ScaniverseV1',
    HyperionRaw: 'HyperionRaw',
} as const;

export type RHIMMeasurementServiceContractsDataMeasurementSystems = typeof RHIMMeasurementServiceContractsDataMeasurementSystems[keyof typeof RHIMMeasurementServiceContractsDataMeasurementSystems];


export interface RHIMMeasurementServiceContractsDataPlotValues {
    'min': number;
    'max': number;
    'med': number;
    'avg': number;
    'cnt'?: number | null;
    'std'?: number | null;
}

export const RHIMMeasurementServiceContractsDataVesselLining = {
    Shell: 'Shell',
    ShellInsulation: 'ShellInsulation',
    PermanentLining: 'PermanentLining',
    WearLining: 'WearLining',
} as const;

export type RHIMMeasurementServiceContractsDataVesselLining = typeof RHIMMeasurementServiceContractsDataVesselLining[keyof typeof RHIMMeasurementServiceContractsDataVesselLining];



export const RHIMMeasurementServiceContractsDataVesselLiningAndCondition = {
    ShellLining: 'ShellLining',
    PermanentLining: 'PermanentLining',
    WearLiningInitial: 'WearLiningInitial',
    WearLiningUsed: 'WearLiningUsed',
} as const;

export type RHIMMeasurementServiceContractsDataVesselLiningAndCondition = typeof RHIMMeasurementServiceContractsDataVesselLiningAndCondition[keyof typeof RHIMMeasurementServiceContractsDataVesselLiningAndCondition];


export interface RHIMMeasurementServiceDataCartesianBottomPlot {
    'data': Array<RHIMMeasurementServiceDataCartesianBottomPlotData>;
    'metadata': RHIMMeasurementServiceDataCartesianBottomPlotMetadata;
}
export interface RHIMMeasurementServiceDataCartesianBottomPlotData {
    'length': number;
    'width': number;
    'rbl'?: RHIMMeasurementServiceContractsDataPlotValues | null;
    'wear'?: RHIMMeasurementServiceContractsDataPlotValues | null;
    'wearAfterRepair'?: RHIMMeasurementServiceContractsDataPlotValues | null;
    'minRbl'?: RHIMMeasurementServiceContractsDataPlotValues | null;
    'minRblHeat'?: number | null;
    'wearRateBas'?: RHIMMeasurementServiceContractsDataPlotValues | null;
    'wearRateInst'?: RHIMMeasurementServiceContractsDataPlotValues | null;
    'wearRateEff'?: RHIMMeasurementServiceContractsDataPlotValues | null;
}
export interface RHIMMeasurementServiceDataCartesianBottomPlotMetadata {
    'columns': number;
    'rows': number;
}
export interface RHIMMeasurementServiceDataCartesianPlotData {
    'length': number;
    'depth': number;
    'rbl'?: RHIMMeasurementServiceContractsDataPlotValues | null;
    'wear'?: RHIMMeasurementServiceContractsDataPlotValues | null;
    'wearAfterRepair'?: RHIMMeasurementServiceContractsDataPlotValues | null;
    'minRbl'?: RHIMMeasurementServiceContractsDataPlotValues | null;
    'minRblHeat'?: number | null;
    'wearRateBas'?: RHIMMeasurementServiceContractsDataPlotValues | null;
    'wearRateInst'?: RHIMMeasurementServiceContractsDataPlotValues | null;
    'wearRateEff'?: RHIMMeasurementServiceContractsDataPlotValues | null;
}
export interface RHIMMeasurementServiceDataCartesianSectionCuts {
    'data': { [key: string]: Array<RHIMMeasurementServiceDataCartesianSectionCutsPoint>; };
    'metadata': RHIMMeasurementServiceDataCartesianSectionCutsMetadata;
}
export interface RHIMMeasurementServiceDataCartesianSectionCutsMetadata {
    'lengthStep': number;
    'depthStep': number;
    'bottomDepth': number;
    'maxWidth': number;
    'maxDepth': number;
}
export interface RHIMMeasurementServiceDataCartesianSectionCutsPoint {
    'width'?: number | null;
    'depth'?: number | null;
    'rbl'?: RHIMMeasurementServiceContractsDataPlotValues | null;
    'wear'?: RHIMMeasurementServiceContractsDataPlotValues | null;
    'isBottom': boolean;
}
export interface RHIMMeasurementServiceDataCylindricalBottomPlotData {
    'angleStart': number;
    'angleEnd': number;
    'radiusStart': number;
    'radiusEnd': number;
    'rbl'?: RHIMMeasurementServiceContractsDataPlotValues | null;
    'wear'?: RHIMMeasurementServiceContractsDataPlotValues | null;
    'wearAfterRepair'?: RHIMMeasurementServiceContractsDataPlotValues | null;
    'minRbl'?: RHIMMeasurementServiceContractsDataPlotValues | null;
    'minRblHeat'?: number | null;
    'wearRateBas'?: RHIMMeasurementServiceContractsDataPlotValues | null;
    'wearRateInst'?: RHIMMeasurementServiceContractsDataPlotValues | null;
    'wearRateEff'?: RHIMMeasurementServiceContractsDataPlotValues | null;
}
export interface RHIMMeasurementServiceDataCylindricalBottomPlotMetadata {
    'maxRadius': number;
}
export interface RHIMMeasurementServiceDataCylindricalPlotData {
    'angle': number;
    'depth'?: number | null;
    'length'?: number | null;
    'rbl'?: RHIMMeasurementServiceContractsDataPlotValues | null;
    'wear'?: RHIMMeasurementServiceContractsDataPlotValues | null;
    'wearAfterRepair'?: RHIMMeasurementServiceContractsDataPlotValues | null;
    'minRbl'?: RHIMMeasurementServiceContractsDataPlotValues | null;
    'minRblHeat'?: number | null;
    'wearRateBas'?: RHIMMeasurementServiceContractsDataPlotValues | null;
    'wearRateInst'?: RHIMMeasurementServiceContractsDataPlotValues | null;
    'wearRateEff'?: RHIMMeasurementServiceContractsDataPlotValues | null;
}
export interface RHIMMeasurementServiceDataCylindricalSectionCuts {
    'data': { [key: string]: Array<RHIMMeasurementServiceDataCylindricalSectionCutsPoint>; };
    'metadata': RHIMMeasurementServiceDataCylindricalSectionCutsMetadata;
}
export interface RHIMMeasurementServiceDataCylindricalSectionCutsMetadata {
    'angleStep': number;
    'depthStep': number;
    'bottomDepth': number;
    'maxRadius': number;
    'maxDepth': number;
}
export interface RHIMMeasurementServiceDataCylindricalSectionCutsPoint {
    'radius'?: number | null;
    'depth'?: number | null;
    'rbl'?: RHIMMeasurementServiceContractsDataPlotValues | null;
    'wear'?: RHIMMeasurementServiceContractsDataPlotValues | null;
    'isBottom'?: boolean | null;
}

export const RHIMMeasurementServiceDataMeasurementPlotUnits = {
    M: 'm',
    Mm: 'mm',
    Degree: 'degree',
    Radian: 'radian',
} as const;

export type RHIMMeasurementServiceDataMeasurementPlotUnits = typeof RHIMMeasurementServiceDataMeasurementPlotUnits[keyof typeof RHIMMeasurementServiceDataMeasurementPlotUnits];


export interface RHIMMeasurementServiceDataSnorkelPosition {
    'x': number;
    'y': number;
    'r': number;
}

export const RHIMMeasurementServiceDataValidationError = {
    MeasurementInProgress: 'MeasurementInProgress',
    CampaignHeatTimestampMismatch: 'CampaignHeatTimestampMismatch',
    InvalidHeat: 'InvalidHeat',
    WlExists: 'WlExists',
    InvalidReferenceMeasurement: 'InvalidReferenceMeasurement',
    PtsFileContentInvalid: 'PtsFileContentInvalid',
    FilePartIncomplete: 'FilePartIncomplete',
    MeasurementInUse: 'MeasurementInUse',
    MissingSettings: 'MissingSettings',
    RetryAfterCancel: 'RetryAfterCancel',
    InvalidMeasurement: 'InvalidMeasurement',
} as const;

export type RHIMMeasurementServiceDataValidationError = typeof RHIMMeasurementServiceDataValidationError[keyof typeof RHIMMeasurementServiceDataValidationError];



export const RHIMMeasurementServiceDataValidationWarning = {
    ExistingPlDelete: 'ExistingPlDelete',
    ExistingWlDelete: 'ExistingWlDelete',
    ExistingMeasurementDelete: 'ExistingMeasurementDelete',
    IncompleteMeasurementDelete: 'IncompleteMeasurementDelete',
    NoRblCalculation: 'NoRblCalculation',
    PossiblyInaccurateWear: 'PossiblyInaccurateWear',
    PlPreviousCampaign: 'PlPreviousCampaign',
} as const;

export type RHIMMeasurementServiceDataValidationWarning = typeof RHIMMeasurementServiceDataValidationWarning[keyof typeof RHIMMeasurementServiceDataValidationWarning];


export interface RHIMMeasurementServiceDataVesselBendParameter {
    'depth': number;
    'radius': number;
}
export interface RHIMMeasurementServiceDataVolumeValue {
    'depth': number;
    'volume': number;
}
export interface RHIMMeasurementServiceDataWallPlot {
    'data'?: Array<RHIMMeasurementServiceDataCylindricalPlotData> | null;
    'dataSide0'?: Array<RHIMMeasurementServiceDataCartesianPlotData> | null;
    'dataSide1'?: Array<RHIMMeasurementServiceDataCartesianPlotData> | null;
    'metadata': RHIMMeasurementServiceDataWallPlotMetadata;
}
export interface RHIMMeasurementServiceDataWallPlotMetadata {
    'columns': number;
    'rows': number;
}
export interface RHIMMeasurementServiceWebV1ModelsMeasurementValidationErrorDto {
    'error': RHIMMeasurementServiceDataValidationError;
    'text': string;
    'details'?: string | null;
}


export interface RHIMMeasurementServiceWebV1ModelsMeasurementValidationWarningDto {
    'warning': RHIMMeasurementServiceDataValidationWarning;
    'text': string;
    'details'?: string | null;
}


export interface RHIMMeasurementServiceWebV1ModelsUploadMeasurementFileResponseDto {
    /**
     * The Id of the point cloud file if validation and upload succeeded, otherwise null.
     */
    'measurementFileId'?: string | null;
    /**
     * The Id of the measurement if validation and upload was successful, otherwise null
     */
    'measurementId'?: string | null;
    /**
     * The list of warnings.
     */
    'warnings': Array<RHIMMeasurementServiceWebV1ModelsMeasurementValidationWarningDto>;
    /**
     * The list of Errors.
     */
    'errors': Array<RHIMMeasurementServiceWebV1ModelsMeasurementValidationErrorDto>;
}
export interface RHIMMeasurementServiceWebV1ModelsValidateResponseDto {
    'referenceMeasurement'?: RHIMMeasurementServiceApiV1ModelsMeasurementDto | null;
    /**
     * The list of warnings.
     */
    'warnings': Array<RHIMMeasurementServiceWebV1ModelsMeasurementValidationWarningDto>;
    /**
     * The list of Errors.
     */
    'errors': Array<RHIMMeasurementServiceWebV1ModelsMeasurementValidationErrorDto>;
}

/**
 * CalculationsApi - axios parameter creator
 */
export const CalculationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Triggers the calculation of a transformation matrix.
         * @summary Triggers the calculation of a transformation matrix.
         * @param {string} vesselId The vessel Id for authorization
         * @param {RHIMMeasurementServiceApiV1ModelsCalculateTransformPointsDto} [rHIMMeasurementServiceApiV1ModelsCalculateTransformPointsDto] The source and target points and the transformation matrix (pointcloudmodifications)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCalculationsVesselidTransformpoints: async (vesselId: string, rHIMMeasurementServiceApiV1ModelsCalculateTransformPointsDto?: RHIMMeasurementServiceApiV1ModelsCalculateTransformPointsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('postCalculationsVesselidTransformpoints', 'vesselId', vesselId)
            const localVarPath = `/Calculations/{vesselId}/transformpoints`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMMeasurementServiceApiV1ModelsCalculateTransformPointsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CalculationsApi - functional programming interface
 */
export const CalculationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CalculationsApiAxiosParamCreator(configuration)
    return {
        /**
         * Triggers the calculation of a transformation matrix.
         * @summary Triggers the calculation of a transformation matrix.
         * @param {string} vesselId The vessel Id for authorization
         * @param {RHIMMeasurementServiceApiV1ModelsCalculateTransformPointsDto} [rHIMMeasurementServiceApiV1ModelsCalculateTransformPointsDto] The source and target points and the transformation matrix (pointcloudmodifications)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCalculationsVesselidTransformpoints(vesselId: string, rHIMMeasurementServiceApiV1ModelsCalculateTransformPointsDto?: RHIMMeasurementServiceApiV1ModelsCalculateTransformPointsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMMeasurementServiceApiV1ModelsCalculateTransformPointsResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCalculationsVesselidTransformpoints(vesselId, rHIMMeasurementServiceApiV1ModelsCalculateTransformPointsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalculationsApi.postCalculationsVesselidTransformpoints']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CalculationsApi - factory interface
 */
export const CalculationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CalculationsApiFp(configuration)
    return {
        /**
         * Triggers the calculation of a transformation matrix.
         * @summary Triggers the calculation of a transformation matrix.
         * @param {string} vesselId The vessel Id for authorization
         * @param {RHIMMeasurementServiceApiV1ModelsCalculateTransformPointsDto} [rHIMMeasurementServiceApiV1ModelsCalculateTransformPointsDto] The source and target points and the transformation matrix (pointcloudmodifications)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCalculationsVesselidTransformpoints(vesselId: string, rHIMMeasurementServiceApiV1ModelsCalculateTransformPointsDto?: RHIMMeasurementServiceApiV1ModelsCalculateTransformPointsDto, options?: RawAxiosRequestConfig): AxiosPromise<RHIMMeasurementServiceApiV1ModelsCalculateTransformPointsResultDto> {
            return localVarFp.postCalculationsVesselidTransformpoints(vesselId, rHIMMeasurementServiceApiV1ModelsCalculateTransformPointsDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CalculationsApi - object-oriented interface
 */
export class CalculationsApi extends BaseAPI {
    /**
     * Triggers the calculation of a transformation matrix.
     * @summary Triggers the calculation of a transformation matrix.
     * @param {string} vesselId The vessel Id for authorization
     * @param {RHIMMeasurementServiceApiV1ModelsCalculateTransformPointsDto} [rHIMMeasurementServiceApiV1ModelsCalculateTransformPointsDto] The source and target points and the transformation matrix (pointcloudmodifications)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postCalculationsVesselidTransformpoints(vesselId: string, rHIMMeasurementServiceApiV1ModelsCalculateTransformPointsDto?: RHIMMeasurementServiceApiV1ModelsCalculateTransformPointsDto, options?: RawAxiosRequestConfig) {
        return CalculationsApiFp(this.configuration).postCalculationsVesselidTransformpoints(vesselId, rHIMMeasurementServiceApiV1ModelsCalculateTransformPointsDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CampaignsApi - axios parameter creator
 */
export const CampaignsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary /Campaigns/{vesselId}/{campaign}/overview - GET
         * @param {string} vesselId 
         * @param {number} campaign 
         * @param {boolean} [viewOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignsVesselidCampaignOverview: async (vesselId: string, campaign: number, viewOnly?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getCampaignsVesselidCampaignOverview', 'vesselId', vesselId)
            // verify required parameter 'campaign' is not null or undefined
            assertParamExists('getCampaignsVesselidCampaignOverview', 'campaign', campaign)
            const localVarPath = `/Campaigns/{vesselId}/{campaign}/overview`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)))
                .replace('{campaign}', encodeURIComponent(String(campaign)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (viewOnly !== undefined) {
                localVarQueryParameter['viewOnly'] = viewOnly;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CampaignsApi - functional programming interface
 */
export const CampaignsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CampaignsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary /Campaigns/{vesselId}/{campaign}/overview - GET
         * @param {string} vesselId 
         * @param {number} campaign 
         * @param {boolean} [viewOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCampaignsVesselidCampaignOverview(vesselId: string, campaign: number, viewOnly?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMMeasurementServiceApiV1ModelsMeasurementsOfCampaignOverviewDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCampaignsVesselidCampaignOverview(vesselId, campaign, viewOnly, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignsApi.getCampaignsVesselidCampaignOverview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CampaignsApi - factory interface
 */
export const CampaignsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CampaignsApiFp(configuration)
    return {
        /**
         * 
         * @summary /Campaigns/{vesselId}/{campaign}/overview - GET
         * @param {string} vesselId 
         * @param {number} campaign 
         * @param {boolean} [viewOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignsVesselidCampaignOverview(vesselId: string, campaign: number, viewOnly?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<RHIMMeasurementServiceApiV1ModelsMeasurementsOfCampaignOverviewDto> {
            return localVarFp.getCampaignsVesselidCampaignOverview(vesselId, campaign, viewOnly, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CampaignsApi - object-oriented interface
 */
export class CampaignsApi extends BaseAPI {
    /**
     * 
     * @summary /Campaigns/{vesselId}/{campaign}/overview - GET
     * @param {string} vesselId 
     * @param {number} campaign 
     * @param {boolean} [viewOnly] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCampaignsVesselidCampaignOverview(vesselId: string, campaign: number, viewOnly?: boolean, options?: RawAxiosRequestConfig) {
        return CampaignsApiFp(this.configuration).getCampaignsVesselidCampaignOverview(vesselId, campaign, viewOnly, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DefaultApi - axios parameter creator
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Load MeasurementFile bits by path-name
         * @summary Load MeasurementFile bits by path-name
         * @param {string} measurementId the id of the measurement
         * @param {string} path the name and path of the file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementfileBitsByName: async (measurementId: string, path: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'measurementId' is not null or undefined
            assertParamExists('getMeasurementfileBitsByName', 'measurementId', measurementId)
            // verify required parameter 'path' is not null or undefined
            assertParamExists('getMeasurementfileBitsByName', 'path', path)
            const localVarPath = `/measurementfiles/bits/{measurementId}/{*path}`
                .replace('{measurementId}', encodeURIComponent(String(measurementId)))
                .replace('{*path}', encodeURIComponent(String(path)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * Load MeasurementFile bits by path-name
         * @summary Load MeasurementFile bits by path-name
         * @param {string} measurementId the id of the measurement
         * @param {string} path the name and path of the file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeasurementfileBitsByName(measurementId: string, path: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeasurementfileBitsByName(measurementId, path, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getMeasurementfileBitsByName']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DefaultApi - factory interface
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * Load MeasurementFile bits by path-name
         * @summary Load MeasurementFile bits by path-name
         * @param {string} measurementId the id of the measurement
         * @param {string} path the name and path of the file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementfileBitsByName(measurementId: string, path: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getMeasurementfileBitsByName(measurementId, path, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 */
export class DefaultApi extends BaseAPI {
    /**
     * Load MeasurementFile bits by path-name
     * @summary Load MeasurementFile bits by path-name
     * @param {string} measurementId the id of the measurement
     * @param {string} path the name and path of the file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMeasurementfileBitsByName(measurementId: string, path: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getMeasurementfileBitsByName(measurementId, path, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GunningEventApi - axios parameter creator
 */
export const GunningEventApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary /GunningEvent/{vesselId}/Add - PUT
         * @param {string} vesselId 
         * @param {RHIMMeasurementServiceApiV1ModelsGunningEventMaterialDataDto} [rHIMMeasurementServiceApiV1ModelsGunningEventMaterialDataDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putGunningeventVesselidAdd: async (vesselId: string, rHIMMeasurementServiceApiV1ModelsGunningEventMaterialDataDto?: RHIMMeasurementServiceApiV1ModelsGunningEventMaterialDataDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('putGunningeventVesselidAdd', 'vesselId', vesselId)
            const localVarPath = `/GunningEvent/{vesselId}/Add`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMMeasurementServiceApiV1ModelsGunningEventMaterialDataDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GunningEventApi - functional programming interface
 */
export const GunningEventApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GunningEventApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary /GunningEvent/{vesselId}/Add - PUT
         * @param {string} vesselId 
         * @param {RHIMMeasurementServiceApiV1ModelsGunningEventMaterialDataDto} [rHIMMeasurementServiceApiV1ModelsGunningEventMaterialDataDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putGunningeventVesselidAdd(vesselId: string, rHIMMeasurementServiceApiV1ModelsGunningEventMaterialDataDto?: RHIMMeasurementServiceApiV1ModelsGunningEventMaterialDataDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putGunningeventVesselidAdd(vesselId, rHIMMeasurementServiceApiV1ModelsGunningEventMaterialDataDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GunningEventApi.putGunningeventVesselidAdd']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GunningEventApi - factory interface
 */
export const GunningEventApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GunningEventApiFp(configuration)
    return {
        /**
         * 
         * @summary /GunningEvent/{vesselId}/Add - PUT
         * @param {string} vesselId 
         * @param {RHIMMeasurementServiceApiV1ModelsGunningEventMaterialDataDto} [rHIMMeasurementServiceApiV1ModelsGunningEventMaterialDataDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putGunningeventVesselidAdd(vesselId: string, rHIMMeasurementServiceApiV1ModelsGunningEventMaterialDataDto?: RHIMMeasurementServiceApiV1ModelsGunningEventMaterialDataDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putGunningeventVesselidAdd(vesselId, rHIMMeasurementServiceApiV1ModelsGunningEventMaterialDataDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GunningEventApi - object-oriented interface
 */
export class GunningEventApi extends BaseAPI {
    /**
     * 
     * @summary /GunningEvent/{vesselId}/Add - PUT
     * @param {string} vesselId 
     * @param {RHIMMeasurementServiceApiV1ModelsGunningEventMaterialDataDto} [rHIMMeasurementServiceApiV1ModelsGunningEventMaterialDataDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public putGunningeventVesselidAdd(vesselId: string, rHIMMeasurementServiceApiV1ModelsGunningEventMaterialDataDto?: RHIMMeasurementServiceApiV1ModelsGunningEventMaterialDataDto, options?: RawAxiosRequestConfig) {
        return GunningEventApiFp(this.configuration).putGunningeventVesselidAdd(vesselId, rHIMMeasurementServiceApiV1ModelsGunningEventMaterialDataDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GunningEventsApi - axios parameter creator
 */
export const GunningEventsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary /GunningEvents/{vesselId}/ByCampaign/{campaign} - GET
         * @param {string} vesselId 
         * @param {number} campaign 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGunningeventsVesselidBycampaignCampaign: async (vesselId: string, campaign: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getGunningeventsVesselidBycampaignCampaign', 'vesselId', vesselId)
            // verify required parameter 'campaign' is not null or undefined
            assertParamExists('getGunningeventsVesselidBycampaignCampaign', 'campaign', campaign)
            const localVarPath = `/GunningEvents/{vesselId}/ByCampaign/{campaign}`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)))
                .replace('{campaign}', encodeURIComponent(String(campaign)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GunningEventsApi - functional programming interface
 */
export const GunningEventsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GunningEventsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary /GunningEvents/{vesselId}/ByCampaign/{campaign} - GET
         * @param {string} vesselId 
         * @param {number} campaign 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGunningeventsVesselidBycampaignCampaign(vesselId: string, campaign: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMMeasurementServiceApiV1ModelsGunningEventDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGunningeventsVesselidBycampaignCampaign(vesselId, campaign, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GunningEventsApi.getGunningeventsVesselidBycampaignCampaign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GunningEventsApi - factory interface
 */
export const GunningEventsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GunningEventsApiFp(configuration)
    return {
        /**
         * 
         * @summary /GunningEvents/{vesselId}/ByCampaign/{campaign} - GET
         * @param {string} vesselId 
         * @param {number} campaign 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGunningeventsVesselidBycampaignCampaign(vesselId: string, campaign: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMMeasurementServiceApiV1ModelsGunningEventDto>> {
            return localVarFp.getGunningeventsVesselidBycampaignCampaign(vesselId, campaign, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GunningEventsApi - object-oriented interface
 */
export class GunningEventsApi extends BaseAPI {
    /**
     * 
     * @summary /GunningEvents/{vesselId}/ByCampaign/{campaign} - GET
     * @param {string} vesselId 
     * @param {number} campaign 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getGunningeventsVesselidBycampaignCampaign(vesselId: string, campaign: number, options?: RawAxiosRequestConfig) {
        return GunningEventsApiFp(this.configuration).getGunningeventsVesselidBycampaignCampaign(vesselId, campaign, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GunningMaterialApi - axios parameter creator
 */
export const GunningMaterialApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary /GunningMaterial - GET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGunningmaterial: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/GunningMaterial`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /GunningMaterial/{vesselId}/lookups - GET
         * @param {string} vesselId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGunningmaterialVesselidLookups: async (vesselId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getGunningmaterialVesselidLookups', 'vesselId', vesselId)
            const localVarPath = `/GunningMaterial/{vesselId}/lookups`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GunningMaterialApi - functional programming interface
 */
export const GunningMaterialApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GunningMaterialApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary /GunningMaterial - GET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGunningmaterial(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMMeasurementServiceApiV1ModelsMaterialDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGunningmaterial(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GunningMaterialApi.getGunningmaterial']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /GunningMaterial/{vesselId}/lookups - GET
         * @param {string} vesselId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGunningmaterialVesselidLookups(vesselId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMMeasurementServiceApiV1ModelsGunningMaterialLookupDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGunningmaterialVesselidLookups(vesselId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GunningMaterialApi.getGunningmaterialVesselidLookups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GunningMaterialApi - factory interface
 */
export const GunningMaterialApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GunningMaterialApiFp(configuration)
    return {
        /**
         * 
         * @summary /GunningMaterial - GET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGunningmaterial(options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMMeasurementServiceApiV1ModelsMaterialDto>> {
            return localVarFp.getGunningmaterial(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /GunningMaterial/{vesselId}/lookups - GET
         * @param {string} vesselId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGunningmaterialVesselidLookups(vesselId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMMeasurementServiceApiV1ModelsGunningMaterialLookupDto>> {
            return localVarFp.getGunningmaterialVesselidLookups(vesselId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GunningMaterialApi - object-oriented interface
 */
export class GunningMaterialApi extends BaseAPI {
    /**
     * 
     * @summary /GunningMaterial - GET
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getGunningmaterial(options?: RawAxiosRequestConfig) {
        return GunningMaterialApiFp(this.configuration).getGunningmaterial(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /GunningMaterial/{vesselId}/lookups - GET
     * @param {string} vesselId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getGunningmaterialVesselidLookups(vesselId: string, options?: RawAxiosRequestConfig) {
        return GunningMaterialApiFp(this.configuration).getGunningmaterialVesselidLookups(vesselId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MeasurementApi - axios parameter creator
 */
export const MeasurementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary /Measurement/latest/{vesselId} - GET
         * @param {string} vesselId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementLatestVesselid: async (vesselId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getMeasurementLatestVesselid', 'vesselId', vesselId)
            const localVarPath = `/Measurement/latest/{vesselId}`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /Measurement/{measurementId} - GET
         * @param {string} measurementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementMeasurementid: async (measurementId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'measurementId' is not null or undefined
            assertParamExists('getMeasurementMeasurementid', 'measurementId', measurementId)
            const localVarPath = `/Measurement/{measurementId}`
                .replace('{measurementId}', encodeURIComponent(String(measurementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /Measurement/{measurementId}/state - GET
         * @param {string} measurementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementMeasurementidState: async (measurementId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'measurementId' is not null or undefined
            assertParamExists('getMeasurementMeasurementidState', 'measurementId', measurementId)
            const localVarPath = `/Measurement/{measurementId}/state`
                .replace('{measurementId}', encodeURIComponent(String(measurementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MeasurementApi - functional programming interface
 */
export const MeasurementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MeasurementApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary /Measurement/latest/{vesselId} - GET
         * @param {string} vesselId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeasurementLatestVesselid(vesselId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMMeasurementServiceApiV1ModelsMeasurementDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeasurementLatestVesselid(vesselId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementApi.getMeasurementLatestVesselid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /Measurement/{measurementId} - GET
         * @param {string} measurementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeasurementMeasurementid(measurementId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMMeasurementServiceApiV1ModelsMeasurementDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeasurementMeasurementid(measurementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementApi.getMeasurementMeasurementid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /Measurement/{measurementId}/state - GET
         * @param {string} measurementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeasurementMeasurementidState(measurementId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMMeasurementServiceApiV1ModelsMeasurementStatusDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeasurementMeasurementidState(measurementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementApi.getMeasurementMeasurementidState']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MeasurementApi - factory interface
 */
export const MeasurementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MeasurementApiFp(configuration)
    return {
        /**
         * 
         * @summary /Measurement/latest/{vesselId} - GET
         * @param {string} vesselId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementLatestVesselid(vesselId: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMMeasurementServiceApiV1ModelsMeasurementDto> {
            return localVarFp.getMeasurementLatestVesselid(vesselId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /Measurement/{measurementId} - GET
         * @param {string} measurementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementMeasurementid(measurementId: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMMeasurementServiceApiV1ModelsMeasurementDto> {
            return localVarFp.getMeasurementMeasurementid(measurementId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /Measurement/{measurementId}/state - GET
         * @param {string} measurementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementMeasurementidState(measurementId: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMMeasurementServiceApiV1ModelsMeasurementStatusDto> {
            return localVarFp.getMeasurementMeasurementidState(measurementId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MeasurementApi - object-oriented interface
 */
export class MeasurementApi extends BaseAPI {
    /**
     * 
     * @summary /Measurement/latest/{vesselId} - GET
     * @param {string} vesselId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMeasurementLatestVesselid(vesselId: string, options?: RawAxiosRequestConfig) {
        return MeasurementApiFp(this.configuration).getMeasurementLatestVesselid(vesselId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /Measurement/{measurementId} - GET
     * @param {string} measurementId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMeasurementMeasurementid(measurementId: string, options?: RawAxiosRequestConfig) {
        return MeasurementApiFp(this.configuration).getMeasurementMeasurementid(measurementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /Measurement/{measurementId}/state - GET
     * @param {string} measurementId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMeasurementMeasurementidState(measurementId: string, options?: RawAxiosRequestConfig) {
        return MeasurementApiFp(this.configuration).getMeasurementMeasurementidState(measurementId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MeasurementExportApi - axios parameter creator
 */
export const MeasurementExportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary /MeasurementExport/debug/{measurementId} - GET
         * @param {string} measurementId 
         * @param {boolean} [refInclude] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementexportDebugMeasurementid: async (measurementId: string, refInclude?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'measurementId' is not null or undefined
            assertParamExists('getMeasurementexportDebugMeasurementid', 'measurementId', measurementId)
            const localVarPath = `/MeasurementExport/debug/{measurementId}`
                .replace('{measurementId}', encodeURIComponent(String(measurementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (refInclude !== undefined) {
                localVarQueryParameter['refInclude'] = refInclude;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /MeasurementExport/files/{measurementId} - GET
         * @param {string} measurementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementexportFilesMeasurementid: async (measurementId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'measurementId' is not null or undefined
            assertParamExists('getMeasurementexportFilesMeasurementid', 'measurementId', measurementId)
            const localVarPath = `/MeasurementExport/files/{measurementId}`
                .replace('{measurementId}', encodeURIComponent(String(measurementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /MeasurementExport/pcraw/{measurementId} - GET
         * @param {string} measurementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementexportPcrawMeasurementid: async (measurementId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'measurementId' is not null or undefined
            assertParamExists('getMeasurementexportPcrawMeasurementid', 'measurementId', measurementId)
            const localVarPath = `/MeasurementExport/pcraw/{measurementId}`
                .replace('{measurementId}', encodeURIComponent(String(measurementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MeasurementExportApi - functional programming interface
 */
export const MeasurementExportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MeasurementExportApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary /MeasurementExport/debug/{measurementId} - GET
         * @param {string} measurementId 
         * @param {boolean} [refInclude] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeasurementexportDebugMeasurementid(measurementId: string, refInclude?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeasurementexportDebugMeasurementid(measurementId, refInclude, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementExportApi.getMeasurementexportDebugMeasurementid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /MeasurementExport/files/{measurementId} - GET
         * @param {string} measurementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeasurementexportFilesMeasurementid(measurementId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeasurementexportFilesMeasurementid(measurementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementExportApi.getMeasurementexportFilesMeasurementid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /MeasurementExport/pcraw/{measurementId} - GET
         * @param {string} measurementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeasurementexportPcrawMeasurementid(measurementId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeasurementexportPcrawMeasurementid(measurementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementExportApi.getMeasurementexportPcrawMeasurementid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MeasurementExportApi - factory interface
 */
export const MeasurementExportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MeasurementExportApiFp(configuration)
    return {
        /**
         * 
         * @summary /MeasurementExport/debug/{measurementId} - GET
         * @param {string} measurementId 
         * @param {boolean} [refInclude] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementexportDebugMeasurementid(measurementId: string, refInclude?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getMeasurementexportDebugMeasurementid(measurementId, refInclude, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /MeasurementExport/files/{measurementId} - GET
         * @param {string} measurementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementexportFilesMeasurementid(measurementId: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getMeasurementexportFilesMeasurementid(measurementId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /MeasurementExport/pcraw/{measurementId} - GET
         * @param {string} measurementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementexportPcrawMeasurementid(measurementId: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getMeasurementexportPcrawMeasurementid(measurementId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MeasurementExportApi - object-oriented interface
 */
export class MeasurementExportApi extends BaseAPI {
    /**
     * 
     * @summary /MeasurementExport/debug/{measurementId} - GET
     * @param {string} measurementId 
     * @param {boolean} [refInclude] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMeasurementexportDebugMeasurementid(measurementId: string, refInclude?: boolean, options?: RawAxiosRequestConfig) {
        return MeasurementExportApiFp(this.configuration).getMeasurementexportDebugMeasurementid(measurementId, refInclude, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /MeasurementExport/files/{measurementId} - GET
     * @param {string} measurementId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMeasurementexportFilesMeasurementid(measurementId: string, options?: RawAxiosRequestConfig) {
        return MeasurementExportApiFp(this.configuration).getMeasurementexportFilesMeasurementid(measurementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /MeasurementExport/pcraw/{measurementId} - GET
     * @param {string} measurementId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMeasurementexportPcrawMeasurementid(measurementId: string, options?: RawAxiosRequestConfig) {
        return MeasurementExportApiFp(this.configuration).getMeasurementexportPcrawMeasurementid(measurementId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MeasurementFilesApi - axios parameter creator
 */
export const MeasurementFilesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary /MeasurementFiles/{measurementFileId} - GET
         * @param {string} measurementFileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementfilesMeasurementfileid: async (measurementFileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'measurementFileId' is not null or undefined
            assertParamExists('getMeasurementfilesMeasurementfileid', 'measurementFileId', measurementFileId)
            const localVarPath = `/MeasurementFiles/{measurementFileId}`
                .replace('{measurementFileId}', encodeURIComponent(String(measurementFileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /MeasurementFiles/metadata/{measurementFileId} - GET
         * @param {string} measurementFileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementfilesMetadataMeasurementfileid: async (measurementFileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'measurementFileId' is not null or undefined
            assertParamExists('getMeasurementfilesMetadataMeasurementfileid', 'measurementFileId', measurementFileId)
            const localVarPath = `/MeasurementFiles/metadata/{measurementFileId}`
                .replace('{measurementFileId}', encodeURIComponent(String(measurementFileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /MeasurementFiles/regionvalues/{measurementFileId} - GET
         * @param {string} measurementFileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementfilesRegionvaluesMeasurementfileid: async (measurementFileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'measurementFileId' is not null or undefined
            assertParamExists('getMeasurementfilesRegionvaluesMeasurementfileid', 'measurementFileId', measurementFileId)
            const localVarPath = `/MeasurementFiles/regionvalues/{measurementFileId}`
                .replace('{measurementFileId}', encodeURIComponent(String(measurementFileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /MeasurementFiles/volumes/{measurementFileId} - GET
         * @param {string} measurementFileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementfilesVolumesMeasurementfileid: async (measurementFileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'measurementFileId' is not null or undefined
            assertParamExists('getMeasurementfilesVolumesMeasurementfileid', 'measurementFileId', measurementFileId)
            const localVarPath = `/MeasurementFiles/volumes/{measurementFileId}`
                .replace('{measurementFileId}', encodeURIComponent(String(measurementFileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MeasurementFilesApi - functional programming interface
 */
export const MeasurementFilesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MeasurementFilesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary /MeasurementFiles/{measurementFileId} - GET
         * @param {string} measurementFileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeasurementfilesMeasurementfileid(measurementFileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeasurementfilesMeasurementfileid(measurementFileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementFilesApi.getMeasurementfilesMeasurementfileid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /MeasurementFiles/metadata/{measurementFileId} - GET
         * @param {string} measurementFileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeasurementfilesMetadataMeasurementfileid(measurementFileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMMeasurementServiceApiV1ModelsMeasurementMetadataDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeasurementfilesMetadataMeasurementfileid(measurementFileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementFilesApi.getMeasurementfilesMetadataMeasurementfileid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /MeasurementFiles/regionvalues/{measurementFileId} - GET
         * @param {string} measurementFileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeasurementfilesRegionvaluesMeasurementfileid(measurementFileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMMeasurementServiceApiV1ModelsPlotRegionValueDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeasurementfilesRegionvaluesMeasurementfileid(measurementFileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementFilesApi.getMeasurementfilesRegionvaluesMeasurementfileid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /MeasurementFiles/volumes/{measurementFileId} - GET
         * @param {string} measurementFileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeasurementfilesVolumesMeasurementfileid(measurementFileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMMeasurementServiceApiV1ModelsVolumesPlotDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeasurementfilesVolumesMeasurementfileid(measurementFileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementFilesApi.getMeasurementfilesVolumesMeasurementfileid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MeasurementFilesApi - factory interface
 */
export const MeasurementFilesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MeasurementFilesApiFp(configuration)
    return {
        /**
         * 
         * @summary /MeasurementFiles/{measurementFileId} - GET
         * @param {string} measurementFileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementfilesMeasurementfileid(measurementFileId: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getMeasurementfilesMeasurementfileid(measurementFileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /MeasurementFiles/metadata/{measurementFileId} - GET
         * @param {string} measurementFileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementfilesMetadataMeasurementfileid(measurementFileId: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMMeasurementServiceApiV1ModelsMeasurementMetadataDto> {
            return localVarFp.getMeasurementfilesMetadataMeasurementfileid(measurementFileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /MeasurementFiles/regionvalues/{measurementFileId} - GET
         * @param {string} measurementFileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementfilesRegionvaluesMeasurementfileid(measurementFileId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMMeasurementServiceApiV1ModelsPlotRegionValueDto>> {
            return localVarFp.getMeasurementfilesRegionvaluesMeasurementfileid(measurementFileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /MeasurementFiles/volumes/{measurementFileId} - GET
         * @param {string} measurementFileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementfilesVolumesMeasurementfileid(measurementFileId: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMMeasurementServiceApiV1ModelsVolumesPlotDto> {
            return localVarFp.getMeasurementfilesVolumesMeasurementfileid(measurementFileId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MeasurementFilesApi - object-oriented interface
 */
export class MeasurementFilesApi extends BaseAPI {
    /**
     * 
     * @summary /MeasurementFiles/{measurementFileId} - GET
     * @param {string} measurementFileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMeasurementfilesMeasurementfileid(measurementFileId: string, options?: RawAxiosRequestConfig) {
        return MeasurementFilesApiFp(this.configuration).getMeasurementfilesMeasurementfileid(measurementFileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /MeasurementFiles/metadata/{measurementFileId} - GET
     * @param {string} measurementFileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMeasurementfilesMetadataMeasurementfileid(measurementFileId: string, options?: RawAxiosRequestConfig) {
        return MeasurementFilesApiFp(this.configuration).getMeasurementfilesMetadataMeasurementfileid(measurementFileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /MeasurementFiles/regionvalues/{measurementFileId} - GET
     * @param {string} measurementFileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMeasurementfilesRegionvaluesMeasurementfileid(measurementFileId: string, options?: RawAxiosRequestConfig) {
        return MeasurementFilesApiFp(this.configuration).getMeasurementfilesRegionvaluesMeasurementfileid(measurementFileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /MeasurementFiles/volumes/{measurementFileId} - GET
     * @param {string} measurementFileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMeasurementfilesVolumesMeasurementfileid(measurementFileId: string, options?: RawAxiosRequestConfig) {
        return MeasurementFilesApiFp(this.configuration).getMeasurementfilesVolumesMeasurementfileid(measurementFileId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MeasurementMaintenanceApi - axios parameter creator
 */
export const MeasurementMaintenanceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary /MeasurementMaintenance/delete/{measurementId} - DELETE
         * @param {string} measurementId 
         * @param {RHIMMeasurementServiceApiV1ModelsMaintenanceRequestDto} [rHIMMeasurementServiceApiV1ModelsMaintenanceRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMeasurementmaintenanceDeleteMeasurementid: async (measurementId: string, rHIMMeasurementServiceApiV1ModelsMaintenanceRequestDto?: RHIMMeasurementServiceApiV1ModelsMaintenanceRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'measurementId' is not null or undefined
            assertParamExists('deleteMeasurementmaintenanceDeleteMeasurementid', 'measurementId', measurementId)
            const localVarPath = `/MeasurementMaintenance/delete/{measurementId}`
                .replace('{measurementId}', encodeURIComponent(String(measurementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMMeasurementServiceApiV1ModelsMaintenanceRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /MeasurementMaintenance/delete/{vesselId}/{campaign} - DELETE
         * @param {string} vesselId 
         * @param {number} campaign 
         * @param {RHIMMeasurementServiceApiV1ModelsMaintenanceRequestDto} [rHIMMeasurementServiceApiV1ModelsMaintenanceRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMeasurementmaintenanceDeleteVesselidCampaign: async (vesselId: string, campaign: number, rHIMMeasurementServiceApiV1ModelsMaintenanceRequestDto?: RHIMMeasurementServiceApiV1ModelsMaintenanceRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('deleteMeasurementmaintenanceDeleteVesselidCampaign', 'vesselId', vesselId)
            // verify required parameter 'campaign' is not null or undefined
            assertParamExists('deleteMeasurementmaintenanceDeleteVesselidCampaign', 'campaign', campaign)
            const localVarPath = `/MeasurementMaintenance/delete/{vesselId}/{campaign}`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)))
                .replace('{campaign}', encodeURIComponent(String(campaign)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMMeasurementServiceApiV1ModelsMaintenanceRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /MeasurementMaintenance/cancel/{measurementId} - POST
         * @param {string} measurementId 
         * @param {RHIMMeasurementServiceApiV1ModelsMaintenanceRequestDto} [rHIMMeasurementServiceApiV1ModelsMaintenanceRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMeasurementmaintenanceCancelMeasurementid: async (measurementId: string, rHIMMeasurementServiceApiV1ModelsMaintenanceRequestDto?: RHIMMeasurementServiceApiV1ModelsMaintenanceRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'measurementId' is not null or undefined
            assertParamExists('postMeasurementmaintenanceCancelMeasurementid', 'measurementId', measurementId)
            const localVarPath = `/MeasurementMaintenance/cancel/{measurementId}`
                .replace('{measurementId}', encodeURIComponent(String(measurementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMMeasurementServiceApiV1ModelsMaintenanceRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /MeasurementMaintenance/clearrbl/{measurementId} - POST
         * @param {string} measurementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMeasurementmaintenanceClearrblMeasurementid: async (measurementId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'measurementId' is not null or undefined
            assertParamExists('postMeasurementmaintenanceClearrblMeasurementid', 'measurementId', measurementId)
            const localVarPath = `/MeasurementMaintenance/clearrbl/{measurementId}`
                .replace('{measurementId}', encodeURIComponent(String(measurementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /MeasurementMaintenance/recalculate-campaign/{vesselId} - POST
         * @param {string} vesselId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMeasurementmaintenanceRecalculateCampaignVesselid: async (vesselId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('postMeasurementmaintenanceRecalculateCampaignVesselid', 'vesselId', vesselId)
            const localVarPath = `/MeasurementMaintenance/recalculate-campaign/{vesselId}`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /MeasurementMaintenance/recalculate-campaign/{vesselId}/{campaign} - POST
         * @param {string} vesselId 
         * @param {number} campaign 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMeasurementmaintenanceRecalculateCampaignVesselidCampaign: async (vesselId: string, campaign: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('postMeasurementmaintenanceRecalculateCampaignVesselidCampaign', 'vesselId', vesselId)
            // verify required parameter 'campaign' is not null or undefined
            assertParamExists('postMeasurementmaintenanceRecalculateCampaignVesselidCampaign', 'campaign', campaign)
            const localVarPath = `/MeasurementMaintenance/recalculate-campaign/{vesselId}/{campaign}`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)))
                .replace('{campaign}', encodeURIComponent(String(campaign)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /MeasurementMaintenance/recalculate/{measurementId} - POST
         * @param {string} measurementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMeasurementmaintenanceRecalculateMeasurementid: async (measurementId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'measurementId' is not null or undefined
            assertParamExists('postMeasurementmaintenanceRecalculateMeasurementid', 'measurementId', measurementId)
            const localVarPath = `/MeasurementMaintenance/recalculate/{measurementId}`
                .replace('{measurementId}', encodeURIComponent(String(measurementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /MeasurementMaintenance/trigger-campaign/{vesselId} - POST
         * @param {string} vesselId 
         * @param {RHIMMeasurementServiceApiV1ModelsMeasurementTriggerTaskDto} [rHIMMeasurementServiceApiV1ModelsMeasurementTriggerTaskDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMeasurementmaintenanceTriggerCampaignVesselid: async (vesselId: string, rHIMMeasurementServiceApiV1ModelsMeasurementTriggerTaskDto?: RHIMMeasurementServiceApiV1ModelsMeasurementTriggerTaskDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('postMeasurementmaintenanceTriggerCampaignVesselid', 'vesselId', vesselId)
            const localVarPath = `/MeasurementMaintenance/trigger-campaign/{vesselId}`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMMeasurementServiceApiV1ModelsMeasurementTriggerTaskDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /MeasurementMaintenance/trigger-campaign/{vesselId}/{campaign} - POST
         * @param {string} vesselId 
         * @param {number} campaign 
         * @param {RHIMMeasurementServiceApiV1ModelsMeasurementTriggerTaskDto} [rHIMMeasurementServiceApiV1ModelsMeasurementTriggerTaskDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMeasurementmaintenanceTriggerCampaignVesselidCampaign: async (vesselId: string, campaign: number, rHIMMeasurementServiceApiV1ModelsMeasurementTriggerTaskDto?: RHIMMeasurementServiceApiV1ModelsMeasurementTriggerTaskDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('postMeasurementmaintenanceTriggerCampaignVesselidCampaign', 'vesselId', vesselId)
            // verify required parameter 'campaign' is not null or undefined
            assertParamExists('postMeasurementmaintenanceTriggerCampaignVesselidCampaign', 'campaign', campaign)
            const localVarPath = `/MeasurementMaintenance/trigger-campaign/{vesselId}/{campaign}`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)))
                .replace('{campaign}', encodeURIComponent(String(campaign)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMMeasurementServiceApiV1ModelsMeasurementTriggerTaskDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /MeasurementMaintenance/trigger/{measurementId} - POST
         * @param {string} measurementId 
         * @param {RHIMMeasurementServiceApiV1ModelsMeasurementTriggerTaskDto} [rHIMMeasurementServiceApiV1ModelsMeasurementTriggerTaskDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMeasurementmaintenanceTriggerMeasurementid: async (measurementId: string, rHIMMeasurementServiceApiV1ModelsMeasurementTriggerTaskDto?: RHIMMeasurementServiceApiV1ModelsMeasurementTriggerTaskDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'measurementId' is not null or undefined
            assertParamExists('postMeasurementmaintenanceTriggerMeasurementid', 'measurementId', measurementId)
            const localVarPath = `/MeasurementMaintenance/trigger/{measurementId}`
                .replace('{measurementId}', encodeURIComponent(String(measurementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMMeasurementServiceApiV1ModelsMeasurementTriggerTaskDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MeasurementMaintenanceApi - functional programming interface
 */
export const MeasurementMaintenanceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MeasurementMaintenanceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary /MeasurementMaintenance/delete/{measurementId} - DELETE
         * @param {string} measurementId 
         * @param {RHIMMeasurementServiceApiV1ModelsMaintenanceRequestDto} [rHIMMeasurementServiceApiV1ModelsMaintenanceRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMeasurementmaintenanceDeleteMeasurementid(measurementId: string, rHIMMeasurementServiceApiV1ModelsMaintenanceRequestDto?: RHIMMeasurementServiceApiV1ModelsMaintenanceRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMMeasurementServiceApiV1ModelsMaintenanceResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMeasurementmaintenanceDeleteMeasurementid(measurementId, rHIMMeasurementServiceApiV1ModelsMaintenanceRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementMaintenanceApi.deleteMeasurementmaintenanceDeleteMeasurementid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /MeasurementMaintenance/delete/{vesselId}/{campaign} - DELETE
         * @param {string} vesselId 
         * @param {number} campaign 
         * @param {RHIMMeasurementServiceApiV1ModelsMaintenanceRequestDto} [rHIMMeasurementServiceApiV1ModelsMaintenanceRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMeasurementmaintenanceDeleteVesselidCampaign(vesselId: string, campaign: number, rHIMMeasurementServiceApiV1ModelsMaintenanceRequestDto?: RHIMMeasurementServiceApiV1ModelsMaintenanceRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMMeasurementServiceApiV1ModelsMaintenanceResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMeasurementmaintenanceDeleteVesselidCampaign(vesselId, campaign, rHIMMeasurementServiceApiV1ModelsMaintenanceRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementMaintenanceApi.deleteMeasurementmaintenanceDeleteVesselidCampaign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /MeasurementMaintenance/cancel/{measurementId} - POST
         * @param {string} measurementId 
         * @param {RHIMMeasurementServiceApiV1ModelsMaintenanceRequestDto} [rHIMMeasurementServiceApiV1ModelsMaintenanceRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postMeasurementmaintenanceCancelMeasurementid(measurementId: string, rHIMMeasurementServiceApiV1ModelsMaintenanceRequestDto?: RHIMMeasurementServiceApiV1ModelsMaintenanceRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMMeasurementServiceApiV1ModelsMaintenanceResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postMeasurementmaintenanceCancelMeasurementid(measurementId, rHIMMeasurementServiceApiV1ModelsMaintenanceRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementMaintenanceApi.postMeasurementmaintenanceCancelMeasurementid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /MeasurementMaintenance/clearrbl/{measurementId} - POST
         * @param {string} measurementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postMeasurementmaintenanceClearrblMeasurementid(measurementId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postMeasurementmaintenanceClearrblMeasurementid(measurementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementMaintenanceApi.postMeasurementmaintenanceClearrblMeasurementid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /MeasurementMaintenance/recalculate-campaign/{vesselId} - POST
         * @param {string} vesselId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postMeasurementmaintenanceRecalculateCampaignVesselid(vesselId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postMeasurementmaintenanceRecalculateCampaignVesselid(vesselId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementMaintenanceApi.postMeasurementmaintenanceRecalculateCampaignVesselid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /MeasurementMaintenance/recalculate-campaign/{vesselId}/{campaign} - POST
         * @param {string} vesselId 
         * @param {number} campaign 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postMeasurementmaintenanceRecalculateCampaignVesselidCampaign(vesselId: string, campaign: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postMeasurementmaintenanceRecalculateCampaignVesselidCampaign(vesselId, campaign, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementMaintenanceApi.postMeasurementmaintenanceRecalculateCampaignVesselidCampaign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /MeasurementMaintenance/recalculate/{measurementId} - POST
         * @param {string} measurementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postMeasurementmaintenanceRecalculateMeasurementid(measurementId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postMeasurementmaintenanceRecalculateMeasurementid(measurementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementMaintenanceApi.postMeasurementmaintenanceRecalculateMeasurementid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /MeasurementMaintenance/trigger-campaign/{vesselId} - POST
         * @param {string} vesselId 
         * @param {RHIMMeasurementServiceApiV1ModelsMeasurementTriggerTaskDto} [rHIMMeasurementServiceApiV1ModelsMeasurementTriggerTaskDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postMeasurementmaintenanceTriggerCampaignVesselid(vesselId: string, rHIMMeasurementServiceApiV1ModelsMeasurementTriggerTaskDto?: RHIMMeasurementServiceApiV1ModelsMeasurementTriggerTaskDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postMeasurementmaintenanceTriggerCampaignVesselid(vesselId, rHIMMeasurementServiceApiV1ModelsMeasurementTriggerTaskDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementMaintenanceApi.postMeasurementmaintenanceTriggerCampaignVesselid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /MeasurementMaintenance/trigger-campaign/{vesselId}/{campaign} - POST
         * @param {string} vesselId 
         * @param {number} campaign 
         * @param {RHIMMeasurementServiceApiV1ModelsMeasurementTriggerTaskDto} [rHIMMeasurementServiceApiV1ModelsMeasurementTriggerTaskDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postMeasurementmaintenanceTriggerCampaignVesselidCampaign(vesselId: string, campaign: number, rHIMMeasurementServiceApiV1ModelsMeasurementTriggerTaskDto?: RHIMMeasurementServiceApiV1ModelsMeasurementTriggerTaskDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postMeasurementmaintenanceTriggerCampaignVesselidCampaign(vesselId, campaign, rHIMMeasurementServiceApiV1ModelsMeasurementTriggerTaskDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementMaintenanceApi.postMeasurementmaintenanceTriggerCampaignVesselidCampaign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /MeasurementMaintenance/trigger/{measurementId} - POST
         * @param {string} measurementId 
         * @param {RHIMMeasurementServiceApiV1ModelsMeasurementTriggerTaskDto} [rHIMMeasurementServiceApiV1ModelsMeasurementTriggerTaskDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postMeasurementmaintenanceTriggerMeasurementid(measurementId: string, rHIMMeasurementServiceApiV1ModelsMeasurementTriggerTaskDto?: RHIMMeasurementServiceApiV1ModelsMeasurementTriggerTaskDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postMeasurementmaintenanceTriggerMeasurementid(measurementId, rHIMMeasurementServiceApiV1ModelsMeasurementTriggerTaskDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementMaintenanceApi.postMeasurementmaintenanceTriggerMeasurementid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MeasurementMaintenanceApi - factory interface
 */
export const MeasurementMaintenanceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MeasurementMaintenanceApiFp(configuration)
    return {
        /**
         * 
         * @summary /MeasurementMaintenance/delete/{measurementId} - DELETE
         * @param {string} measurementId 
         * @param {RHIMMeasurementServiceApiV1ModelsMaintenanceRequestDto} [rHIMMeasurementServiceApiV1ModelsMaintenanceRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMeasurementmaintenanceDeleteMeasurementid(measurementId: string, rHIMMeasurementServiceApiV1ModelsMaintenanceRequestDto?: RHIMMeasurementServiceApiV1ModelsMaintenanceRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<RHIMMeasurementServiceApiV1ModelsMaintenanceResponseDto> {
            return localVarFp.deleteMeasurementmaintenanceDeleteMeasurementid(measurementId, rHIMMeasurementServiceApiV1ModelsMaintenanceRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /MeasurementMaintenance/delete/{vesselId}/{campaign} - DELETE
         * @param {string} vesselId 
         * @param {number} campaign 
         * @param {RHIMMeasurementServiceApiV1ModelsMaintenanceRequestDto} [rHIMMeasurementServiceApiV1ModelsMaintenanceRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMeasurementmaintenanceDeleteVesselidCampaign(vesselId: string, campaign: number, rHIMMeasurementServiceApiV1ModelsMaintenanceRequestDto?: RHIMMeasurementServiceApiV1ModelsMaintenanceRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<RHIMMeasurementServiceApiV1ModelsMaintenanceResponseDto> {
            return localVarFp.deleteMeasurementmaintenanceDeleteVesselidCampaign(vesselId, campaign, rHIMMeasurementServiceApiV1ModelsMaintenanceRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /MeasurementMaintenance/cancel/{measurementId} - POST
         * @param {string} measurementId 
         * @param {RHIMMeasurementServiceApiV1ModelsMaintenanceRequestDto} [rHIMMeasurementServiceApiV1ModelsMaintenanceRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMeasurementmaintenanceCancelMeasurementid(measurementId: string, rHIMMeasurementServiceApiV1ModelsMaintenanceRequestDto?: RHIMMeasurementServiceApiV1ModelsMaintenanceRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<RHIMMeasurementServiceApiV1ModelsMaintenanceResponseDto> {
            return localVarFp.postMeasurementmaintenanceCancelMeasurementid(measurementId, rHIMMeasurementServiceApiV1ModelsMaintenanceRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /MeasurementMaintenance/clearrbl/{measurementId} - POST
         * @param {string} measurementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMeasurementmaintenanceClearrblMeasurementid(measurementId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postMeasurementmaintenanceClearrblMeasurementid(measurementId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /MeasurementMaintenance/recalculate-campaign/{vesselId} - POST
         * @param {string} vesselId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMeasurementmaintenanceRecalculateCampaignVesselid(vesselId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postMeasurementmaintenanceRecalculateCampaignVesselid(vesselId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /MeasurementMaintenance/recalculate-campaign/{vesselId}/{campaign} - POST
         * @param {string} vesselId 
         * @param {number} campaign 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMeasurementmaintenanceRecalculateCampaignVesselidCampaign(vesselId: string, campaign: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postMeasurementmaintenanceRecalculateCampaignVesselidCampaign(vesselId, campaign, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /MeasurementMaintenance/recalculate/{measurementId} - POST
         * @param {string} measurementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMeasurementmaintenanceRecalculateMeasurementid(measurementId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postMeasurementmaintenanceRecalculateMeasurementid(measurementId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /MeasurementMaintenance/trigger-campaign/{vesselId} - POST
         * @param {string} vesselId 
         * @param {RHIMMeasurementServiceApiV1ModelsMeasurementTriggerTaskDto} [rHIMMeasurementServiceApiV1ModelsMeasurementTriggerTaskDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMeasurementmaintenanceTriggerCampaignVesselid(vesselId: string, rHIMMeasurementServiceApiV1ModelsMeasurementTriggerTaskDto?: RHIMMeasurementServiceApiV1ModelsMeasurementTriggerTaskDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postMeasurementmaintenanceTriggerCampaignVesselid(vesselId, rHIMMeasurementServiceApiV1ModelsMeasurementTriggerTaskDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /MeasurementMaintenance/trigger-campaign/{vesselId}/{campaign} - POST
         * @param {string} vesselId 
         * @param {number} campaign 
         * @param {RHIMMeasurementServiceApiV1ModelsMeasurementTriggerTaskDto} [rHIMMeasurementServiceApiV1ModelsMeasurementTriggerTaskDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMeasurementmaintenanceTriggerCampaignVesselidCampaign(vesselId: string, campaign: number, rHIMMeasurementServiceApiV1ModelsMeasurementTriggerTaskDto?: RHIMMeasurementServiceApiV1ModelsMeasurementTriggerTaskDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postMeasurementmaintenanceTriggerCampaignVesselidCampaign(vesselId, campaign, rHIMMeasurementServiceApiV1ModelsMeasurementTriggerTaskDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /MeasurementMaintenance/trigger/{measurementId} - POST
         * @param {string} measurementId 
         * @param {RHIMMeasurementServiceApiV1ModelsMeasurementTriggerTaskDto} [rHIMMeasurementServiceApiV1ModelsMeasurementTriggerTaskDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMeasurementmaintenanceTriggerMeasurementid(measurementId: string, rHIMMeasurementServiceApiV1ModelsMeasurementTriggerTaskDto?: RHIMMeasurementServiceApiV1ModelsMeasurementTriggerTaskDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postMeasurementmaintenanceTriggerMeasurementid(measurementId, rHIMMeasurementServiceApiV1ModelsMeasurementTriggerTaskDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MeasurementMaintenanceApi - object-oriented interface
 */
export class MeasurementMaintenanceApi extends BaseAPI {
    /**
     * 
     * @summary /MeasurementMaintenance/delete/{measurementId} - DELETE
     * @param {string} measurementId 
     * @param {RHIMMeasurementServiceApiV1ModelsMaintenanceRequestDto} [rHIMMeasurementServiceApiV1ModelsMaintenanceRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteMeasurementmaintenanceDeleteMeasurementid(measurementId: string, rHIMMeasurementServiceApiV1ModelsMaintenanceRequestDto?: RHIMMeasurementServiceApiV1ModelsMaintenanceRequestDto, options?: RawAxiosRequestConfig) {
        return MeasurementMaintenanceApiFp(this.configuration).deleteMeasurementmaintenanceDeleteMeasurementid(measurementId, rHIMMeasurementServiceApiV1ModelsMaintenanceRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /MeasurementMaintenance/delete/{vesselId}/{campaign} - DELETE
     * @param {string} vesselId 
     * @param {number} campaign 
     * @param {RHIMMeasurementServiceApiV1ModelsMaintenanceRequestDto} [rHIMMeasurementServiceApiV1ModelsMaintenanceRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteMeasurementmaintenanceDeleteVesselidCampaign(vesselId: string, campaign: number, rHIMMeasurementServiceApiV1ModelsMaintenanceRequestDto?: RHIMMeasurementServiceApiV1ModelsMaintenanceRequestDto, options?: RawAxiosRequestConfig) {
        return MeasurementMaintenanceApiFp(this.configuration).deleteMeasurementmaintenanceDeleteVesselidCampaign(vesselId, campaign, rHIMMeasurementServiceApiV1ModelsMaintenanceRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /MeasurementMaintenance/cancel/{measurementId} - POST
     * @param {string} measurementId 
     * @param {RHIMMeasurementServiceApiV1ModelsMaintenanceRequestDto} [rHIMMeasurementServiceApiV1ModelsMaintenanceRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postMeasurementmaintenanceCancelMeasurementid(measurementId: string, rHIMMeasurementServiceApiV1ModelsMaintenanceRequestDto?: RHIMMeasurementServiceApiV1ModelsMaintenanceRequestDto, options?: RawAxiosRequestConfig) {
        return MeasurementMaintenanceApiFp(this.configuration).postMeasurementmaintenanceCancelMeasurementid(measurementId, rHIMMeasurementServiceApiV1ModelsMaintenanceRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /MeasurementMaintenance/clearrbl/{measurementId} - POST
     * @param {string} measurementId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postMeasurementmaintenanceClearrblMeasurementid(measurementId: string, options?: RawAxiosRequestConfig) {
        return MeasurementMaintenanceApiFp(this.configuration).postMeasurementmaintenanceClearrblMeasurementid(measurementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /MeasurementMaintenance/recalculate-campaign/{vesselId} - POST
     * @param {string} vesselId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postMeasurementmaintenanceRecalculateCampaignVesselid(vesselId: string, options?: RawAxiosRequestConfig) {
        return MeasurementMaintenanceApiFp(this.configuration).postMeasurementmaintenanceRecalculateCampaignVesselid(vesselId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /MeasurementMaintenance/recalculate-campaign/{vesselId}/{campaign} - POST
     * @param {string} vesselId 
     * @param {number} campaign 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postMeasurementmaintenanceRecalculateCampaignVesselidCampaign(vesselId: string, campaign: number, options?: RawAxiosRequestConfig) {
        return MeasurementMaintenanceApiFp(this.configuration).postMeasurementmaintenanceRecalculateCampaignVesselidCampaign(vesselId, campaign, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /MeasurementMaintenance/recalculate/{measurementId} - POST
     * @param {string} measurementId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postMeasurementmaintenanceRecalculateMeasurementid(measurementId: string, options?: RawAxiosRequestConfig) {
        return MeasurementMaintenanceApiFp(this.configuration).postMeasurementmaintenanceRecalculateMeasurementid(measurementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /MeasurementMaintenance/trigger-campaign/{vesselId} - POST
     * @param {string} vesselId 
     * @param {RHIMMeasurementServiceApiV1ModelsMeasurementTriggerTaskDto} [rHIMMeasurementServiceApiV1ModelsMeasurementTriggerTaskDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postMeasurementmaintenanceTriggerCampaignVesselid(vesselId: string, rHIMMeasurementServiceApiV1ModelsMeasurementTriggerTaskDto?: RHIMMeasurementServiceApiV1ModelsMeasurementTriggerTaskDto, options?: RawAxiosRequestConfig) {
        return MeasurementMaintenanceApiFp(this.configuration).postMeasurementmaintenanceTriggerCampaignVesselid(vesselId, rHIMMeasurementServiceApiV1ModelsMeasurementTriggerTaskDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /MeasurementMaintenance/trigger-campaign/{vesselId}/{campaign} - POST
     * @param {string} vesselId 
     * @param {number} campaign 
     * @param {RHIMMeasurementServiceApiV1ModelsMeasurementTriggerTaskDto} [rHIMMeasurementServiceApiV1ModelsMeasurementTriggerTaskDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postMeasurementmaintenanceTriggerCampaignVesselidCampaign(vesselId: string, campaign: number, rHIMMeasurementServiceApiV1ModelsMeasurementTriggerTaskDto?: RHIMMeasurementServiceApiV1ModelsMeasurementTriggerTaskDto, options?: RawAxiosRequestConfig) {
        return MeasurementMaintenanceApiFp(this.configuration).postMeasurementmaintenanceTriggerCampaignVesselidCampaign(vesselId, campaign, rHIMMeasurementServiceApiV1ModelsMeasurementTriggerTaskDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /MeasurementMaintenance/trigger/{measurementId} - POST
     * @param {string} measurementId 
     * @param {RHIMMeasurementServiceApiV1ModelsMeasurementTriggerTaskDto} [rHIMMeasurementServiceApiV1ModelsMeasurementTriggerTaskDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postMeasurementmaintenanceTriggerMeasurementid(measurementId: string, rHIMMeasurementServiceApiV1ModelsMeasurementTriggerTaskDto?: RHIMMeasurementServiceApiV1ModelsMeasurementTriggerTaskDto, options?: RawAxiosRequestConfig) {
        return MeasurementMaintenanceApiFp(this.configuration).postMeasurementmaintenanceTriggerMeasurementid(measurementId, rHIMMeasurementServiceApiV1ModelsMeasurementTriggerTaskDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MeasurementPointcloudViewApi - axios parameter creator
 */
export const MeasurementPointcloudViewApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary /MeasurementPointcloudView/{measurementId}/details - GET
         * @param {string} measurementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementpointcloudviewMeasurementidDetails: async (measurementId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'measurementId' is not null or undefined
            assertParamExists('getMeasurementpointcloudviewMeasurementidDetails', 'measurementId', measurementId)
            const localVarPath = `/MeasurementPointcloudView/{measurementId}/details`
                .replace('{measurementId}', encodeURIComponent(String(measurementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /MeasurementPointcloudView/{vesselId}/campaigns - GET
         * @param {string} vesselId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementpointcloudviewVesselidCampaigns: async (vesselId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getMeasurementpointcloudviewVesselidCampaigns', 'vesselId', vesselId)
            const localVarPath = `/MeasurementPointcloudView/{vesselId}/campaigns`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /MeasurementPointcloudView/{vesselId}/measurements/{campaign} - GET
         * @param {string} vesselId 
         * @param {number} campaign 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementpointcloudviewVesselidMeasurementsCampaign: async (vesselId: string, campaign: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getMeasurementpointcloudviewVesselidMeasurementsCampaign', 'vesselId', vesselId)
            // verify required parameter 'campaign' is not null or undefined
            assertParamExists('getMeasurementpointcloudviewVesselidMeasurementsCampaign', 'campaign', campaign)
            const localVarPath = `/MeasurementPointcloudView/{vesselId}/measurements/{campaign}`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)))
                .replace('{campaign}', encodeURIComponent(String(campaign)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MeasurementPointcloudViewApi - functional programming interface
 */
export const MeasurementPointcloudViewApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MeasurementPointcloudViewApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary /MeasurementPointcloudView/{measurementId}/details - GET
         * @param {string} measurementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeasurementpointcloudviewMeasurementidDetails(measurementId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMMeasurementServiceApiV1ModelsMeasurementPointcloudViewDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeasurementpointcloudviewMeasurementidDetails(measurementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementPointcloudViewApi.getMeasurementpointcloudviewMeasurementidDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /MeasurementPointcloudView/{vesselId}/campaigns - GET
         * @param {string} vesselId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeasurementpointcloudviewVesselidCampaigns(vesselId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMMeasurementServiceApiV1ModelsCampaignDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeasurementpointcloudviewVesselidCampaigns(vesselId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementPointcloudViewApi.getMeasurementpointcloudviewVesselidCampaigns']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /MeasurementPointcloudView/{vesselId}/measurements/{campaign} - GET
         * @param {string} vesselId 
         * @param {number} campaign 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeasurementpointcloudviewVesselidMeasurementsCampaign(vesselId: string, campaign: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMMeasurementServiceApiV1ModelsMeasurementPointcloudViewDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeasurementpointcloudviewVesselidMeasurementsCampaign(vesselId, campaign, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementPointcloudViewApi.getMeasurementpointcloudviewVesselidMeasurementsCampaign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MeasurementPointcloudViewApi - factory interface
 */
export const MeasurementPointcloudViewApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MeasurementPointcloudViewApiFp(configuration)
    return {
        /**
         * 
         * @summary /MeasurementPointcloudView/{measurementId}/details - GET
         * @param {string} measurementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementpointcloudviewMeasurementidDetails(measurementId: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMMeasurementServiceApiV1ModelsMeasurementPointcloudViewDto> {
            return localVarFp.getMeasurementpointcloudviewMeasurementidDetails(measurementId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /MeasurementPointcloudView/{vesselId}/campaigns - GET
         * @param {string} vesselId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementpointcloudviewVesselidCampaigns(vesselId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMMeasurementServiceApiV1ModelsCampaignDto>> {
            return localVarFp.getMeasurementpointcloudviewVesselidCampaigns(vesselId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /MeasurementPointcloudView/{vesselId}/measurements/{campaign} - GET
         * @param {string} vesselId 
         * @param {number} campaign 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementpointcloudviewVesselidMeasurementsCampaign(vesselId: string, campaign: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMMeasurementServiceApiV1ModelsMeasurementPointcloudViewDto>> {
            return localVarFp.getMeasurementpointcloudviewVesselidMeasurementsCampaign(vesselId, campaign, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MeasurementPointcloudViewApi - object-oriented interface
 */
export class MeasurementPointcloudViewApi extends BaseAPI {
    /**
     * 
     * @summary /MeasurementPointcloudView/{measurementId}/details - GET
     * @param {string} measurementId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMeasurementpointcloudviewMeasurementidDetails(measurementId: string, options?: RawAxiosRequestConfig) {
        return MeasurementPointcloudViewApiFp(this.configuration).getMeasurementpointcloudviewMeasurementidDetails(measurementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /MeasurementPointcloudView/{vesselId}/campaigns - GET
     * @param {string} vesselId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMeasurementpointcloudviewVesselidCampaigns(vesselId: string, options?: RawAxiosRequestConfig) {
        return MeasurementPointcloudViewApiFp(this.configuration).getMeasurementpointcloudviewVesselidCampaigns(vesselId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /MeasurementPointcloudView/{vesselId}/measurements/{campaign} - GET
     * @param {string} vesselId 
     * @param {number} campaign 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMeasurementpointcloudviewVesselidMeasurementsCampaign(vesselId: string, campaign: number, options?: RawAxiosRequestConfig) {
        return MeasurementPointcloudViewApiFp(this.configuration).getMeasurementpointcloudviewVesselidMeasurementsCampaign(vesselId, campaign, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MeasurementSystemsFilesUploadApi - axios parameter creator
 */
export const MeasurementSystemsFilesUploadApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary /FerrotronUpload/v1/{vesselId} - POST
         * @param {string} vesselId 
         * @param {File} [pointdata] 
         * @param {number} [campaign] 
         * @param {number} [heat] 
         * @param {string} [measurementTaken] 
         * @param {boolean} [viewOnly] 
         * @param {string} [vesselLining] 
         * @param {string} [liningCondition] 
         * @param {string} [liningMaintenanceType] 
         * @param {boolean} [hotMeasurement] 
         * @param {string} [notes] 
         * @param {string} [responsible] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFerrotronuploadV1Vesselid: async (vesselId: string, pointdata?: File, campaign?: number, heat?: number, measurementTaken?: string, viewOnly?: boolean, vesselLining?: string, liningCondition?: string, liningMaintenanceType?: string, hotMeasurement?: boolean, notes?: string, responsible?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('postFerrotronuploadV1Vesselid', 'vesselId', vesselId)
            const localVarPath = `/FerrotronUpload/v1/{vesselId}`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (pointdata !== undefined) { 
                localVarFormParams.append('pointdata', pointdata as any);
            }

            if (campaign !== undefined) { 
                localVarFormParams.append('Campaign', campaign as any);
            }

            if (heat !== undefined) { 
                localVarFormParams.append('Heat', heat as any);
            }

            if (measurementTaken !== undefined) { 
                localVarFormParams.append('MeasurementTaken', measurementTaken as any);
            }

            if (viewOnly !== undefined) { 
                localVarFormParams.append('ViewOnly', String(viewOnly) as any);
            }

            if (vesselLining !== undefined) { 
                localVarFormParams.append('VesselLining', vesselLining as any);
            }

            if (liningCondition !== undefined) { 
                localVarFormParams.append('LiningCondition', liningCondition as any);
            }

            if (liningMaintenanceType !== undefined) { 
                localVarFormParams.append('LiningMaintenanceType', liningMaintenanceType as any);
            }

            if (hotMeasurement !== undefined) { 
                localVarFormParams.append('HotMeasurement', String(hotMeasurement) as any);
            }

            if (notes !== undefined) { 
                localVarFormParams.append('Notes', notes as any);
            }

            if (responsible !== undefined) { 
                localVarFormParams.append('Responsible', responsible as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /FerrotronUpload/v2/{vesselId} - POST
         * @param {string} vesselId 
         * @param {File} [pointdata] 
         * @param {number} [campaign] 
         * @param {number} [heat] 
         * @param {string} [measurementTaken] 
         * @param {boolean} [viewOnly] 
         * @param {string} [vesselLining] 
         * @param {string} [liningCondition] 
         * @param {string} [liningMaintenanceType] 
         * @param {boolean} [hotMeasurement] 
         * @param {string} [notes] 
         * @param {string} [responsible] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFerrotronuploadV2Vesselid: async (vesselId: string, pointdata?: File, campaign?: number, heat?: number, measurementTaken?: string, viewOnly?: boolean, vesselLining?: string, liningCondition?: string, liningMaintenanceType?: string, hotMeasurement?: boolean, notes?: string, responsible?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('postFerrotronuploadV2Vesselid', 'vesselId', vesselId)
            const localVarPath = `/FerrotronUpload/v2/{vesselId}`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (pointdata !== undefined) { 
                localVarFormParams.append('pointdata', pointdata as any);
            }

            if (campaign !== undefined) { 
                localVarFormParams.append('Campaign', campaign as any);
            }

            if (heat !== undefined) { 
                localVarFormParams.append('Heat', heat as any);
            }

            if (measurementTaken !== undefined) { 
                localVarFormParams.append('MeasurementTaken', measurementTaken as any);
            }

            if (viewOnly !== undefined) { 
                localVarFormParams.append('ViewOnly', String(viewOnly) as any);
            }

            if (vesselLining !== undefined) { 
                localVarFormParams.append('VesselLining', vesselLining as any);
            }

            if (liningCondition !== undefined) { 
                localVarFormParams.append('LiningCondition', liningCondition as any);
            }

            if (liningMaintenanceType !== undefined) { 
                localVarFormParams.append('LiningMaintenanceType', liningMaintenanceType as any);
            }

            if (hotMeasurement !== undefined) { 
                localVarFormParams.append('HotMeasurement', String(hotMeasurement) as any);
            }

            if (notes !== undefined) { 
                localVarFormParams.append('Notes', notes as any);
            }

            if (responsible !== undefined) { 
                localVarFormParams.append('Responsible', responsible as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /HyperionUpload/raw/{vesselId} - POST
         * @param {string} vesselId 
         * @param {File} [raw] 
         * @param {File} [stl] 
         * @param {number} [campaign] 
         * @param {number} [heat] 
         * @param {string} [measurementTaken] 
         * @param {boolean} [viewOnly] 
         * @param {string} [vesselLining] 
         * @param {string} [liningCondition] 
         * @param {string} [liningMaintenanceType] 
         * @param {boolean} [hotMeasurement] 
         * @param {string} [notes] 
         * @param {string} [responsible] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postHyperionuploadRawVesselid: async (vesselId: string, raw?: File, stl?: File, campaign?: number, heat?: number, measurementTaken?: string, viewOnly?: boolean, vesselLining?: string, liningCondition?: string, liningMaintenanceType?: string, hotMeasurement?: boolean, notes?: string, responsible?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('postHyperionuploadRawVesselid', 'vesselId', vesselId)
            const localVarPath = `/HyperionUpload/raw/{vesselId}`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (raw !== undefined) { 
                localVarFormParams.append('raw', raw as any);
            }

            if (stl !== undefined) { 
                localVarFormParams.append('stl', stl as any);
            }

            if (campaign !== undefined) { 
                localVarFormParams.append('Campaign', campaign as any);
            }

            if (heat !== undefined) { 
                localVarFormParams.append('Heat', heat as any);
            }

            if (measurementTaken !== undefined) { 
                localVarFormParams.append('MeasurementTaken', measurementTaken as any);
            }

            if (viewOnly !== undefined) { 
                localVarFormParams.append('ViewOnly', String(viewOnly) as any);
            }

            if (vesselLining !== undefined) { 
                localVarFormParams.append('VesselLining', vesselLining as any);
            }

            if (liningCondition !== undefined) { 
                localVarFormParams.append('LiningCondition', liningCondition as any);
            }

            if (liningMaintenanceType !== undefined) { 
                localVarFormParams.append('LiningMaintenanceType', liningMaintenanceType as any);
            }

            if (hotMeasurement !== undefined) { 
                localVarFormParams.append('HotMeasurement', String(hotMeasurement) as any);
            }

            if (notes !== undefined) { 
                localVarFormParams.append('Notes', notes as any);
            }

            if (responsible !== undefined) { 
                localVarFormParams.append('Responsible', responsible as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /IMSIUpload/{vesselId} - POST
         * @param {string} vesselId 
         * @param {File} [pointdata] 
         * @param {number} [campaign] 
         * @param {number} [heat] 
         * @param {string} [measurementTaken] 
         * @param {boolean} [viewOnly] 
         * @param {string} [vesselLining] 
         * @param {string} [liningCondition] 
         * @param {string} [liningMaintenanceType] 
         * @param {boolean} [hotMeasurement] 
         * @param {string} [notes] 
         * @param {string} [responsible] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postImsiuploadVesselid: async (vesselId: string, pointdata?: File, campaign?: number, heat?: number, measurementTaken?: string, viewOnly?: boolean, vesselLining?: string, liningCondition?: string, liningMaintenanceType?: string, hotMeasurement?: boolean, notes?: string, responsible?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('postImsiuploadVesselid', 'vesselId', vesselId)
            const localVarPath = `/IMSIUpload/{vesselId}`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (pointdata !== undefined) { 
                localVarFormParams.append('pointdata', pointdata as any);
            }

            if (campaign !== undefined) { 
                localVarFormParams.append('Campaign', campaign as any);
            }

            if (heat !== undefined) { 
                localVarFormParams.append('Heat', heat as any);
            }

            if (measurementTaken !== undefined) { 
                localVarFormParams.append('MeasurementTaken', measurementTaken as any);
            }

            if (viewOnly !== undefined) { 
                localVarFormParams.append('ViewOnly', String(viewOnly) as any);
            }

            if (vesselLining !== undefined) { 
                localVarFormParams.append('VesselLining', vesselLining as any);
            }

            if (liningCondition !== undefined) { 
                localVarFormParams.append('LiningCondition', liningCondition as any);
            }

            if (liningMaintenanceType !== undefined) { 
                localVarFormParams.append('LiningMaintenanceType', liningMaintenanceType as any);
            }

            if (hotMeasurement !== undefined) { 
                localVarFormParams.append('HotMeasurement', String(hotMeasurement) as any);
            }

            if (notes !== undefined) { 
                localVarFormParams.append('Notes', notes as any);
            }

            if (responsible !== undefined) { 
                localVarFormParams.append('Responsible', responsible as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /LatitudeUpload/{vesselId} - POST
         * @param {string} vesselId 
         * @param {File} [pointdata] 
         * @param {number} [campaign] 
         * @param {number} [heat] 
         * @param {string} [measurementTaken] 
         * @param {boolean} [viewOnly] 
         * @param {string} [vesselLining] 
         * @param {string} [liningCondition] 
         * @param {string} [liningMaintenanceType] 
         * @param {boolean} [hotMeasurement] 
         * @param {string} [notes] 
         * @param {string} [responsible] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postLatitudeuploadVesselid: async (vesselId: string, pointdata?: File, campaign?: number, heat?: number, measurementTaken?: string, viewOnly?: boolean, vesselLining?: string, liningCondition?: string, liningMaintenanceType?: string, hotMeasurement?: boolean, notes?: string, responsible?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('postLatitudeuploadVesselid', 'vesselId', vesselId)
            const localVarPath = `/LatitudeUpload/{vesselId}`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (pointdata !== undefined) { 
                localVarFormParams.append('pointdata', pointdata as any);
            }

            if (campaign !== undefined) { 
                localVarFormParams.append('Campaign', campaign as any);
            }

            if (heat !== undefined) { 
                localVarFormParams.append('Heat', heat as any);
            }

            if (measurementTaken !== undefined) { 
                localVarFormParams.append('MeasurementTaken', measurementTaken as any);
            }

            if (viewOnly !== undefined) { 
                localVarFormParams.append('ViewOnly', String(viewOnly) as any);
            }

            if (vesselLining !== undefined) { 
                localVarFormParams.append('VesselLining', vesselLining as any);
            }

            if (liningCondition !== undefined) { 
                localVarFormParams.append('LiningCondition', liningCondition as any);
            }

            if (liningMaintenanceType !== undefined) { 
                localVarFormParams.append('LiningMaintenanceType', liningMaintenanceType as any);
            }

            if (hotMeasurement !== undefined) { 
                localVarFormParams.append('HotMeasurement', String(hotMeasurement) as any);
            }

            if (notes !== undefined) { 
                localVarFormParams.append('Notes', notes as any);
            }

            if (responsible !== undefined) { 
                localVarFormParams.append('Responsible', responsible as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /ScaniverseUpload/{vesselId} - POST
         * @param {string} vesselId 
         * @param {File} [pointdata] 
         * @param {File} [mesh] 
         * @param {number} [campaign] 
         * @param {number} [heat] 
         * @param {string} [measurementTaken] 
         * @param {boolean} [viewOnly] 
         * @param {string} [vesselLining] 
         * @param {string} [liningCondition] 
         * @param {string} [liningMaintenanceType] 
         * @param {boolean} [hotMeasurement] 
         * @param {string} [notes] 
         * @param {string} [responsible] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postScaniverseuploadVesselid: async (vesselId: string, pointdata?: File, mesh?: File, campaign?: number, heat?: number, measurementTaken?: string, viewOnly?: boolean, vesselLining?: string, liningCondition?: string, liningMaintenanceType?: string, hotMeasurement?: boolean, notes?: string, responsible?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('postScaniverseuploadVesselid', 'vesselId', vesselId)
            const localVarPath = `/ScaniverseUpload/{vesselId}`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (pointdata !== undefined) { 
                localVarFormParams.append('pointdata', pointdata as any);
            }

            if (mesh !== undefined) { 
                localVarFormParams.append('mesh', mesh as any);
            }

            if (campaign !== undefined) { 
                localVarFormParams.append('Campaign', campaign as any);
            }

            if (heat !== undefined) { 
                localVarFormParams.append('Heat', heat as any);
            }

            if (measurementTaken !== undefined) { 
                localVarFormParams.append('MeasurementTaken', measurementTaken as any);
            }

            if (viewOnly !== undefined) { 
                localVarFormParams.append('ViewOnly', String(viewOnly) as any);
            }

            if (vesselLining !== undefined) { 
                localVarFormParams.append('VesselLining', vesselLining as any);
            }

            if (liningCondition !== undefined) { 
                localVarFormParams.append('LiningCondition', liningCondition as any);
            }

            if (liningMaintenanceType !== undefined) { 
                localVarFormParams.append('LiningMaintenanceType', liningMaintenanceType as any);
            }

            if (hotMeasurement !== undefined) { 
                localVarFormParams.append('HotMeasurement', String(hotMeasurement) as any);
            }

            if (notes !== undefined) { 
                localVarFormParams.append('Notes', notes as any);
            }

            if (responsible !== undefined) { 
                localVarFormParams.append('Responsible', responsible as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /VertexUpload/hyperion/{vesselId} - POST
         * @param {string} vesselId 
         * @param {File} [vertex] 
         * @param {File} [stl] 
         * @param {File} [summary] 
         * @param {number} [campaign] 
         * @param {number} [heat] 
         * @param {string} [measurementTaken] 
         * @param {boolean} [viewOnly] 
         * @param {string} [vesselLining] 
         * @param {string} [liningCondition] 
         * @param {string} [liningMaintenanceType] 
         * @param {boolean} [hotMeasurement] 
         * @param {string} [notes] 
         * @param {string} [responsible] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postVertexuploadHyperionVesselid: async (vesselId: string, vertex?: File, stl?: File, summary?: File, campaign?: number, heat?: number, measurementTaken?: string, viewOnly?: boolean, vesselLining?: string, liningCondition?: string, liningMaintenanceType?: string, hotMeasurement?: boolean, notes?: string, responsible?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('postVertexuploadHyperionVesselid', 'vesselId', vesselId)
            const localVarPath = `/VertexUpload/hyperion/{vesselId}`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (vertex !== undefined) { 
                localVarFormParams.append('vertex', vertex as any);
            }

            if (stl !== undefined) { 
                localVarFormParams.append('stl', stl as any);
            }

            if (summary !== undefined) { 
                localVarFormParams.append('summary', summary as any);
            }

            if (campaign !== undefined) { 
                localVarFormParams.append('Campaign', campaign as any);
            }

            if (heat !== undefined) { 
                localVarFormParams.append('Heat', heat as any);
            }

            if (measurementTaken !== undefined) { 
                localVarFormParams.append('MeasurementTaken', measurementTaken as any);
            }

            if (viewOnly !== undefined) { 
                localVarFormParams.append('ViewOnly', String(viewOnly) as any);
            }

            if (vesselLining !== undefined) { 
                localVarFormParams.append('VesselLining', vesselLining as any);
            }

            if (liningCondition !== undefined) { 
                localVarFormParams.append('LiningCondition', liningCondition as any);
            }

            if (liningMaintenanceType !== undefined) { 
                localVarFormParams.append('LiningMaintenanceType', liningMaintenanceType as any);
            }

            if (hotMeasurement !== undefined) { 
                localVarFormParams.append('HotMeasurement', String(hotMeasurement) as any);
            }

            if (notes !== undefined) { 
                localVarFormParams.append('Notes', notes as any);
            }

            if (responsible !== undefined) { 
                localVarFormParams.append('Responsible', responsible as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /VertexUpload/lcs/{vesselId} - POST
         * @param {string} vesselId 
         * @param {File} [vertex] 
         * @param {File} [stl] 
         * @param {File} [summary] 
         * @param {number} [campaign] 
         * @param {number} [heat] 
         * @param {string} [measurementTaken] 
         * @param {boolean} [viewOnly] 
         * @param {string} [vesselLining] 
         * @param {string} [liningCondition] 
         * @param {string} [liningMaintenanceType] 
         * @param {boolean} [hotMeasurement] 
         * @param {string} [notes] 
         * @param {string} [responsible] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postVertexuploadLcsVesselid: async (vesselId: string, vertex?: File, stl?: File, summary?: File, campaign?: number, heat?: number, measurementTaken?: string, viewOnly?: boolean, vesselLining?: string, liningCondition?: string, liningMaintenanceType?: string, hotMeasurement?: boolean, notes?: string, responsible?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('postVertexuploadLcsVesselid', 'vesselId', vesselId)
            const localVarPath = `/VertexUpload/lcs/{vesselId}`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (vertex !== undefined) { 
                localVarFormParams.append('vertex', vertex as any);
            }

            if (stl !== undefined) { 
                localVarFormParams.append('stl', stl as any);
            }

            if (summary !== undefined) { 
                localVarFormParams.append('summary', summary as any);
            }

            if (campaign !== undefined) { 
                localVarFormParams.append('Campaign', campaign as any);
            }

            if (heat !== undefined) { 
                localVarFormParams.append('Heat', heat as any);
            }

            if (measurementTaken !== undefined) { 
                localVarFormParams.append('MeasurementTaken', measurementTaken as any);
            }

            if (viewOnly !== undefined) { 
                localVarFormParams.append('ViewOnly', String(viewOnly) as any);
            }

            if (vesselLining !== undefined) { 
                localVarFormParams.append('VesselLining', vesselLining as any);
            }

            if (liningCondition !== undefined) { 
                localVarFormParams.append('LiningCondition', liningCondition as any);
            }

            if (liningMaintenanceType !== undefined) { 
                localVarFormParams.append('LiningMaintenanceType', liningMaintenanceType as any);
            }

            if (hotMeasurement !== undefined) { 
                localVarFormParams.append('HotMeasurement', String(hotMeasurement) as any);
            }

            if (notes !== undefined) { 
                localVarFormParams.append('Notes', notes as any);
            }

            if (responsible !== undefined) { 
                localVarFormParams.append('Responsible', responsible as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MeasurementSystemsFilesUploadApi - functional programming interface
 */
export const MeasurementSystemsFilesUploadApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MeasurementSystemsFilesUploadApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary /FerrotronUpload/v1/{vesselId} - POST
         * @param {string} vesselId 
         * @param {File} [pointdata] 
         * @param {number} [campaign] 
         * @param {number} [heat] 
         * @param {string} [measurementTaken] 
         * @param {boolean} [viewOnly] 
         * @param {string} [vesselLining] 
         * @param {string} [liningCondition] 
         * @param {string} [liningMaintenanceType] 
         * @param {boolean} [hotMeasurement] 
         * @param {string} [notes] 
         * @param {string} [responsible] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postFerrotronuploadV1Vesselid(vesselId: string, pointdata?: File, campaign?: number, heat?: number, measurementTaken?: string, viewOnly?: boolean, vesselLining?: string, liningCondition?: string, liningMaintenanceType?: string, hotMeasurement?: boolean, notes?: string, responsible?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postFerrotronuploadV1Vesselid(vesselId, pointdata, campaign, heat, measurementTaken, viewOnly, vesselLining, liningCondition, liningMaintenanceType, hotMeasurement, notes, responsible, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementSystemsFilesUploadApi.postFerrotronuploadV1Vesselid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /FerrotronUpload/v2/{vesselId} - POST
         * @param {string} vesselId 
         * @param {File} [pointdata] 
         * @param {number} [campaign] 
         * @param {number} [heat] 
         * @param {string} [measurementTaken] 
         * @param {boolean} [viewOnly] 
         * @param {string} [vesselLining] 
         * @param {string} [liningCondition] 
         * @param {string} [liningMaintenanceType] 
         * @param {boolean} [hotMeasurement] 
         * @param {string} [notes] 
         * @param {string} [responsible] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postFerrotronuploadV2Vesselid(vesselId: string, pointdata?: File, campaign?: number, heat?: number, measurementTaken?: string, viewOnly?: boolean, vesselLining?: string, liningCondition?: string, liningMaintenanceType?: string, hotMeasurement?: boolean, notes?: string, responsible?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postFerrotronuploadV2Vesselid(vesselId, pointdata, campaign, heat, measurementTaken, viewOnly, vesselLining, liningCondition, liningMaintenanceType, hotMeasurement, notes, responsible, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementSystemsFilesUploadApi.postFerrotronuploadV2Vesselid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /HyperionUpload/raw/{vesselId} - POST
         * @param {string} vesselId 
         * @param {File} [raw] 
         * @param {File} [stl] 
         * @param {number} [campaign] 
         * @param {number} [heat] 
         * @param {string} [measurementTaken] 
         * @param {boolean} [viewOnly] 
         * @param {string} [vesselLining] 
         * @param {string} [liningCondition] 
         * @param {string} [liningMaintenanceType] 
         * @param {boolean} [hotMeasurement] 
         * @param {string} [notes] 
         * @param {string} [responsible] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postHyperionuploadRawVesselid(vesselId: string, raw?: File, stl?: File, campaign?: number, heat?: number, measurementTaken?: string, viewOnly?: boolean, vesselLining?: string, liningCondition?: string, liningMaintenanceType?: string, hotMeasurement?: boolean, notes?: string, responsible?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postHyperionuploadRawVesselid(vesselId, raw, stl, campaign, heat, measurementTaken, viewOnly, vesselLining, liningCondition, liningMaintenanceType, hotMeasurement, notes, responsible, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementSystemsFilesUploadApi.postHyperionuploadRawVesselid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /IMSIUpload/{vesselId} - POST
         * @param {string} vesselId 
         * @param {File} [pointdata] 
         * @param {number} [campaign] 
         * @param {number} [heat] 
         * @param {string} [measurementTaken] 
         * @param {boolean} [viewOnly] 
         * @param {string} [vesselLining] 
         * @param {string} [liningCondition] 
         * @param {string} [liningMaintenanceType] 
         * @param {boolean} [hotMeasurement] 
         * @param {string} [notes] 
         * @param {string} [responsible] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postImsiuploadVesselid(vesselId: string, pointdata?: File, campaign?: number, heat?: number, measurementTaken?: string, viewOnly?: boolean, vesselLining?: string, liningCondition?: string, liningMaintenanceType?: string, hotMeasurement?: boolean, notes?: string, responsible?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postImsiuploadVesselid(vesselId, pointdata, campaign, heat, measurementTaken, viewOnly, vesselLining, liningCondition, liningMaintenanceType, hotMeasurement, notes, responsible, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementSystemsFilesUploadApi.postImsiuploadVesselid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /LatitudeUpload/{vesselId} - POST
         * @param {string} vesselId 
         * @param {File} [pointdata] 
         * @param {number} [campaign] 
         * @param {number} [heat] 
         * @param {string} [measurementTaken] 
         * @param {boolean} [viewOnly] 
         * @param {string} [vesselLining] 
         * @param {string} [liningCondition] 
         * @param {string} [liningMaintenanceType] 
         * @param {boolean} [hotMeasurement] 
         * @param {string} [notes] 
         * @param {string} [responsible] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postLatitudeuploadVesselid(vesselId: string, pointdata?: File, campaign?: number, heat?: number, measurementTaken?: string, viewOnly?: boolean, vesselLining?: string, liningCondition?: string, liningMaintenanceType?: string, hotMeasurement?: boolean, notes?: string, responsible?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postLatitudeuploadVesselid(vesselId, pointdata, campaign, heat, measurementTaken, viewOnly, vesselLining, liningCondition, liningMaintenanceType, hotMeasurement, notes, responsible, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementSystemsFilesUploadApi.postLatitudeuploadVesselid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /ScaniverseUpload/{vesselId} - POST
         * @param {string} vesselId 
         * @param {File} [pointdata] 
         * @param {File} [mesh] 
         * @param {number} [campaign] 
         * @param {number} [heat] 
         * @param {string} [measurementTaken] 
         * @param {boolean} [viewOnly] 
         * @param {string} [vesselLining] 
         * @param {string} [liningCondition] 
         * @param {string} [liningMaintenanceType] 
         * @param {boolean} [hotMeasurement] 
         * @param {string} [notes] 
         * @param {string} [responsible] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postScaniverseuploadVesselid(vesselId: string, pointdata?: File, mesh?: File, campaign?: number, heat?: number, measurementTaken?: string, viewOnly?: boolean, vesselLining?: string, liningCondition?: string, liningMaintenanceType?: string, hotMeasurement?: boolean, notes?: string, responsible?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postScaniverseuploadVesselid(vesselId, pointdata, mesh, campaign, heat, measurementTaken, viewOnly, vesselLining, liningCondition, liningMaintenanceType, hotMeasurement, notes, responsible, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementSystemsFilesUploadApi.postScaniverseuploadVesselid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /VertexUpload/hyperion/{vesselId} - POST
         * @param {string} vesselId 
         * @param {File} [vertex] 
         * @param {File} [stl] 
         * @param {File} [summary] 
         * @param {number} [campaign] 
         * @param {number} [heat] 
         * @param {string} [measurementTaken] 
         * @param {boolean} [viewOnly] 
         * @param {string} [vesselLining] 
         * @param {string} [liningCondition] 
         * @param {string} [liningMaintenanceType] 
         * @param {boolean} [hotMeasurement] 
         * @param {string} [notes] 
         * @param {string} [responsible] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postVertexuploadHyperionVesselid(vesselId: string, vertex?: File, stl?: File, summary?: File, campaign?: number, heat?: number, measurementTaken?: string, viewOnly?: boolean, vesselLining?: string, liningCondition?: string, liningMaintenanceType?: string, hotMeasurement?: boolean, notes?: string, responsible?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postVertexuploadHyperionVesselid(vesselId, vertex, stl, summary, campaign, heat, measurementTaken, viewOnly, vesselLining, liningCondition, liningMaintenanceType, hotMeasurement, notes, responsible, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementSystemsFilesUploadApi.postVertexuploadHyperionVesselid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /VertexUpload/lcs/{vesselId} - POST
         * @param {string} vesselId 
         * @param {File} [vertex] 
         * @param {File} [stl] 
         * @param {File} [summary] 
         * @param {number} [campaign] 
         * @param {number} [heat] 
         * @param {string} [measurementTaken] 
         * @param {boolean} [viewOnly] 
         * @param {string} [vesselLining] 
         * @param {string} [liningCondition] 
         * @param {string} [liningMaintenanceType] 
         * @param {boolean} [hotMeasurement] 
         * @param {string} [notes] 
         * @param {string} [responsible] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postVertexuploadLcsVesselid(vesselId: string, vertex?: File, stl?: File, summary?: File, campaign?: number, heat?: number, measurementTaken?: string, viewOnly?: boolean, vesselLining?: string, liningCondition?: string, liningMaintenanceType?: string, hotMeasurement?: boolean, notes?: string, responsible?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postVertexuploadLcsVesselid(vesselId, vertex, stl, summary, campaign, heat, measurementTaken, viewOnly, vesselLining, liningCondition, liningMaintenanceType, hotMeasurement, notes, responsible, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementSystemsFilesUploadApi.postVertexuploadLcsVesselid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MeasurementSystemsFilesUploadApi - factory interface
 */
export const MeasurementSystemsFilesUploadApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MeasurementSystemsFilesUploadApiFp(configuration)
    return {
        /**
         * 
         * @summary /FerrotronUpload/v1/{vesselId} - POST
         * @param {string} vesselId 
         * @param {File} [pointdata] 
         * @param {number} [campaign] 
         * @param {number} [heat] 
         * @param {string} [measurementTaken] 
         * @param {boolean} [viewOnly] 
         * @param {string} [vesselLining] 
         * @param {string} [liningCondition] 
         * @param {string} [liningMaintenanceType] 
         * @param {boolean} [hotMeasurement] 
         * @param {string} [notes] 
         * @param {string} [responsible] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFerrotronuploadV1Vesselid(vesselId: string, pointdata?: File, campaign?: number, heat?: number, measurementTaken?: string, viewOnly?: boolean, vesselLining?: string, liningCondition?: string, liningMaintenanceType?: string, hotMeasurement?: boolean, notes?: string, responsible?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postFerrotronuploadV1Vesselid(vesselId, pointdata, campaign, heat, measurementTaken, viewOnly, vesselLining, liningCondition, liningMaintenanceType, hotMeasurement, notes, responsible, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /FerrotronUpload/v2/{vesselId} - POST
         * @param {string} vesselId 
         * @param {File} [pointdata] 
         * @param {number} [campaign] 
         * @param {number} [heat] 
         * @param {string} [measurementTaken] 
         * @param {boolean} [viewOnly] 
         * @param {string} [vesselLining] 
         * @param {string} [liningCondition] 
         * @param {string} [liningMaintenanceType] 
         * @param {boolean} [hotMeasurement] 
         * @param {string} [notes] 
         * @param {string} [responsible] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFerrotronuploadV2Vesselid(vesselId: string, pointdata?: File, campaign?: number, heat?: number, measurementTaken?: string, viewOnly?: boolean, vesselLining?: string, liningCondition?: string, liningMaintenanceType?: string, hotMeasurement?: boolean, notes?: string, responsible?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postFerrotronuploadV2Vesselid(vesselId, pointdata, campaign, heat, measurementTaken, viewOnly, vesselLining, liningCondition, liningMaintenanceType, hotMeasurement, notes, responsible, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /HyperionUpload/raw/{vesselId} - POST
         * @param {string} vesselId 
         * @param {File} [raw] 
         * @param {File} [stl] 
         * @param {number} [campaign] 
         * @param {number} [heat] 
         * @param {string} [measurementTaken] 
         * @param {boolean} [viewOnly] 
         * @param {string} [vesselLining] 
         * @param {string} [liningCondition] 
         * @param {string} [liningMaintenanceType] 
         * @param {boolean} [hotMeasurement] 
         * @param {string} [notes] 
         * @param {string} [responsible] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postHyperionuploadRawVesselid(vesselId: string, raw?: File, stl?: File, campaign?: number, heat?: number, measurementTaken?: string, viewOnly?: boolean, vesselLining?: string, liningCondition?: string, liningMaintenanceType?: string, hotMeasurement?: boolean, notes?: string, responsible?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postHyperionuploadRawVesselid(vesselId, raw, stl, campaign, heat, measurementTaken, viewOnly, vesselLining, liningCondition, liningMaintenanceType, hotMeasurement, notes, responsible, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /IMSIUpload/{vesselId} - POST
         * @param {string} vesselId 
         * @param {File} [pointdata] 
         * @param {number} [campaign] 
         * @param {number} [heat] 
         * @param {string} [measurementTaken] 
         * @param {boolean} [viewOnly] 
         * @param {string} [vesselLining] 
         * @param {string} [liningCondition] 
         * @param {string} [liningMaintenanceType] 
         * @param {boolean} [hotMeasurement] 
         * @param {string} [notes] 
         * @param {string} [responsible] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postImsiuploadVesselid(vesselId: string, pointdata?: File, campaign?: number, heat?: number, measurementTaken?: string, viewOnly?: boolean, vesselLining?: string, liningCondition?: string, liningMaintenanceType?: string, hotMeasurement?: boolean, notes?: string, responsible?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postImsiuploadVesselid(vesselId, pointdata, campaign, heat, measurementTaken, viewOnly, vesselLining, liningCondition, liningMaintenanceType, hotMeasurement, notes, responsible, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /LatitudeUpload/{vesselId} - POST
         * @param {string} vesselId 
         * @param {File} [pointdata] 
         * @param {number} [campaign] 
         * @param {number} [heat] 
         * @param {string} [measurementTaken] 
         * @param {boolean} [viewOnly] 
         * @param {string} [vesselLining] 
         * @param {string} [liningCondition] 
         * @param {string} [liningMaintenanceType] 
         * @param {boolean} [hotMeasurement] 
         * @param {string} [notes] 
         * @param {string} [responsible] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postLatitudeuploadVesselid(vesselId: string, pointdata?: File, campaign?: number, heat?: number, measurementTaken?: string, viewOnly?: boolean, vesselLining?: string, liningCondition?: string, liningMaintenanceType?: string, hotMeasurement?: boolean, notes?: string, responsible?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postLatitudeuploadVesselid(vesselId, pointdata, campaign, heat, measurementTaken, viewOnly, vesselLining, liningCondition, liningMaintenanceType, hotMeasurement, notes, responsible, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /ScaniverseUpload/{vesselId} - POST
         * @param {string} vesselId 
         * @param {File} [pointdata] 
         * @param {File} [mesh] 
         * @param {number} [campaign] 
         * @param {number} [heat] 
         * @param {string} [measurementTaken] 
         * @param {boolean} [viewOnly] 
         * @param {string} [vesselLining] 
         * @param {string} [liningCondition] 
         * @param {string} [liningMaintenanceType] 
         * @param {boolean} [hotMeasurement] 
         * @param {string} [notes] 
         * @param {string} [responsible] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postScaniverseuploadVesselid(vesselId: string, pointdata?: File, mesh?: File, campaign?: number, heat?: number, measurementTaken?: string, viewOnly?: boolean, vesselLining?: string, liningCondition?: string, liningMaintenanceType?: string, hotMeasurement?: boolean, notes?: string, responsible?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postScaniverseuploadVesselid(vesselId, pointdata, mesh, campaign, heat, measurementTaken, viewOnly, vesselLining, liningCondition, liningMaintenanceType, hotMeasurement, notes, responsible, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /VertexUpload/hyperion/{vesselId} - POST
         * @param {string} vesselId 
         * @param {File} [vertex] 
         * @param {File} [stl] 
         * @param {File} [summary] 
         * @param {number} [campaign] 
         * @param {number} [heat] 
         * @param {string} [measurementTaken] 
         * @param {boolean} [viewOnly] 
         * @param {string} [vesselLining] 
         * @param {string} [liningCondition] 
         * @param {string} [liningMaintenanceType] 
         * @param {boolean} [hotMeasurement] 
         * @param {string} [notes] 
         * @param {string} [responsible] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postVertexuploadHyperionVesselid(vesselId: string, vertex?: File, stl?: File, summary?: File, campaign?: number, heat?: number, measurementTaken?: string, viewOnly?: boolean, vesselLining?: string, liningCondition?: string, liningMaintenanceType?: string, hotMeasurement?: boolean, notes?: string, responsible?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postVertexuploadHyperionVesselid(vesselId, vertex, stl, summary, campaign, heat, measurementTaken, viewOnly, vesselLining, liningCondition, liningMaintenanceType, hotMeasurement, notes, responsible, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /VertexUpload/lcs/{vesselId} - POST
         * @param {string} vesselId 
         * @param {File} [vertex] 
         * @param {File} [stl] 
         * @param {File} [summary] 
         * @param {number} [campaign] 
         * @param {number} [heat] 
         * @param {string} [measurementTaken] 
         * @param {boolean} [viewOnly] 
         * @param {string} [vesselLining] 
         * @param {string} [liningCondition] 
         * @param {string} [liningMaintenanceType] 
         * @param {boolean} [hotMeasurement] 
         * @param {string} [notes] 
         * @param {string} [responsible] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postVertexuploadLcsVesselid(vesselId: string, vertex?: File, stl?: File, summary?: File, campaign?: number, heat?: number, measurementTaken?: string, viewOnly?: boolean, vesselLining?: string, liningCondition?: string, liningMaintenanceType?: string, hotMeasurement?: boolean, notes?: string, responsible?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postVertexuploadLcsVesselid(vesselId, vertex, stl, summary, campaign, heat, measurementTaken, viewOnly, vesselLining, liningCondition, liningMaintenanceType, hotMeasurement, notes, responsible, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MeasurementSystemsFilesUploadApi - object-oriented interface
 */
export class MeasurementSystemsFilesUploadApi extends BaseAPI {
    /**
     * 
     * @summary /FerrotronUpload/v1/{vesselId} - POST
     * @param {string} vesselId 
     * @param {File} [pointdata] 
     * @param {number} [campaign] 
     * @param {number} [heat] 
     * @param {string} [measurementTaken] 
     * @param {boolean} [viewOnly] 
     * @param {string} [vesselLining] 
     * @param {string} [liningCondition] 
     * @param {string} [liningMaintenanceType] 
     * @param {boolean} [hotMeasurement] 
     * @param {string} [notes] 
     * @param {string} [responsible] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postFerrotronuploadV1Vesselid(vesselId: string, pointdata?: File, campaign?: number, heat?: number, measurementTaken?: string, viewOnly?: boolean, vesselLining?: string, liningCondition?: string, liningMaintenanceType?: string, hotMeasurement?: boolean, notes?: string, responsible?: string, options?: RawAxiosRequestConfig) {
        return MeasurementSystemsFilesUploadApiFp(this.configuration).postFerrotronuploadV1Vesselid(vesselId, pointdata, campaign, heat, measurementTaken, viewOnly, vesselLining, liningCondition, liningMaintenanceType, hotMeasurement, notes, responsible, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /FerrotronUpload/v2/{vesselId} - POST
     * @param {string} vesselId 
     * @param {File} [pointdata] 
     * @param {number} [campaign] 
     * @param {number} [heat] 
     * @param {string} [measurementTaken] 
     * @param {boolean} [viewOnly] 
     * @param {string} [vesselLining] 
     * @param {string} [liningCondition] 
     * @param {string} [liningMaintenanceType] 
     * @param {boolean} [hotMeasurement] 
     * @param {string} [notes] 
     * @param {string} [responsible] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postFerrotronuploadV2Vesselid(vesselId: string, pointdata?: File, campaign?: number, heat?: number, measurementTaken?: string, viewOnly?: boolean, vesselLining?: string, liningCondition?: string, liningMaintenanceType?: string, hotMeasurement?: boolean, notes?: string, responsible?: string, options?: RawAxiosRequestConfig) {
        return MeasurementSystemsFilesUploadApiFp(this.configuration).postFerrotronuploadV2Vesselid(vesselId, pointdata, campaign, heat, measurementTaken, viewOnly, vesselLining, liningCondition, liningMaintenanceType, hotMeasurement, notes, responsible, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /HyperionUpload/raw/{vesselId} - POST
     * @param {string} vesselId 
     * @param {File} [raw] 
     * @param {File} [stl] 
     * @param {number} [campaign] 
     * @param {number} [heat] 
     * @param {string} [measurementTaken] 
     * @param {boolean} [viewOnly] 
     * @param {string} [vesselLining] 
     * @param {string} [liningCondition] 
     * @param {string} [liningMaintenanceType] 
     * @param {boolean} [hotMeasurement] 
     * @param {string} [notes] 
     * @param {string} [responsible] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postHyperionuploadRawVesselid(vesselId: string, raw?: File, stl?: File, campaign?: number, heat?: number, measurementTaken?: string, viewOnly?: boolean, vesselLining?: string, liningCondition?: string, liningMaintenanceType?: string, hotMeasurement?: boolean, notes?: string, responsible?: string, options?: RawAxiosRequestConfig) {
        return MeasurementSystemsFilesUploadApiFp(this.configuration).postHyperionuploadRawVesselid(vesselId, raw, stl, campaign, heat, measurementTaken, viewOnly, vesselLining, liningCondition, liningMaintenanceType, hotMeasurement, notes, responsible, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /IMSIUpload/{vesselId} - POST
     * @param {string} vesselId 
     * @param {File} [pointdata] 
     * @param {number} [campaign] 
     * @param {number} [heat] 
     * @param {string} [measurementTaken] 
     * @param {boolean} [viewOnly] 
     * @param {string} [vesselLining] 
     * @param {string} [liningCondition] 
     * @param {string} [liningMaintenanceType] 
     * @param {boolean} [hotMeasurement] 
     * @param {string} [notes] 
     * @param {string} [responsible] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postImsiuploadVesselid(vesselId: string, pointdata?: File, campaign?: number, heat?: number, measurementTaken?: string, viewOnly?: boolean, vesselLining?: string, liningCondition?: string, liningMaintenanceType?: string, hotMeasurement?: boolean, notes?: string, responsible?: string, options?: RawAxiosRequestConfig) {
        return MeasurementSystemsFilesUploadApiFp(this.configuration).postImsiuploadVesselid(vesselId, pointdata, campaign, heat, measurementTaken, viewOnly, vesselLining, liningCondition, liningMaintenanceType, hotMeasurement, notes, responsible, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /LatitudeUpload/{vesselId} - POST
     * @param {string} vesselId 
     * @param {File} [pointdata] 
     * @param {number} [campaign] 
     * @param {number} [heat] 
     * @param {string} [measurementTaken] 
     * @param {boolean} [viewOnly] 
     * @param {string} [vesselLining] 
     * @param {string} [liningCondition] 
     * @param {string} [liningMaintenanceType] 
     * @param {boolean} [hotMeasurement] 
     * @param {string} [notes] 
     * @param {string} [responsible] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postLatitudeuploadVesselid(vesselId: string, pointdata?: File, campaign?: number, heat?: number, measurementTaken?: string, viewOnly?: boolean, vesselLining?: string, liningCondition?: string, liningMaintenanceType?: string, hotMeasurement?: boolean, notes?: string, responsible?: string, options?: RawAxiosRequestConfig) {
        return MeasurementSystemsFilesUploadApiFp(this.configuration).postLatitudeuploadVesselid(vesselId, pointdata, campaign, heat, measurementTaken, viewOnly, vesselLining, liningCondition, liningMaintenanceType, hotMeasurement, notes, responsible, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /ScaniverseUpload/{vesselId} - POST
     * @param {string} vesselId 
     * @param {File} [pointdata] 
     * @param {File} [mesh] 
     * @param {number} [campaign] 
     * @param {number} [heat] 
     * @param {string} [measurementTaken] 
     * @param {boolean} [viewOnly] 
     * @param {string} [vesselLining] 
     * @param {string} [liningCondition] 
     * @param {string} [liningMaintenanceType] 
     * @param {boolean} [hotMeasurement] 
     * @param {string} [notes] 
     * @param {string} [responsible] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postScaniverseuploadVesselid(vesselId: string, pointdata?: File, mesh?: File, campaign?: number, heat?: number, measurementTaken?: string, viewOnly?: boolean, vesselLining?: string, liningCondition?: string, liningMaintenanceType?: string, hotMeasurement?: boolean, notes?: string, responsible?: string, options?: RawAxiosRequestConfig) {
        return MeasurementSystemsFilesUploadApiFp(this.configuration).postScaniverseuploadVesselid(vesselId, pointdata, mesh, campaign, heat, measurementTaken, viewOnly, vesselLining, liningCondition, liningMaintenanceType, hotMeasurement, notes, responsible, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /VertexUpload/hyperion/{vesselId} - POST
     * @param {string} vesselId 
     * @param {File} [vertex] 
     * @param {File} [stl] 
     * @param {File} [summary] 
     * @param {number} [campaign] 
     * @param {number} [heat] 
     * @param {string} [measurementTaken] 
     * @param {boolean} [viewOnly] 
     * @param {string} [vesselLining] 
     * @param {string} [liningCondition] 
     * @param {string} [liningMaintenanceType] 
     * @param {boolean} [hotMeasurement] 
     * @param {string} [notes] 
     * @param {string} [responsible] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postVertexuploadHyperionVesselid(vesselId: string, vertex?: File, stl?: File, summary?: File, campaign?: number, heat?: number, measurementTaken?: string, viewOnly?: boolean, vesselLining?: string, liningCondition?: string, liningMaintenanceType?: string, hotMeasurement?: boolean, notes?: string, responsible?: string, options?: RawAxiosRequestConfig) {
        return MeasurementSystemsFilesUploadApiFp(this.configuration).postVertexuploadHyperionVesselid(vesselId, vertex, stl, summary, campaign, heat, measurementTaken, viewOnly, vesselLining, liningCondition, liningMaintenanceType, hotMeasurement, notes, responsible, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /VertexUpload/lcs/{vesselId} - POST
     * @param {string} vesselId 
     * @param {File} [vertex] 
     * @param {File} [stl] 
     * @param {File} [summary] 
     * @param {number} [campaign] 
     * @param {number} [heat] 
     * @param {string} [measurementTaken] 
     * @param {boolean} [viewOnly] 
     * @param {string} [vesselLining] 
     * @param {string} [liningCondition] 
     * @param {string} [liningMaintenanceType] 
     * @param {boolean} [hotMeasurement] 
     * @param {string} [notes] 
     * @param {string} [responsible] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postVertexuploadLcsVesselid(vesselId: string, vertex?: File, stl?: File, summary?: File, campaign?: number, heat?: number, measurementTaken?: string, viewOnly?: boolean, vesselLining?: string, liningCondition?: string, liningMaintenanceType?: string, hotMeasurement?: boolean, notes?: string, responsible?: string, options?: RawAxiosRequestConfig) {
        return MeasurementSystemsFilesUploadApiFp(this.configuration).postVertexuploadLcsVesselid(vesselId, vertex, stl, summary, campaign, heat, measurementTaken, viewOnly, vesselLining, liningCondition, liningMaintenanceType, hotMeasurement, notes, responsible, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MeasurementViewApi - axios parameter creator
 */
export const MeasurementViewApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary /MeasurementView/file/{measurementId}/3d - GET
         * @param {string} measurementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementviewFileMeasurementid3d: async (measurementId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'measurementId' is not null or undefined
            assertParamExists('getMeasurementviewFileMeasurementid3d', 'measurementId', measurementId)
            const localVarPath = `/MeasurementView/file/{measurementId}/3d`
                .replace('{measurementId}', encodeURIComponent(String(measurementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /MeasurementView/file/{measurementId}/bottomplot - GET
         * @param {string} measurementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementviewFileMeasurementidBottomplot: async (measurementId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'measurementId' is not null or undefined
            assertParamExists('getMeasurementviewFileMeasurementidBottomplot', 'measurementId', measurementId)
            const localVarPath = `/MeasurementView/file/{measurementId}/bottomplot`
                .replace('{measurementId}', encodeURIComponent(String(measurementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /MeasurementView/file/{measurementId}/meta - GET
         * @param {string} measurementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementviewFileMeasurementidMeta: async (measurementId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'measurementId' is not null or undefined
            assertParamExists('getMeasurementviewFileMeasurementidMeta', 'measurementId', measurementId)
            const localVarPath = `/MeasurementView/file/{measurementId}/meta`
                .replace('{measurementId}', encodeURIComponent(String(measurementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /MeasurementView/file/{measurementId}/rbl - GET
         * @param {string} measurementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementviewFileMeasurementidRbl: async (measurementId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'measurementId' is not null or undefined
            assertParamExists('getMeasurementviewFileMeasurementidRbl', 'measurementId', measurementId)
            const localVarPath = `/MeasurementView/file/{measurementId}/rbl`
                .replace('{measurementId}', encodeURIComponent(String(measurementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /MeasurementView/file/{measurementId}/sectioncuts - GET
         * @param {string} measurementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementviewFileMeasurementidSectioncuts: async (measurementId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'measurementId' is not null or undefined
            assertParamExists('getMeasurementviewFileMeasurementidSectioncuts', 'measurementId', measurementId)
            const localVarPath = `/MeasurementView/file/{measurementId}/sectioncuts`
                .replace('{measurementId}', encodeURIComponent(String(measurementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /MeasurementView/file/{measurementId}/viewpointcloud - GET
         * @param {string} measurementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementviewFileMeasurementidViewpointcloud: async (measurementId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'measurementId' is not null or undefined
            assertParamExists('getMeasurementviewFileMeasurementidViewpointcloud', 'measurementId', measurementId)
            const localVarPath = `/MeasurementView/file/{measurementId}/viewpointcloud`
                .replace('{measurementId}', encodeURIComponent(String(measurementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /MeasurementView/file/{measurementId}/wallplot - GET
         * @param {string} measurementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementviewFileMeasurementidWallplot: async (measurementId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'measurementId' is not null or undefined
            assertParamExists('getMeasurementviewFileMeasurementidWallplot', 'measurementId', measurementId)
            const localVarPath = `/MeasurementView/file/{measurementId}/wallplot`
                .replace('{measurementId}', encodeURIComponent(String(measurementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /MeasurementView/file/{measurementId}/wear - GET
         * @param {string} measurementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementviewFileMeasurementidWear: async (measurementId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'measurementId' is not null or undefined
            assertParamExists('getMeasurementviewFileMeasurementidWear', 'measurementId', measurementId)
            const localVarPath = `/MeasurementView/file/{measurementId}/wear`
                .replace('{measurementId}', encodeURIComponent(String(measurementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /MeasurementView/file/{measurementId}/wearrate-bas - GET
         * @param {string} measurementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementviewFileMeasurementidWearrateBas: async (measurementId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'measurementId' is not null or undefined
            assertParamExists('getMeasurementviewFileMeasurementidWearrateBas', 'measurementId', measurementId)
            const localVarPath = `/MeasurementView/file/{measurementId}/wearrate-bas`
                .replace('{measurementId}', encodeURIComponent(String(measurementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /MeasurementView/file/{measurementId}/wearrate-eff - GET
         * @param {string} measurementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementviewFileMeasurementidWearrateEff: async (measurementId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'measurementId' is not null or undefined
            assertParamExists('getMeasurementviewFileMeasurementidWearrateEff', 'measurementId', measurementId)
            const localVarPath = `/MeasurementView/file/{measurementId}/wearrate-eff`
                .replace('{measurementId}', encodeURIComponent(String(measurementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /MeasurementView/file/{measurementId}/wearrate-inst - GET
         * @param {string} measurementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementviewFileMeasurementidWearrateInst: async (measurementId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'measurementId' is not null or undefined
            assertParamExists('getMeasurementviewFileMeasurementidWearrateInst', 'measurementId', measurementId)
            const localVarPath = `/MeasurementView/file/{measurementId}/wearrate-inst`
                .replace('{measurementId}', encodeURIComponent(String(measurementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /MeasurementView/{measurementId}/details - GET
         * @param {string} measurementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementviewMeasurementidDetails: async (measurementId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'measurementId' is not null or undefined
            assertParamExists('getMeasurementviewMeasurementidDetails', 'measurementId', measurementId)
            const localVarPath = `/MeasurementView/{measurementId}/details`
                .replace('{measurementId}', encodeURIComponent(String(measurementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /MeasurementView/settings/{customerId}/{vesselType} - GET
         * @param {string} customerId 
         * @param {string} vesselType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementviewSettingsCustomeridVesseltype: async (customerId: string, vesselType: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getMeasurementviewSettingsCustomeridVesseltype', 'customerId', customerId)
            // verify required parameter 'vesselType' is not null or undefined
            assertParamExists('getMeasurementviewSettingsCustomeridVesseltype', 'vesselType', vesselType)
            const localVarPath = `/MeasurementView/settings/{customerId}/{vesselType}`
                .replace('{customerId}', encodeURIComponent(String(customerId)))
                .replace('{vesselType}', encodeURIComponent(String(vesselType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /MeasurementView/settings/edit/{vesselId} - GET
         * @param {string} vesselId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementviewSettingsEditVesselid: async (vesselId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getMeasurementviewSettingsEditVesselid', 'vesselId', vesselId)
            const localVarPath = `/MeasurementView/settings/edit/{vesselId}`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /MeasurementView/settings/{vesselId} - GET
         * @param {string} vesselId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementviewSettingsVesselid: async (vesselId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getMeasurementviewSettingsVesselid', 'vesselId', vesselId)
            const localVarPath = `/MeasurementView/settings/{vesselId}`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /MeasurementView/{vesselId}/campaigns - GET
         * @param {string} vesselId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementviewVesselidCampaigns: async (vesselId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getMeasurementviewVesselidCampaigns', 'vesselId', vesselId)
            const localVarPath = `/MeasurementView/{vesselId}/campaigns`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /MeasurementView/{vesselId}/measurements/by-notes - GET
         * @param {string} vesselId 
         * @param {string} [notes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementviewVesselidMeasurementsByNotes: async (vesselId: string, notes?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getMeasurementviewVesselidMeasurementsByNotes', 'vesselId', vesselId)
            const localVarPath = `/MeasurementView/{vesselId}/measurements/by-notes`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (notes !== undefined) {
                localVarQueryParameter['notes'] = notes;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /MeasurementView/{vesselId}/measurements/by-notes-exact - GET
         * @param {string} vesselId 
         * @param {string} [notes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementviewVesselidMeasurementsByNotesExact: async (vesselId: string, notes?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getMeasurementviewVesselidMeasurementsByNotesExact', 'vesselId', vesselId)
            const localVarPath = `/MeasurementView/{vesselId}/measurements/by-notes-exact`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (notes !== undefined) {
                localVarQueryParameter['notes'] = notes;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /MeasurementView/{vesselId}/measurements/{campaign} - GET
         * @param {string} vesselId 
         * @param {number} campaign 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementviewVesselidMeasurementsCampaign: async (vesselId: string, campaign: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getMeasurementviewVesselidMeasurementsCampaign', 'vesselId', vesselId)
            // verify required parameter 'campaign' is not null or undefined
            assertParamExists('getMeasurementviewVesselidMeasurementsCampaign', 'campaign', campaign)
            const localVarPath = `/MeasurementView/{vesselId}/measurements/{campaign}`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)))
                .replace('{campaign}', encodeURIComponent(String(campaign)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /MeasurementView/{vesselId}/vessel - GET
         * @param {string} vesselId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementviewVesselidVessel: async (vesselId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getMeasurementviewVesselidVessel', 'vesselId', vesselId)
            const localVarPath = `/MeasurementView/{vesselId}/vessel`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /MeasurementView/vessels/{customerId} - GET
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementviewVesselsCustomerid: async (customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getMeasurementviewVesselsCustomerid', 'customerId', customerId)
            const localVarPath = `/MeasurementView/vessels/{customerId}`
                .replace('{customerId}', encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /MeasurementView/settings/{customerId}/{vesselType} - POST
         * @param {string} customerId 
         * @param {string} vesselType 
         * @param {RHIMMeasurementServiceApiV1ModelsView3dSettingsDto} [rHIMMeasurementServiceApiV1ModelsView3dSettingsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMeasurementviewSettingsCustomeridVesseltype: async (customerId: string, vesselType: string, rHIMMeasurementServiceApiV1ModelsView3dSettingsDto?: RHIMMeasurementServiceApiV1ModelsView3dSettingsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('postMeasurementviewSettingsCustomeridVesseltype', 'customerId', customerId)
            // verify required parameter 'vesselType' is not null or undefined
            assertParamExists('postMeasurementviewSettingsCustomeridVesseltype', 'vesselType', vesselType)
            const localVarPath = `/MeasurementView/settings/{customerId}/{vesselType}`
                .replace('{customerId}', encodeURIComponent(String(customerId)))
                .replace('{vesselType}', encodeURIComponent(String(vesselType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMMeasurementServiceApiV1ModelsView3dSettingsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /MeasurementView/settings/edit/{vesselId} - POST
         * @param {string} vesselId 
         * @param {RHIMMeasurementServiceApiV1ModelsView3dSettingsVesselUpdateDto} [rHIMMeasurementServiceApiV1ModelsView3dSettingsVesselUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMeasurementviewSettingsEditVesselid: async (vesselId: string, rHIMMeasurementServiceApiV1ModelsView3dSettingsVesselUpdateDto?: RHIMMeasurementServiceApiV1ModelsView3dSettingsVesselUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('postMeasurementviewSettingsEditVesselid', 'vesselId', vesselId)
            const localVarPath = `/MeasurementView/settings/edit/{vesselId}`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMMeasurementServiceApiV1ModelsView3dSettingsVesselUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MeasurementViewApi - functional programming interface
 */
export const MeasurementViewApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MeasurementViewApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary /MeasurementView/file/{measurementId}/3d - GET
         * @param {string} measurementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeasurementviewFileMeasurementid3d(measurementId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeasurementviewFileMeasurementid3d(measurementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementViewApi.getMeasurementviewFileMeasurementid3d']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /MeasurementView/file/{measurementId}/bottomplot - GET
         * @param {string} measurementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeasurementviewFileMeasurementidBottomplot(measurementId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMMeasurementServiceApiV1ModelsBottomPlotDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeasurementviewFileMeasurementidBottomplot(measurementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementViewApi.getMeasurementviewFileMeasurementidBottomplot']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /MeasurementView/file/{measurementId}/meta - GET
         * @param {string} measurementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeasurementviewFileMeasurementidMeta(measurementId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMMeasurementServiceApiV1ModelsMeasurementMetadataDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeasurementviewFileMeasurementidMeta(measurementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementViewApi.getMeasurementviewFileMeasurementidMeta']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /MeasurementView/file/{measurementId}/rbl - GET
         * @param {string} measurementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeasurementviewFileMeasurementidRbl(measurementId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<number>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeasurementviewFileMeasurementidRbl(measurementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementViewApi.getMeasurementviewFileMeasurementidRbl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /MeasurementView/file/{measurementId}/sectioncuts - GET
         * @param {string} measurementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeasurementviewFileMeasurementidSectioncuts(measurementId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMMeasurementServiceApiV1ModelsSectionCutsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeasurementviewFileMeasurementidSectioncuts(measurementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementViewApi.getMeasurementviewFileMeasurementidSectioncuts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /MeasurementView/file/{measurementId}/viewpointcloud - GET
         * @param {string} measurementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeasurementviewFileMeasurementidViewpointcloud(measurementId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeasurementviewFileMeasurementidViewpointcloud(measurementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementViewApi.getMeasurementviewFileMeasurementidViewpointcloud']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /MeasurementView/file/{measurementId}/wallplot - GET
         * @param {string} measurementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeasurementviewFileMeasurementidWallplot(measurementId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMMeasurementServiceApiV1ModelsWallPlotDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeasurementviewFileMeasurementidWallplot(measurementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementViewApi.getMeasurementviewFileMeasurementidWallplot']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /MeasurementView/file/{measurementId}/wear - GET
         * @param {string} measurementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeasurementviewFileMeasurementidWear(measurementId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<number>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeasurementviewFileMeasurementidWear(measurementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementViewApi.getMeasurementviewFileMeasurementidWear']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /MeasurementView/file/{measurementId}/wearrate-bas - GET
         * @param {string} measurementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeasurementviewFileMeasurementidWearrateBas(measurementId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<number>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeasurementviewFileMeasurementidWearrateBas(measurementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementViewApi.getMeasurementviewFileMeasurementidWearrateBas']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /MeasurementView/file/{measurementId}/wearrate-eff - GET
         * @param {string} measurementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeasurementviewFileMeasurementidWearrateEff(measurementId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<number>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeasurementviewFileMeasurementidWearrateEff(measurementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementViewApi.getMeasurementviewFileMeasurementidWearrateEff']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /MeasurementView/file/{measurementId}/wearrate-inst - GET
         * @param {string} measurementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeasurementviewFileMeasurementidWearrateInst(measurementId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<number>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeasurementviewFileMeasurementidWearrateInst(measurementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementViewApi.getMeasurementviewFileMeasurementidWearrateInst']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /MeasurementView/{measurementId}/details - GET
         * @param {string} measurementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeasurementviewMeasurementidDetails(measurementId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMMeasurementServiceApiV1ModelsMeasurementViewDataDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeasurementviewMeasurementidDetails(measurementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementViewApi.getMeasurementviewMeasurementidDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /MeasurementView/settings/{customerId}/{vesselType} - GET
         * @param {string} customerId 
         * @param {string} vesselType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeasurementviewSettingsCustomeridVesseltype(customerId: string, vesselType: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMMeasurementServiceApiV1ModelsView3dSettingsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeasurementviewSettingsCustomeridVesseltype(customerId, vesselType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementViewApi.getMeasurementviewSettingsCustomeridVesseltype']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /MeasurementView/settings/edit/{vesselId} - GET
         * @param {string} vesselId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeasurementviewSettingsEditVesselid(vesselId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMMeasurementServiceApiV1ModelsView3dSettingsVesselDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeasurementviewSettingsEditVesselid(vesselId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementViewApi.getMeasurementviewSettingsEditVesselid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /MeasurementView/settings/{vesselId} - GET
         * @param {string} vesselId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeasurementviewSettingsVesselid(vesselId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMMeasurementServiceApiV1ModelsView3dSettingsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeasurementviewSettingsVesselid(vesselId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementViewApi.getMeasurementviewSettingsVesselid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /MeasurementView/{vesselId}/campaigns - GET
         * @param {string} vesselId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeasurementviewVesselidCampaigns(vesselId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMMeasurementServiceApiV1ModelsCampaignDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeasurementviewVesselidCampaigns(vesselId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementViewApi.getMeasurementviewVesselidCampaigns']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /MeasurementView/{vesselId}/measurements/by-notes - GET
         * @param {string} vesselId 
         * @param {string} [notes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeasurementviewVesselidMeasurementsByNotes(vesselId: string, notes?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMMeasurementServiceApiV1ModelsMeasurementViewDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeasurementviewVesselidMeasurementsByNotes(vesselId, notes, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementViewApi.getMeasurementviewVesselidMeasurementsByNotes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /MeasurementView/{vesselId}/measurements/by-notes-exact - GET
         * @param {string} vesselId 
         * @param {string} [notes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeasurementviewVesselidMeasurementsByNotesExact(vesselId: string, notes?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMMeasurementServiceApiV1ModelsMeasurementViewDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeasurementviewVesselidMeasurementsByNotesExact(vesselId, notes, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementViewApi.getMeasurementviewVesselidMeasurementsByNotesExact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /MeasurementView/{vesselId}/measurements/{campaign} - GET
         * @param {string} vesselId 
         * @param {number} campaign 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeasurementviewVesselidMeasurementsCampaign(vesselId: string, campaign: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMMeasurementServiceApiV1ModelsMeasurementViewDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeasurementviewVesselidMeasurementsCampaign(vesselId, campaign, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementViewApi.getMeasurementviewVesselidMeasurementsCampaign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /MeasurementView/{vesselId}/vessel - GET
         * @param {string} vesselId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeasurementviewVesselidVessel(vesselId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMMeasurementServiceApiV1ModelsMeasurementViewVesselDataDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeasurementviewVesselidVessel(vesselId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementViewApi.getMeasurementviewVesselidVessel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /MeasurementView/vessels/{customerId} - GET
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeasurementviewVesselsCustomerid(customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMHMDCustomerManagementContractsV1VesselVesselDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeasurementviewVesselsCustomerid(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementViewApi.getMeasurementviewVesselsCustomerid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /MeasurementView/settings/{customerId}/{vesselType} - POST
         * @param {string} customerId 
         * @param {string} vesselType 
         * @param {RHIMMeasurementServiceApiV1ModelsView3dSettingsDto} [rHIMMeasurementServiceApiV1ModelsView3dSettingsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postMeasurementviewSettingsCustomeridVesseltype(customerId: string, vesselType: string, rHIMMeasurementServiceApiV1ModelsView3dSettingsDto?: RHIMMeasurementServiceApiV1ModelsView3dSettingsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postMeasurementviewSettingsCustomeridVesseltype(customerId, vesselType, rHIMMeasurementServiceApiV1ModelsView3dSettingsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementViewApi.postMeasurementviewSettingsCustomeridVesseltype']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /MeasurementView/settings/edit/{vesselId} - POST
         * @param {string} vesselId 
         * @param {RHIMMeasurementServiceApiV1ModelsView3dSettingsVesselUpdateDto} [rHIMMeasurementServiceApiV1ModelsView3dSettingsVesselUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postMeasurementviewSettingsEditVesselid(vesselId: string, rHIMMeasurementServiceApiV1ModelsView3dSettingsVesselUpdateDto?: RHIMMeasurementServiceApiV1ModelsView3dSettingsVesselUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postMeasurementviewSettingsEditVesselid(vesselId, rHIMMeasurementServiceApiV1ModelsView3dSettingsVesselUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementViewApi.postMeasurementviewSettingsEditVesselid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MeasurementViewApi - factory interface
 */
export const MeasurementViewApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MeasurementViewApiFp(configuration)
    return {
        /**
         * 
         * @summary /MeasurementView/file/{measurementId}/3d - GET
         * @param {string} measurementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementviewFileMeasurementid3d(measurementId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getMeasurementviewFileMeasurementid3d(measurementId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /MeasurementView/file/{measurementId}/bottomplot - GET
         * @param {string} measurementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementviewFileMeasurementidBottomplot(measurementId: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMMeasurementServiceApiV1ModelsBottomPlotDto> {
            return localVarFp.getMeasurementviewFileMeasurementidBottomplot(measurementId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /MeasurementView/file/{measurementId}/meta - GET
         * @param {string} measurementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementviewFileMeasurementidMeta(measurementId: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMMeasurementServiceApiV1ModelsMeasurementMetadataDto> {
            return localVarFp.getMeasurementviewFileMeasurementidMeta(measurementId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /MeasurementView/file/{measurementId}/rbl - GET
         * @param {string} measurementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementviewFileMeasurementidRbl(measurementId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<number>> {
            return localVarFp.getMeasurementviewFileMeasurementidRbl(measurementId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /MeasurementView/file/{measurementId}/sectioncuts - GET
         * @param {string} measurementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementviewFileMeasurementidSectioncuts(measurementId: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMMeasurementServiceApiV1ModelsSectionCutsDto> {
            return localVarFp.getMeasurementviewFileMeasurementidSectioncuts(measurementId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /MeasurementView/file/{measurementId}/viewpointcloud - GET
         * @param {string} measurementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementviewFileMeasurementidViewpointcloud(measurementId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getMeasurementviewFileMeasurementidViewpointcloud(measurementId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /MeasurementView/file/{measurementId}/wallplot - GET
         * @param {string} measurementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementviewFileMeasurementidWallplot(measurementId: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMMeasurementServiceApiV1ModelsWallPlotDto> {
            return localVarFp.getMeasurementviewFileMeasurementidWallplot(measurementId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /MeasurementView/file/{measurementId}/wear - GET
         * @param {string} measurementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementviewFileMeasurementidWear(measurementId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<number>> {
            return localVarFp.getMeasurementviewFileMeasurementidWear(measurementId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /MeasurementView/file/{measurementId}/wearrate-bas - GET
         * @param {string} measurementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementviewFileMeasurementidWearrateBas(measurementId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<number>> {
            return localVarFp.getMeasurementviewFileMeasurementidWearrateBas(measurementId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /MeasurementView/file/{measurementId}/wearrate-eff - GET
         * @param {string} measurementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementviewFileMeasurementidWearrateEff(measurementId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<number>> {
            return localVarFp.getMeasurementviewFileMeasurementidWearrateEff(measurementId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /MeasurementView/file/{measurementId}/wearrate-inst - GET
         * @param {string} measurementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementviewFileMeasurementidWearrateInst(measurementId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<number>> {
            return localVarFp.getMeasurementviewFileMeasurementidWearrateInst(measurementId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /MeasurementView/{measurementId}/details - GET
         * @param {string} measurementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementviewMeasurementidDetails(measurementId: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMMeasurementServiceApiV1ModelsMeasurementViewDataDto> {
            return localVarFp.getMeasurementviewMeasurementidDetails(measurementId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /MeasurementView/settings/{customerId}/{vesselType} - GET
         * @param {string} customerId 
         * @param {string} vesselType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementviewSettingsCustomeridVesseltype(customerId: string, vesselType: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMMeasurementServiceApiV1ModelsView3dSettingsDto> {
            return localVarFp.getMeasurementviewSettingsCustomeridVesseltype(customerId, vesselType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /MeasurementView/settings/edit/{vesselId} - GET
         * @param {string} vesselId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementviewSettingsEditVesselid(vesselId: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMMeasurementServiceApiV1ModelsView3dSettingsVesselDto> {
            return localVarFp.getMeasurementviewSettingsEditVesselid(vesselId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /MeasurementView/settings/{vesselId} - GET
         * @param {string} vesselId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementviewSettingsVesselid(vesselId: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMMeasurementServiceApiV1ModelsView3dSettingsDto> {
            return localVarFp.getMeasurementviewSettingsVesselid(vesselId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /MeasurementView/{vesselId}/campaigns - GET
         * @param {string} vesselId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementviewVesselidCampaigns(vesselId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMMeasurementServiceApiV1ModelsCampaignDto>> {
            return localVarFp.getMeasurementviewVesselidCampaigns(vesselId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /MeasurementView/{vesselId}/measurements/by-notes - GET
         * @param {string} vesselId 
         * @param {string} [notes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementviewVesselidMeasurementsByNotes(vesselId: string, notes?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMMeasurementServiceApiV1ModelsMeasurementViewDto>> {
            return localVarFp.getMeasurementviewVesselidMeasurementsByNotes(vesselId, notes, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /MeasurementView/{vesselId}/measurements/by-notes-exact - GET
         * @param {string} vesselId 
         * @param {string} [notes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementviewVesselidMeasurementsByNotesExact(vesselId: string, notes?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMMeasurementServiceApiV1ModelsMeasurementViewDto>> {
            return localVarFp.getMeasurementviewVesselidMeasurementsByNotesExact(vesselId, notes, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /MeasurementView/{vesselId}/measurements/{campaign} - GET
         * @param {string} vesselId 
         * @param {number} campaign 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementviewVesselidMeasurementsCampaign(vesselId: string, campaign: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMMeasurementServiceApiV1ModelsMeasurementViewDto>> {
            return localVarFp.getMeasurementviewVesselidMeasurementsCampaign(vesselId, campaign, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /MeasurementView/{vesselId}/vessel - GET
         * @param {string} vesselId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementviewVesselidVessel(vesselId: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMMeasurementServiceApiV1ModelsMeasurementViewVesselDataDto> {
            return localVarFp.getMeasurementviewVesselidVessel(vesselId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /MeasurementView/vessels/{customerId} - GET
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementviewVesselsCustomerid(customerId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMHMDCustomerManagementContractsV1VesselVesselDto>> {
            return localVarFp.getMeasurementviewVesselsCustomerid(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /MeasurementView/settings/{customerId}/{vesselType} - POST
         * @param {string} customerId 
         * @param {string} vesselType 
         * @param {RHIMMeasurementServiceApiV1ModelsView3dSettingsDto} [rHIMMeasurementServiceApiV1ModelsView3dSettingsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMeasurementviewSettingsCustomeridVesseltype(customerId: string, vesselType: string, rHIMMeasurementServiceApiV1ModelsView3dSettingsDto?: RHIMMeasurementServiceApiV1ModelsView3dSettingsDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postMeasurementviewSettingsCustomeridVesseltype(customerId, vesselType, rHIMMeasurementServiceApiV1ModelsView3dSettingsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /MeasurementView/settings/edit/{vesselId} - POST
         * @param {string} vesselId 
         * @param {RHIMMeasurementServiceApiV1ModelsView3dSettingsVesselUpdateDto} [rHIMMeasurementServiceApiV1ModelsView3dSettingsVesselUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMeasurementviewSettingsEditVesselid(vesselId: string, rHIMMeasurementServiceApiV1ModelsView3dSettingsVesselUpdateDto?: RHIMMeasurementServiceApiV1ModelsView3dSettingsVesselUpdateDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postMeasurementviewSettingsEditVesselid(vesselId, rHIMMeasurementServiceApiV1ModelsView3dSettingsVesselUpdateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MeasurementViewApi - object-oriented interface
 */
export class MeasurementViewApi extends BaseAPI {
    /**
     * 
     * @summary /MeasurementView/file/{measurementId}/3d - GET
     * @param {string} measurementId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMeasurementviewFileMeasurementid3d(measurementId: string, options?: RawAxiosRequestConfig) {
        return MeasurementViewApiFp(this.configuration).getMeasurementviewFileMeasurementid3d(measurementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /MeasurementView/file/{measurementId}/bottomplot - GET
     * @param {string} measurementId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMeasurementviewFileMeasurementidBottomplot(measurementId: string, options?: RawAxiosRequestConfig) {
        return MeasurementViewApiFp(this.configuration).getMeasurementviewFileMeasurementidBottomplot(measurementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /MeasurementView/file/{measurementId}/meta - GET
     * @param {string} measurementId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMeasurementviewFileMeasurementidMeta(measurementId: string, options?: RawAxiosRequestConfig) {
        return MeasurementViewApiFp(this.configuration).getMeasurementviewFileMeasurementidMeta(measurementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /MeasurementView/file/{measurementId}/rbl - GET
     * @param {string} measurementId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMeasurementviewFileMeasurementidRbl(measurementId: string, options?: RawAxiosRequestConfig) {
        return MeasurementViewApiFp(this.configuration).getMeasurementviewFileMeasurementidRbl(measurementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /MeasurementView/file/{measurementId}/sectioncuts - GET
     * @param {string} measurementId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMeasurementviewFileMeasurementidSectioncuts(measurementId: string, options?: RawAxiosRequestConfig) {
        return MeasurementViewApiFp(this.configuration).getMeasurementviewFileMeasurementidSectioncuts(measurementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /MeasurementView/file/{measurementId}/viewpointcloud - GET
     * @param {string} measurementId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMeasurementviewFileMeasurementidViewpointcloud(measurementId: string, options?: RawAxiosRequestConfig) {
        return MeasurementViewApiFp(this.configuration).getMeasurementviewFileMeasurementidViewpointcloud(measurementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /MeasurementView/file/{measurementId}/wallplot - GET
     * @param {string} measurementId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMeasurementviewFileMeasurementidWallplot(measurementId: string, options?: RawAxiosRequestConfig) {
        return MeasurementViewApiFp(this.configuration).getMeasurementviewFileMeasurementidWallplot(measurementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /MeasurementView/file/{measurementId}/wear - GET
     * @param {string} measurementId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMeasurementviewFileMeasurementidWear(measurementId: string, options?: RawAxiosRequestConfig) {
        return MeasurementViewApiFp(this.configuration).getMeasurementviewFileMeasurementidWear(measurementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /MeasurementView/file/{measurementId}/wearrate-bas - GET
     * @param {string} measurementId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMeasurementviewFileMeasurementidWearrateBas(measurementId: string, options?: RawAxiosRequestConfig) {
        return MeasurementViewApiFp(this.configuration).getMeasurementviewFileMeasurementidWearrateBas(measurementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /MeasurementView/file/{measurementId}/wearrate-eff - GET
     * @param {string} measurementId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMeasurementviewFileMeasurementidWearrateEff(measurementId: string, options?: RawAxiosRequestConfig) {
        return MeasurementViewApiFp(this.configuration).getMeasurementviewFileMeasurementidWearrateEff(measurementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /MeasurementView/file/{measurementId}/wearrate-inst - GET
     * @param {string} measurementId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMeasurementviewFileMeasurementidWearrateInst(measurementId: string, options?: RawAxiosRequestConfig) {
        return MeasurementViewApiFp(this.configuration).getMeasurementviewFileMeasurementidWearrateInst(measurementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /MeasurementView/{measurementId}/details - GET
     * @param {string} measurementId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMeasurementviewMeasurementidDetails(measurementId: string, options?: RawAxiosRequestConfig) {
        return MeasurementViewApiFp(this.configuration).getMeasurementviewMeasurementidDetails(measurementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /MeasurementView/settings/{customerId}/{vesselType} - GET
     * @param {string} customerId 
     * @param {string} vesselType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMeasurementviewSettingsCustomeridVesseltype(customerId: string, vesselType: string, options?: RawAxiosRequestConfig) {
        return MeasurementViewApiFp(this.configuration).getMeasurementviewSettingsCustomeridVesseltype(customerId, vesselType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /MeasurementView/settings/edit/{vesselId} - GET
     * @param {string} vesselId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMeasurementviewSettingsEditVesselid(vesselId: string, options?: RawAxiosRequestConfig) {
        return MeasurementViewApiFp(this.configuration).getMeasurementviewSettingsEditVesselid(vesselId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /MeasurementView/settings/{vesselId} - GET
     * @param {string} vesselId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMeasurementviewSettingsVesselid(vesselId: string, options?: RawAxiosRequestConfig) {
        return MeasurementViewApiFp(this.configuration).getMeasurementviewSettingsVesselid(vesselId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /MeasurementView/{vesselId}/campaigns - GET
     * @param {string} vesselId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMeasurementviewVesselidCampaigns(vesselId: string, options?: RawAxiosRequestConfig) {
        return MeasurementViewApiFp(this.configuration).getMeasurementviewVesselidCampaigns(vesselId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /MeasurementView/{vesselId}/measurements/by-notes - GET
     * @param {string} vesselId 
     * @param {string} [notes] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMeasurementviewVesselidMeasurementsByNotes(vesselId: string, notes?: string, options?: RawAxiosRequestConfig) {
        return MeasurementViewApiFp(this.configuration).getMeasurementviewVesselidMeasurementsByNotes(vesselId, notes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /MeasurementView/{vesselId}/measurements/by-notes-exact - GET
     * @param {string} vesselId 
     * @param {string} [notes] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMeasurementviewVesselidMeasurementsByNotesExact(vesselId: string, notes?: string, options?: RawAxiosRequestConfig) {
        return MeasurementViewApiFp(this.configuration).getMeasurementviewVesselidMeasurementsByNotesExact(vesselId, notes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /MeasurementView/{vesselId}/measurements/{campaign} - GET
     * @param {string} vesselId 
     * @param {number} campaign 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMeasurementviewVesselidMeasurementsCampaign(vesselId: string, campaign: number, options?: RawAxiosRequestConfig) {
        return MeasurementViewApiFp(this.configuration).getMeasurementviewVesselidMeasurementsCampaign(vesselId, campaign, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /MeasurementView/{vesselId}/vessel - GET
     * @param {string} vesselId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMeasurementviewVesselidVessel(vesselId: string, options?: RawAxiosRequestConfig) {
        return MeasurementViewApiFp(this.configuration).getMeasurementviewVesselidVessel(vesselId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /MeasurementView/vessels/{customerId} - GET
     * @param {string} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMeasurementviewVesselsCustomerid(customerId: string, options?: RawAxiosRequestConfig) {
        return MeasurementViewApiFp(this.configuration).getMeasurementviewVesselsCustomerid(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /MeasurementView/settings/{customerId}/{vesselType} - POST
     * @param {string} customerId 
     * @param {string} vesselType 
     * @param {RHIMMeasurementServiceApiV1ModelsView3dSettingsDto} [rHIMMeasurementServiceApiV1ModelsView3dSettingsDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postMeasurementviewSettingsCustomeridVesseltype(customerId: string, vesselType: string, rHIMMeasurementServiceApiV1ModelsView3dSettingsDto?: RHIMMeasurementServiceApiV1ModelsView3dSettingsDto, options?: RawAxiosRequestConfig) {
        return MeasurementViewApiFp(this.configuration).postMeasurementviewSettingsCustomeridVesseltype(customerId, vesselType, rHIMMeasurementServiceApiV1ModelsView3dSettingsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /MeasurementView/settings/edit/{vesselId} - POST
     * @param {string} vesselId 
     * @param {RHIMMeasurementServiceApiV1ModelsView3dSettingsVesselUpdateDto} [rHIMMeasurementServiceApiV1ModelsView3dSettingsVesselUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postMeasurementviewSettingsEditVesselid(vesselId: string, rHIMMeasurementServiceApiV1ModelsView3dSettingsVesselUpdateDto?: RHIMMeasurementServiceApiV1ModelsView3dSettingsVesselUpdateDto, options?: RawAxiosRequestConfig) {
        return MeasurementViewApiFp(this.configuration).postMeasurementviewSettingsEditVesselid(vesselId, rHIMMeasurementServiceApiV1ModelsView3dSettingsVesselUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MeasurementsApi - axios parameter creator
 */
export const MeasurementsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary /Measurements/{vesselId} - GET
         * @param {string} vesselId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementsVesselid: async (vesselId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getMeasurementsVesselid', 'vesselId', vesselId)
            const localVarPath = `/Measurements/{vesselId}`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /Measurements/{vesselId}/{campaign} - GET
         * @param {string} vesselId 
         * @param {number} campaign 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementsVesselidCampaign: async (vesselId: string, campaign: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getMeasurementsVesselidCampaign', 'vesselId', vesselId)
            // verify required parameter 'campaign' is not null or undefined
            assertParamExists('getMeasurementsVesselidCampaign', 'campaign', campaign)
            const localVarPath = `/Measurements/{vesselId}/{campaign}`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)))
                .replace('{campaign}', encodeURIComponent(String(campaign)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MeasurementsApi - functional programming interface
 */
export const MeasurementsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MeasurementsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary /Measurements/{vesselId} - GET
         * @param {string} vesselId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeasurementsVesselid(vesselId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMMeasurementServiceApiV1ModelsMeasurementDetailedDataDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeasurementsVesselid(vesselId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementsApi.getMeasurementsVesselid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /Measurements/{vesselId}/{campaign} - GET
         * @param {string} vesselId 
         * @param {number} campaign 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeasurementsVesselidCampaign(vesselId: string, campaign: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMMeasurementServiceApiV1ModelsMeasurementDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeasurementsVesselidCampaign(vesselId, campaign, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementsApi.getMeasurementsVesselidCampaign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MeasurementsApi - factory interface
 */
export const MeasurementsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MeasurementsApiFp(configuration)
    return {
        /**
         * 
         * @summary /Measurements/{vesselId} - GET
         * @param {string} vesselId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementsVesselid(vesselId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMMeasurementServiceApiV1ModelsMeasurementDetailedDataDto>> {
            return localVarFp.getMeasurementsVesselid(vesselId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /Measurements/{vesselId}/{campaign} - GET
         * @param {string} vesselId 
         * @param {number} campaign 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementsVesselidCampaign(vesselId: string, campaign: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMMeasurementServiceApiV1ModelsMeasurementDto>> {
            return localVarFp.getMeasurementsVesselidCampaign(vesselId, campaign, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MeasurementsApi - object-oriented interface
 */
export class MeasurementsApi extends BaseAPI {
    /**
     * 
     * @summary /Measurements/{vesselId} - GET
     * @param {string} vesselId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMeasurementsVesselid(vesselId: string, options?: RawAxiosRequestConfig) {
        return MeasurementsApiFp(this.configuration).getMeasurementsVesselid(vesselId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /Measurements/{vesselId}/{campaign} - GET
     * @param {string} vesselId 
     * @param {number} campaign 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMeasurementsVesselidCampaign(vesselId: string, campaign: number, options?: RawAxiosRequestConfig) {
        return MeasurementsApiFp(this.configuration).getMeasurementsVesselidCampaign(vesselId, campaign, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PointCloudModificationsApi - axios parameter creator
 */
export const PointCloudModificationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Takes the point cloud modifications and sends an internal session event to store the data and triggers the meshing/registering.
         * @summary Takes the point cloud modifications and sends an internal session event to store the data and triggers the meshing/registering.
         * @param {string} vesselId The id of the vessel
         * @param {RHIMMeasurementServiceApiV1ModelsPointCloudModificationsDto} [rHIMMeasurementServiceApiV1ModelsPointCloudModificationsDto] The modifications for the point cloud file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPointcloudmodificationsVesselid: async (vesselId: string, rHIMMeasurementServiceApiV1ModelsPointCloudModificationsDto?: RHIMMeasurementServiceApiV1ModelsPointCloudModificationsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('postPointcloudmodificationsVesselid', 'vesselId', vesselId)
            const localVarPath = `/PointCloudModifications/{vesselId}`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMMeasurementServiceApiV1ModelsPointCloudModificationsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PointCloudModificationsApi - functional programming interface
 */
export const PointCloudModificationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PointCloudModificationsApiAxiosParamCreator(configuration)
    return {
        /**
         * Takes the point cloud modifications and sends an internal session event to store the data and triggers the meshing/registering.
         * @summary Takes the point cloud modifications and sends an internal session event to store the data and triggers the meshing/registering.
         * @param {string} vesselId The id of the vessel
         * @param {RHIMMeasurementServiceApiV1ModelsPointCloudModificationsDto} [rHIMMeasurementServiceApiV1ModelsPointCloudModificationsDto] The modifications for the point cloud file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postPointcloudmodificationsVesselid(vesselId: string, rHIMMeasurementServiceApiV1ModelsPointCloudModificationsDto?: RHIMMeasurementServiceApiV1ModelsPointCloudModificationsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postPointcloudmodificationsVesselid(vesselId, rHIMMeasurementServiceApiV1ModelsPointCloudModificationsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PointCloudModificationsApi.postPointcloudmodificationsVesselid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PointCloudModificationsApi - factory interface
 */
export const PointCloudModificationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PointCloudModificationsApiFp(configuration)
    return {
        /**
         * Takes the point cloud modifications and sends an internal session event to store the data and triggers the meshing/registering.
         * @summary Takes the point cloud modifications and sends an internal session event to store the data and triggers the meshing/registering.
         * @param {string} vesselId The id of the vessel
         * @param {RHIMMeasurementServiceApiV1ModelsPointCloudModificationsDto} [rHIMMeasurementServiceApiV1ModelsPointCloudModificationsDto] The modifications for the point cloud file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPointcloudmodificationsVesselid(vesselId: string, rHIMMeasurementServiceApiV1ModelsPointCloudModificationsDto?: RHIMMeasurementServiceApiV1ModelsPointCloudModificationsDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postPointcloudmodificationsVesselid(vesselId, rHIMMeasurementServiceApiV1ModelsPointCloudModificationsDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PointCloudModificationsApi - object-oriented interface
 */
export class PointCloudModificationsApi extends BaseAPI {
    /**
     * Takes the point cloud modifications and sends an internal session event to store the data and triggers the meshing/registering.
     * @summary Takes the point cloud modifications and sends an internal session event to store the data and triggers the meshing/registering.
     * @param {string} vesselId The id of the vessel
     * @param {RHIMMeasurementServiceApiV1ModelsPointCloudModificationsDto} [rHIMMeasurementServiceApiV1ModelsPointCloudModificationsDto] The modifications for the point cloud file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postPointcloudmodificationsVesselid(vesselId: string, rHIMMeasurementServiceApiV1ModelsPointCloudModificationsDto?: RHIMMeasurementServiceApiV1ModelsPointCloudModificationsDto, options?: RawAxiosRequestConfig) {
        return PointCloudModificationsApiFp(this.configuration).postPointcloudmodificationsVesselid(vesselId, rHIMMeasurementServiceApiV1ModelsPointCloudModificationsDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PointCloudRegisterApi - axios parameter creator
 */
export const PointCloudRegisterApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Calling this endpoint will start the process of register and mesh the ingressed point cloud file.
         * @summary Calling this endpoint will start the process of register and mesh the ingressed point cloud file.
         * @param {string} vesselId The id of the vessel
         * @param {RHIMMeasurementServiceApiV1ModelsPointCloudRegisterDto} [rHIMMeasurementServiceApiV1ModelsPointCloudRegisterDto] The information needed for a successful registering
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPointcloudregisterVesselid: async (vesselId: string, rHIMMeasurementServiceApiV1ModelsPointCloudRegisterDto?: RHIMMeasurementServiceApiV1ModelsPointCloudRegisterDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('postPointcloudregisterVesselid', 'vesselId', vesselId)
            const localVarPath = `/PointCloudRegister/{vesselId}`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMMeasurementServiceApiV1ModelsPointCloudRegisterDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PointCloudRegisterApi - functional programming interface
 */
export const PointCloudRegisterApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PointCloudRegisterApiAxiosParamCreator(configuration)
    return {
        /**
         * Calling this endpoint will start the process of register and mesh the ingressed point cloud file.
         * @summary Calling this endpoint will start the process of register and mesh the ingressed point cloud file.
         * @param {string} vesselId The id of the vessel
         * @param {RHIMMeasurementServiceApiV1ModelsPointCloudRegisterDto} [rHIMMeasurementServiceApiV1ModelsPointCloudRegisterDto] The information needed for a successful registering
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postPointcloudregisterVesselid(vesselId: string, rHIMMeasurementServiceApiV1ModelsPointCloudRegisterDto?: RHIMMeasurementServiceApiV1ModelsPointCloudRegisterDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postPointcloudregisterVesselid(vesselId, rHIMMeasurementServiceApiV1ModelsPointCloudRegisterDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PointCloudRegisterApi.postPointcloudregisterVesselid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PointCloudRegisterApi - factory interface
 */
export const PointCloudRegisterApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PointCloudRegisterApiFp(configuration)
    return {
        /**
         * Calling this endpoint will start the process of register and mesh the ingressed point cloud file.
         * @summary Calling this endpoint will start the process of register and mesh the ingressed point cloud file.
         * @param {string} vesselId The id of the vessel
         * @param {RHIMMeasurementServiceApiV1ModelsPointCloudRegisterDto} [rHIMMeasurementServiceApiV1ModelsPointCloudRegisterDto] The information needed for a successful registering
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPointcloudregisterVesselid(vesselId: string, rHIMMeasurementServiceApiV1ModelsPointCloudRegisterDto?: RHIMMeasurementServiceApiV1ModelsPointCloudRegisterDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postPointcloudregisterVesselid(vesselId, rHIMMeasurementServiceApiV1ModelsPointCloudRegisterDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PointCloudRegisterApi - object-oriented interface
 */
export class PointCloudRegisterApi extends BaseAPI {
    /**
     * Calling this endpoint will start the process of register and mesh the ingressed point cloud file.
     * @summary Calling this endpoint will start the process of register and mesh the ingressed point cloud file.
     * @param {string} vesselId The id of the vessel
     * @param {RHIMMeasurementServiceApiV1ModelsPointCloudRegisterDto} [rHIMMeasurementServiceApiV1ModelsPointCloudRegisterDto] The information needed for a successful registering
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postPointcloudregisterVesselid(vesselId: string, rHIMMeasurementServiceApiV1ModelsPointCloudRegisterDto?: RHIMMeasurementServiceApiV1ModelsPointCloudRegisterDto, options?: RawAxiosRequestConfig) {
        return PointCloudRegisterApiFp(this.configuration).postPointcloudregisterVesselid(vesselId, rHIMMeasurementServiceApiV1ModelsPointCloudRegisterDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ReferenceMeasurementsApi - axios parameter creator
 */
export const ReferenceMeasurementsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Finds a the reference measurement for a vessel and a campaign.
         * @summary Finds a the reference measurement for a vessel and a campaign.
         * @param {string} vesselId The id of the vessel.
         * @param {number} campaign The number of the campaign.
         * @param {number} [heat] The number of the heat, this is optional.
         * @param {string} [measurementTaken] The date time offset of the measurement when it was taken, this is optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferencemeasurementsVesselidCampaign: async (vesselId: string, campaign: number, heat?: number, measurementTaken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getReferencemeasurementsVesselidCampaign', 'vesselId', vesselId)
            // verify required parameter 'campaign' is not null or undefined
            assertParamExists('getReferencemeasurementsVesselidCampaign', 'campaign', campaign)
            const localVarPath = `/ReferenceMeasurements/{vesselId}/{campaign}`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)))
                .replace('{campaign}', encodeURIComponent(String(campaign)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (heat !== undefined) {
                localVarQueryParameter['heat'] = heat;
            }

            if (measurementTaken !== undefined) {
                localVarQueryParameter['measurementTaken'] = measurementTaken;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReferenceMeasurementsApi - functional programming interface
 */
export const ReferenceMeasurementsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReferenceMeasurementsApiAxiosParamCreator(configuration)
    return {
        /**
         * Finds a the reference measurement for a vessel and a campaign.
         * @summary Finds a the reference measurement for a vessel and a campaign.
         * @param {string} vesselId The id of the vessel.
         * @param {number} campaign The number of the campaign.
         * @param {number} [heat] The number of the heat, this is optional.
         * @param {string} [measurementTaken] The date time offset of the measurement when it was taken, this is optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReferencemeasurementsVesselidCampaign(vesselId: string, campaign: number, heat?: number, measurementTaken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMMeasurementServiceApiV1ModelsMeasurementDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReferencemeasurementsVesselidCampaign(vesselId, campaign, heat, measurementTaken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReferenceMeasurementsApi.getReferencemeasurementsVesselidCampaign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReferenceMeasurementsApi - factory interface
 */
export const ReferenceMeasurementsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReferenceMeasurementsApiFp(configuration)
    return {
        /**
         * Finds a the reference measurement for a vessel and a campaign.
         * @summary Finds a the reference measurement for a vessel and a campaign.
         * @param {string} vesselId The id of the vessel.
         * @param {number} campaign The number of the campaign.
         * @param {number} [heat] The number of the heat, this is optional.
         * @param {string} [measurementTaken] The date time offset of the measurement when it was taken, this is optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferencemeasurementsVesselidCampaign(vesselId: string, campaign: number, heat?: number, measurementTaken?: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMMeasurementServiceApiV1ModelsMeasurementDto> {
            return localVarFp.getReferencemeasurementsVesselidCampaign(vesselId, campaign, heat, measurementTaken, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReferenceMeasurementsApi - object-oriented interface
 */
export class ReferenceMeasurementsApi extends BaseAPI {
    /**
     * Finds a the reference measurement for a vessel and a campaign.
     * @summary Finds a the reference measurement for a vessel and a campaign.
     * @param {string} vesselId The id of the vessel.
     * @param {number} campaign The number of the campaign.
     * @param {number} [heat] The number of the heat, this is optional.
     * @param {string} [measurementTaken] The date time offset of the measurement when it was taken, this is optional.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getReferencemeasurementsVesselidCampaign(vesselId: string, campaign: number, heat?: number, measurementTaken?: string, options?: RawAxiosRequestConfig) {
        return ReferenceMeasurementsApiFp(this.configuration).getReferencemeasurementsVesselidCampaign(vesselId, campaign, heat, measurementTaken, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UploadApi - axios parameter creator
 */
export const UploadApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary /Upload/cancel/{measurementId} - GET
         * @param {string} measurementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUploadCancelMeasurementid: async (measurementId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'measurementId' is not null or undefined
            assertParamExists('getUploadCancelMeasurementid', 'measurementId', measurementId)
            const localVarPath = `/Upload/cancel/{measurementId}`
                .replace('{measurementId}', encodeURIComponent(String(measurementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /Upload/begin/{vesselId} - POST
         * @param {string} vesselId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUploadBeginVesselid: async (vesselId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('postUploadBeginVesselid', 'vesselId', vesselId)
            const localVarPath = `/Upload/begin/{vesselId}`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /Upload/part/{measurementId} - POST
         * @param {string} measurementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUploadPartMeasurementid: async (measurementId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'measurementId' is not null or undefined
            assertParamExists('postUploadPartMeasurementid', 'measurementId', measurementId)
            const localVarPath = `/Upload/part/{measurementId}`
                .replace('{measurementId}', encodeURIComponent(String(measurementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /Upload/pts/{vesselId} - POST
         * @param {string} vesselId 
         * @param {File} [file] 
         * @param {string} [fileName] 
         * @param {number} [fileSize] 
         * @param {number} [chunkCount] 
         * @param {number} [chunkSize] 
         * @param {string} [fileCompression] 
         * @param {string} [requestUtc] 
         * @param {string} [measurementId] 
         * @param {string} [referenceMeasurementId] 
         * @param {string} [processingHint] 
         * @param {string} [measurementSystem] 
         * @param {number} [campaign] 
         * @param {number} [heat] 
         * @param {string} [measurementTaken] 
         * @param {boolean} [viewOnly] 
         * @param {string} [vesselLining] 
         * @param {string} [liningCondition] 
         * @param {string} [liningMaintenanceType] 
         * @param {boolean} [hotMeasurement] 
         * @param {string} [notes] 
         * @param {string} [responsible] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUploadPtsVesselid: async (vesselId: string, file?: File, fileName?: string, fileSize?: number, chunkCount?: number, chunkSize?: number, fileCompression?: string, requestUtc?: string, measurementId?: string, referenceMeasurementId?: string, processingHint?: string, measurementSystem?: string, campaign?: number, heat?: number, measurementTaken?: string, viewOnly?: boolean, vesselLining?: string, liningCondition?: string, liningMaintenanceType?: string, hotMeasurement?: boolean, notes?: string, responsible?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('postUploadPtsVesselid', 'vesselId', vesselId)
            const localVarPath = `/Upload/pts/{vesselId}`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }

            if (fileName !== undefined) { 
                localVarFormParams.append('FileName', fileName as any);
            }

            if (fileSize !== undefined) { 
                localVarFormParams.append('FileSize', fileSize as any);
            }

            if (chunkCount !== undefined) { 
                localVarFormParams.append('ChunkCount', chunkCount as any);
            }

            if (chunkSize !== undefined) { 
                localVarFormParams.append('ChunkSize', chunkSize as any);
            }

            if (fileCompression !== undefined) { 
                localVarFormParams.append('FileCompression', fileCompression as any);
            }

            if (requestUtc !== undefined) { 
                localVarFormParams.append('RequestUtc', requestUtc as any);
            }

            if (measurementId !== undefined) { 
                localVarFormParams.append('MeasurementId', measurementId as any);
            }

            if (referenceMeasurementId !== undefined) { 
                localVarFormParams.append('ReferenceMeasurementId', referenceMeasurementId as any);
            }

            if (processingHint !== undefined) { 
                localVarFormParams.append('ProcessingHint', processingHint as any);
            }

            if (measurementSystem !== undefined) { 
                localVarFormParams.append('MeasurementSystem', measurementSystem as any);
            }

            if (campaign !== undefined) { 
                localVarFormParams.append('Campaign', campaign as any);
            }

            if (heat !== undefined) { 
                localVarFormParams.append('Heat', heat as any);
            }

            if (measurementTaken !== undefined) { 
                localVarFormParams.append('MeasurementTaken', measurementTaken as any);
            }

            if (viewOnly !== undefined) { 
                localVarFormParams.append('ViewOnly', String(viewOnly) as any);
            }

            if (vesselLining !== undefined) { 
                localVarFormParams.append('VesselLining', vesselLining as any);
            }

            if (liningCondition !== undefined) { 
                localVarFormParams.append('LiningCondition', liningCondition as any);
            }

            if (liningMaintenanceType !== undefined) { 
                localVarFormParams.append('LiningMaintenanceType', liningMaintenanceType as any);
            }

            if (hotMeasurement !== undefined) { 
                localVarFormParams.append('HotMeasurement', String(hotMeasurement) as any);
            }

            if (notes !== undefined) { 
                localVarFormParams.append('Notes', notes as any);
            }

            if (responsible !== undefined) { 
                localVarFormParams.append('Responsible', responsible as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UploadApi - functional programming interface
 */
export const UploadApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UploadApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary /Upload/cancel/{measurementId} - GET
         * @param {string} measurementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUploadCancelMeasurementid(measurementId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMMeasurementServiceWebV1ModelsUploadMeasurementFileResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUploadCancelMeasurementid(measurementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UploadApi.getUploadCancelMeasurementid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /Upload/begin/{vesselId} - POST
         * @param {string} vesselId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postUploadBeginVesselid(vesselId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMMeasurementServiceWebV1ModelsUploadMeasurementFileResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postUploadBeginVesselid(vesselId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UploadApi.postUploadBeginVesselid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /Upload/part/{measurementId} - POST
         * @param {string} measurementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postUploadPartMeasurementid(measurementId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMMeasurementServiceWebV1ModelsUploadMeasurementFileResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postUploadPartMeasurementid(measurementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UploadApi.postUploadPartMeasurementid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /Upload/pts/{vesselId} - POST
         * @param {string} vesselId 
         * @param {File} [file] 
         * @param {string} [fileName] 
         * @param {number} [fileSize] 
         * @param {number} [chunkCount] 
         * @param {number} [chunkSize] 
         * @param {string} [fileCompression] 
         * @param {string} [requestUtc] 
         * @param {string} [measurementId] 
         * @param {string} [referenceMeasurementId] 
         * @param {string} [processingHint] 
         * @param {string} [measurementSystem] 
         * @param {number} [campaign] 
         * @param {number} [heat] 
         * @param {string} [measurementTaken] 
         * @param {boolean} [viewOnly] 
         * @param {string} [vesselLining] 
         * @param {string} [liningCondition] 
         * @param {string} [liningMaintenanceType] 
         * @param {boolean} [hotMeasurement] 
         * @param {string} [notes] 
         * @param {string} [responsible] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postUploadPtsVesselid(vesselId: string, file?: File, fileName?: string, fileSize?: number, chunkCount?: number, chunkSize?: number, fileCompression?: string, requestUtc?: string, measurementId?: string, referenceMeasurementId?: string, processingHint?: string, measurementSystem?: string, campaign?: number, heat?: number, measurementTaken?: string, viewOnly?: boolean, vesselLining?: string, liningCondition?: string, liningMaintenanceType?: string, hotMeasurement?: boolean, notes?: string, responsible?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMMeasurementServiceWebV1ModelsUploadMeasurementFileResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postUploadPtsVesselid(vesselId, file, fileName, fileSize, chunkCount, chunkSize, fileCompression, requestUtc, measurementId, referenceMeasurementId, processingHint, measurementSystem, campaign, heat, measurementTaken, viewOnly, vesselLining, liningCondition, liningMaintenanceType, hotMeasurement, notes, responsible, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UploadApi.postUploadPtsVesselid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UploadApi - factory interface
 */
export const UploadApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UploadApiFp(configuration)
    return {
        /**
         * 
         * @summary /Upload/cancel/{measurementId} - GET
         * @param {string} measurementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUploadCancelMeasurementid(measurementId: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMMeasurementServiceWebV1ModelsUploadMeasurementFileResponseDto> {
            return localVarFp.getUploadCancelMeasurementid(measurementId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /Upload/begin/{vesselId} - POST
         * @param {string} vesselId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUploadBeginVesselid(vesselId: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMMeasurementServiceWebV1ModelsUploadMeasurementFileResponseDto> {
            return localVarFp.postUploadBeginVesselid(vesselId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /Upload/part/{measurementId} - POST
         * @param {string} measurementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUploadPartMeasurementid(measurementId: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMMeasurementServiceWebV1ModelsUploadMeasurementFileResponseDto> {
            return localVarFp.postUploadPartMeasurementid(measurementId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /Upload/pts/{vesselId} - POST
         * @param {string} vesselId 
         * @param {File} [file] 
         * @param {string} [fileName] 
         * @param {number} [fileSize] 
         * @param {number} [chunkCount] 
         * @param {number} [chunkSize] 
         * @param {string} [fileCompression] 
         * @param {string} [requestUtc] 
         * @param {string} [measurementId] 
         * @param {string} [referenceMeasurementId] 
         * @param {string} [processingHint] 
         * @param {string} [measurementSystem] 
         * @param {number} [campaign] 
         * @param {number} [heat] 
         * @param {string} [measurementTaken] 
         * @param {boolean} [viewOnly] 
         * @param {string} [vesselLining] 
         * @param {string} [liningCondition] 
         * @param {string} [liningMaintenanceType] 
         * @param {boolean} [hotMeasurement] 
         * @param {string} [notes] 
         * @param {string} [responsible] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUploadPtsVesselid(vesselId: string, file?: File, fileName?: string, fileSize?: number, chunkCount?: number, chunkSize?: number, fileCompression?: string, requestUtc?: string, measurementId?: string, referenceMeasurementId?: string, processingHint?: string, measurementSystem?: string, campaign?: number, heat?: number, measurementTaken?: string, viewOnly?: boolean, vesselLining?: string, liningCondition?: string, liningMaintenanceType?: string, hotMeasurement?: boolean, notes?: string, responsible?: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMMeasurementServiceWebV1ModelsUploadMeasurementFileResponseDto> {
            return localVarFp.postUploadPtsVesselid(vesselId, file, fileName, fileSize, chunkCount, chunkSize, fileCompression, requestUtc, measurementId, referenceMeasurementId, processingHint, measurementSystem, campaign, heat, measurementTaken, viewOnly, vesselLining, liningCondition, liningMaintenanceType, hotMeasurement, notes, responsible, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UploadApi - object-oriented interface
 */
export class UploadApi extends BaseAPI {
    /**
     * 
     * @summary /Upload/cancel/{measurementId} - GET
     * @param {string} measurementId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUploadCancelMeasurementid(measurementId: string, options?: RawAxiosRequestConfig) {
        return UploadApiFp(this.configuration).getUploadCancelMeasurementid(measurementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /Upload/begin/{vesselId} - POST
     * @param {string} vesselId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postUploadBeginVesselid(vesselId: string, options?: RawAxiosRequestConfig) {
        return UploadApiFp(this.configuration).postUploadBeginVesselid(vesselId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /Upload/part/{measurementId} - POST
     * @param {string} measurementId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postUploadPartMeasurementid(measurementId: string, options?: RawAxiosRequestConfig) {
        return UploadApiFp(this.configuration).postUploadPartMeasurementid(measurementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /Upload/pts/{vesselId} - POST
     * @param {string} vesselId 
     * @param {File} [file] 
     * @param {string} [fileName] 
     * @param {number} [fileSize] 
     * @param {number} [chunkCount] 
     * @param {number} [chunkSize] 
     * @param {string} [fileCompression] 
     * @param {string} [requestUtc] 
     * @param {string} [measurementId] 
     * @param {string} [referenceMeasurementId] 
     * @param {string} [processingHint] 
     * @param {string} [measurementSystem] 
     * @param {number} [campaign] 
     * @param {number} [heat] 
     * @param {string} [measurementTaken] 
     * @param {boolean} [viewOnly] 
     * @param {string} [vesselLining] 
     * @param {string} [liningCondition] 
     * @param {string} [liningMaintenanceType] 
     * @param {boolean} [hotMeasurement] 
     * @param {string} [notes] 
     * @param {string} [responsible] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postUploadPtsVesselid(vesselId: string, file?: File, fileName?: string, fileSize?: number, chunkCount?: number, chunkSize?: number, fileCompression?: string, requestUtc?: string, measurementId?: string, referenceMeasurementId?: string, processingHint?: string, measurementSystem?: string, campaign?: number, heat?: number, measurementTaken?: string, viewOnly?: boolean, vesselLining?: string, liningCondition?: string, liningMaintenanceType?: string, hotMeasurement?: boolean, notes?: string, responsible?: string, options?: RawAxiosRequestConfig) {
        return UploadApiFp(this.configuration).postUploadPtsVesselid(vesselId, file, fileName, fileSize, chunkCount, chunkSize, fileCompression, requestUtc, measurementId, referenceMeasurementId, processingHint, measurementSystem, campaign, heat, measurementTaken, viewOnly, vesselLining, liningCondition, liningMaintenanceType, hotMeasurement, notes, responsible, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ValidateApi - axios parameter creator
 */
export const ValidateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary /validate/pts/{vesselId} - POST
         * @param {string} vesselId 
         * @param {RHIMMeasurementServiceApiV1ModelsValidatePointCloudFileDto} [rHIMMeasurementServiceApiV1ModelsValidatePointCloudFileDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postValidatePtsVesselid: async (vesselId: string, rHIMMeasurementServiceApiV1ModelsValidatePointCloudFileDto?: RHIMMeasurementServiceApiV1ModelsValidatePointCloudFileDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('postValidatePtsVesselid', 'vesselId', vesselId)
            const localVarPath = `/validate/pts/{vesselId}`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMMeasurementServiceApiV1ModelsValidatePointCloudFileDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /ValidateFerrotronUpload/v1/{vesselId} - POST
         * @param {string} vesselId 
         * @param {RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto} [rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postValidateferrotronuploadV1Vesselid: async (vesselId: string, rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto?: RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('postValidateferrotronuploadV1Vesselid', 'vesselId', vesselId)
            const localVarPath = `/ValidateFerrotronUpload/v1/{vesselId}`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /ValidateFerrotronUpload/v2/{vesselId} - POST
         * @param {string} vesselId 
         * @param {RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto} [rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postValidateferrotronuploadV2Vesselid: async (vesselId: string, rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto?: RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('postValidateferrotronuploadV2Vesselid', 'vesselId', vesselId)
            const localVarPath = `/ValidateFerrotronUpload/v2/{vesselId}`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /ValidateHyperionUpload/raw/{vesselId} - POST
         * @param {string} vesselId 
         * @param {RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto} [rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postValidatehyperionuploadRawVesselid: async (vesselId: string, rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto?: RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('postValidatehyperionuploadRawVesselid', 'vesselId', vesselId)
            const localVarPath = `/ValidateHyperionUpload/raw/{vesselId}`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /ValidateIMSIUpload/{vesselId} - POST
         * @param {string} vesselId 
         * @param {RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto} [rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postValidateimsiuploadVesselid: async (vesselId: string, rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto?: RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('postValidateimsiuploadVesselid', 'vesselId', vesselId)
            const localVarPath = `/ValidateIMSIUpload/{vesselId}`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /ValidateLatitudeUpload/{vesselId} - POST
         * @param {string} vesselId 
         * @param {RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto} [rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postValidatelatitudeuploadVesselid: async (vesselId: string, rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto?: RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('postValidatelatitudeuploadVesselid', 'vesselId', vesselId)
            const localVarPath = `/ValidateLatitudeUpload/{vesselId}`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /ValidateLeicaUpload/v1/{vesselId} - POST
         * @param {string} vesselId 
         * @param {RHIMMeasurementServiceApiV1ModelsValidatePointCloudFileDto} [rHIMMeasurementServiceApiV1ModelsValidatePointCloudFileDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postValidateleicauploadV1Vesselid: async (vesselId: string, rHIMMeasurementServiceApiV1ModelsValidatePointCloudFileDto?: RHIMMeasurementServiceApiV1ModelsValidatePointCloudFileDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('postValidateleicauploadV1Vesselid', 'vesselId', vesselId)
            const localVarPath = `/ValidateLeicaUpload/v1/{vesselId}`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMMeasurementServiceApiV1ModelsValidatePointCloudFileDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /ValidateScaniverseUpload/{vesselId} - POST
         * @param {string} vesselId 
         * @param {RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto} [rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postValidatescaniverseuploadVesselid: async (vesselId: string, rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto?: RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('postValidatescaniverseuploadVesselid', 'vesselId', vesselId)
            const localVarPath = `/ValidateScaniverseUpload/{vesselId}`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /ValidateVertexUpload/hyperion/{vesselId} - POST
         * @param {string} vesselId 
         * @param {RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto} [rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postValidatevertexuploadHyperionVesselid: async (vesselId: string, rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto?: RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('postValidatevertexuploadHyperionVesselid', 'vesselId', vesselId)
            const localVarPath = `/ValidateVertexUpload/hyperion/{vesselId}`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary /ValidateVertexUpload/lcs/{vesselId} - POST
         * @param {string} vesselId 
         * @param {RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto} [rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postValidatevertexuploadLcsVesselid: async (vesselId: string, rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto?: RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('postValidatevertexuploadLcsVesselid', 'vesselId', vesselId)
            const localVarPath = `/ValidateVertexUpload/lcs/{vesselId}`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ValidateApi - functional programming interface
 */
export const ValidateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ValidateApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary /validate/pts/{vesselId} - POST
         * @param {string} vesselId 
         * @param {RHIMMeasurementServiceApiV1ModelsValidatePointCloudFileDto} [rHIMMeasurementServiceApiV1ModelsValidatePointCloudFileDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postValidatePtsVesselid(vesselId: string, rHIMMeasurementServiceApiV1ModelsValidatePointCloudFileDto?: RHIMMeasurementServiceApiV1ModelsValidatePointCloudFileDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMMeasurementServiceWebV1ModelsValidateResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postValidatePtsVesselid(vesselId, rHIMMeasurementServiceApiV1ModelsValidatePointCloudFileDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ValidateApi.postValidatePtsVesselid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /ValidateFerrotronUpload/v1/{vesselId} - POST
         * @param {string} vesselId 
         * @param {RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto} [rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postValidateferrotronuploadV1Vesselid(vesselId: string, rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto?: RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMMeasurementServiceWebV1ModelsValidateResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postValidateferrotronuploadV1Vesselid(vesselId, rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ValidateApi.postValidateferrotronuploadV1Vesselid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /ValidateFerrotronUpload/v2/{vesselId} - POST
         * @param {string} vesselId 
         * @param {RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto} [rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postValidateferrotronuploadV2Vesselid(vesselId: string, rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto?: RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMMeasurementServiceWebV1ModelsValidateResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postValidateferrotronuploadV2Vesselid(vesselId, rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ValidateApi.postValidateferrotronuploadV2Vesselid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /ValidateHyperionUpload/raw/{vesselId} - POST
         * @param {string} vesselId 
         * @param {RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto} [rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postValidatehyperionuploadRawVesselid(vesselId: string, rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto?: RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMMeasurementServiceWebV1ModelsValidateResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postValidatehyperionuploadRawVesselid(vesselId, rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ValidateApi.postValidatehyperionuploadRawVesselid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /ValidateIMSIUpload/{vesselId} - POST
         * @param {string} vesselId 
         * @param {RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto} [rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postValidateimsiuploadVesselid(vesselId: string, rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto?: RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMMeasurementServiceWebV1ModelsValidateResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postValidateimsiuploadVesselid(vesselId, rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ValidateApi.postValidateimsiuploadVesselid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /ValidateLatitudeUpload/{vesselId} - POST
         * @param {string} vesselId 
         * @param {RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto} [rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postValidatelatitudeuploadVesselid(vesselId: string, rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto?: RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMMeasurementServiceWebV1ModelsValidateResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postValidatelatitudeuploadVesselid(vesselId, rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ValidateApi.postValidatelatitudeuploadVesselid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /ValidateLeicaUpload/v1/{vesselId} - POST
         * @param {string} vesselId 
         * @param {RHIMMeasurementServiceApiV1ModelsValidatePointCloudFileDto} [rHIMMeasurementServiceApiV1ModelsValidatePointCloudFileDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postValidateleicauploadV1Vesselid(vesselId: string, rHIMMeasurementServiceApiV1ModelsValidatePointCloudFileDto?: RHIMMeasurementServiceApiV1ModelsValidatePointCloudFileDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMMeasurementServiceWebV1ModelsValidateResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postValidateleicauploadV1Vesselid(vesselId, rHIMMeasurementServiceApiV1ModelsValidatePointCloudFileDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ValidateApi.postValidateleicauploadV1Vesselid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /ValidateScaniverseUpload/{vesselId} - POST
         * @param {string} vesselId 
         * @param {RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto} [rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postValidatescaniverseuploadVesselid(vesselId: string, rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto?: RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMMeasurementServiceWebV1ModelsValidateResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postValidatescaniverseuploadVesselid(vesselId, rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ValidateApi.postValidatescaniverseuploadVesselid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /ValidateVertexUpload/hyperion/{vesselId} - POST
         * @param {string} vesselId 
         * @param {RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto} [rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postValidatevertexuploadHyperionVesselid(vesselId: string, rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto?: RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMMeasurementServiceWebV1ModelsValidateResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postValidatevertexuploadHyperionVesselid(vesselId, rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ValidateApi.postValidatevertexuploadHyperionVesselid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary /ValidateVertexUpload/lcs/{vesselId} - POST
         * @param {string} vesselId 
         * @param {RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto} [rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postValidatevertexuploadLcsVesselid(vesselId: string, rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto?: RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMMeasurementServiceWebV1ModelsValidateResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postValidatevertexuploadLcsVesselid(vesselId, rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ValidateApi.postValidatevertexuploadLcsVesselid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ValidateApi - factory interface
 */
export const ValidateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ValidateApiFp(configuration)
    return {
        /**
         * 
         * @summary /validate/pts/{vesselId} - POST
         * @param {string} vesselId 
         * @param {RHIMMeasurementServiceApiV1ModelsValidatePointCloudFileDto} [rHIMMeasurementServiceApiV1ModelsValidatePointCloudFileDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postValidatePtsVesselid(vesselId: string, rHIMMeasurementServiceApiV1ModelsValidatePointCloudFileDto?: RHIMMeasurementServiceApiV1ModelsValidatePointCloudFileDto, options?: RawAxiosRequestConfig): AxiosPromise<RHIMMeasurementServiceWebV1ModelsValidateResponseDto> {
            return localVarFp.postValidatePtsVesselid(vesselId, rHIMMeasurementServiceApiV1ModelsValidatePointCloudFileDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /ValidateFerrotronUpload/v1/{vesselId} - POST
         * @param {string} vesselId 
         * @param {RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto} [rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postValidateferrotronuploadV1Vesselid(vesselId: string, rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto?: RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, options?: RawAxiosRequestConfig): AxiosPromise<RHIMMeasurementServiceWebV1ModelsValidateResponseDto> {
            return localVarFp.postValidateferrotronuploadV1Vesselid(vesselId, rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /ValidateFerrotronUpload/v2/{vesselId} - POST
         * @param {string} vesselId 
         * @param {RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto} [rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postValidateferrotronuploadV2Vesselid(vesselId: string, rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto?: RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, options?: RawAxiosRequestConfig): AxiosPromise<RHIMMeasurementServiceWebV1ModelsValidateResponseDto> {
            return localVarFp.postValidateferrotronuploadV2Vesselid(vesselId, rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /ValidateHyperionUpload/raw/{vesselId} - POST
         * @param {string} vesselId 
         * @param {RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto} [rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postValidatehyperionuploadRawVesselid(vesselId: string, rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto?: RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, options?: RawAxiosRequestConfig): AxiosPromise<RHIMMeasurementServiceWebV1ModelsValidateResponseDto> {
            return localVarFp.postValidatehyperionuploadRawVesselid(vesselId, rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /ValidateIMSIUpload/{vesselId} - POST
         * @param {string} vesselId 
         * @param {RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto} [rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postValidateimsiuploadVesselid(vesselId: string, rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto?: RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, options?: RawAxiosRequestConfig): AxiosPromise<RHIMMeasurementServiceWebV1ModelsValidateResponseDto> {
            return localVarFp.postValidateimsiuploadVesselid(vesselId, rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /ValidateLatitudeUpload/{vesselId} - POST
         * @param {string} vesselId 
         * @param {RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto} [rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postValidatelatitudeuploadVesselid(vesselId: string, rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto?: RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, options?: RawAxiosRequestConfig): AxiosPromise<RHIMMeasurementServiceWebV1ModelsValidateResponseDto> {
            return localVarFp.postValidatelatitudeuploadVesselid(vesselId, rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /ValidateLeicaUpload/v1/{vesselId} - POST
         * @param {string} vesselId 
         * @param {RHIMMeasurementServiceApiV1ModelsValidatePointCloudFileDto} [rHIMMeasurementServiceApiV1ModelsValidatePointCloudFileDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postValidateleicauploadV1Vesselid(vesselId: string, rHIMMeasurementServiceApiV1ModelsValidatePointCloudFileDto?: RHIMMeasurementServiceApiV1ModelsValidatePointCloudFileDto, options?: RawAxiosRequestConfig): AxiosPromise<RHIMMeasurementServiceWebV1ModelsValidateResponseDto> {
            return localVarFp.postValidateleicauploadV1Vesselid(vesselId, rHIMMeasurementServiceApiV1ModelsValidatePointCloudFileDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /ValidateScaniverseUpload/{vesselId} - POST
         * @param {string} vesselId 
         * @param {RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto} [rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postValidatescaniverseuploadVesselid(vesselId: string, rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto?: RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, options?: RawAxiosRequestConfig): AxiosPromise<RHIMMeasurementServiceWebV1ModelsValidateResponseDto> {
            return localVarFp.postValidatescaniverseuploadVesselid(vesselId, rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /ValidateVertexUpload/hyperion/{vesselId} - POST
         * @param {string} vesselId 
         * @param {RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto} [rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postValidatevertexuploadHyperionVesselid(vesselId: string, rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto?: RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, options?: RawAxiosRequestConfig): AxiosPromise<RHIMMeasurementServiceWebV1ModelsValidateResponseDto> {
            return localVarFp.postValidatevertexuploadHyperionVesselid(vesselId, rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary /ValidateVertexUpload/lcs/{vesselId} - POST
         * @param {string} vesselId 
         * @param {RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto} [rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postValidatevertexuploadLcsVesselid(vesselId: string, rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto?: RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, options?: RawAxiosRequestConfig): AxiosPromise<RHIMMeasurementServiceWebV1ModelsValidateResponseDto> {
            return localVarFp.postValidatevertexuploadLcsVesselid(vesselId, rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ValidateApi - object-oriented interface
 */
export class ValidateApi extends BaseAPI {
    /**
     * 
     * @summary /validate/pts/{vesselId} - POST
     * @param {string} vesselId 
     * @param {RHIMMeasurementServiceApiV1ModelsValidatePointCloudFileDto} [rHIMMeasurementServiceApiV1ModelsValidatePointCloudFileDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postValidatePtsVesselid(vesselId: string, rHIMMeasurementServiceApiV1ModelsValidatePointCloudFileDto?: RHIMMeasurementServiceApiV1ModelsValidatePointCloudFileDto, options?: RawAxiosRequestConfig) {
        return ValidateApiFp(this.configuration).postValidatePtsVesselid(vesselId, rHIMMeasurementServiceApiV1ModelsValidatePointCloudFileDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /ValidateFerrotronUpload/v1/{vesselId} - POST
     * @param {string} vesselId 
     * @param {RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto} [rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postValidateferrotronuploadV1Vesselid(vesselId: string, rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto?: RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, options?: RawAxiosRequestConfig) {
        return ValidateApiFp(this.configuration).postValidateferrotronuploadV1Vesselid(vesselId, rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /ValidateFerrotronUpload/v2/{vesselId} - POST
     * @param {string} vesselId 
     * @param {RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto} [rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postValidateferrotronuploadV2Vesselid(vesselId: string, rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto?: RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, options?: RawAxiosRequestConfig) {
        return ValidateApiFp(this.configuration).postValidateferrotronuploadV2Vesselid(vesselId, rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /ValidateHyperionUpload/raw/{vesselId} - POST
     * @param {string} vesselId 
     * @param {RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto} [rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postValidatehyperionuploadRawVesselid(vesselId: string, rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto?: RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, options?: RawAxiosRequestConfig) {
        return ValidateApiFp(this.configuration).postValidatehyperionuploadRawVesselid(vesselId, rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /ValidateIMSIUpload/{vesselId} - POST
     * @param {string} vesselId 
     * @param {RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto} [rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postValidateimsiuploadVesselid(vesselId: string, rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto?: RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, options?: RawAxiosRequestConfig) {
        return ValidateApiFp(this.configuration).postValidateimsiuploadVesselid(vesselId, rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /ValidateLatitudeUpload/{vesselId} - POST
     * @param {string} vesselId 
     * @param {RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto} [rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postValidatelatitudeuploadVesselid(vesselId: string, rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto?: RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, options?: RawAxiosRequestConfig) {
        return ValidateApiFp(this.configuration).postValidatelatitudeuploadVesselid(vesselId, rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /ValidateLeicaUpload/v1/{vesselId} - POST
     * @param {string} vesselId 
     * @param {RHIMMeasurementServiceApiV1ModelsValidatePointCloudFileDto} [rHIMMeasurementServiceApiV1ModelsValidatePointCloudFileDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postValidateleicauploadV1Vesselid(vesselId: string, rHIMMeasurementServiceApiV1ModelsValidatePointCloudFileDto?: RHIMMeasurementServiceApiV1ModelsValidatePointCloudFileDto, options?: RawAxiosRequestConfig) {
        return ValidateApiFp(this.configuration).postValidateleicauploadV1Vesselid(vesselId, rHIMMeasurementServiceApiV1ModelsValidatePointCloudFileDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /ValidateScaniverseUpload/{vesselId} - POST
     * @param {string} vesselId 
     * @param {RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto} [rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postValidatescaniverseuploadVesselid(vesselId: string, rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto?: RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, options?: RawAxiosRequestConfig) {
        return ValidateApiFp(this.configuration).postValidatescaniverseuploadVesselid(vesselId, rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /ValidateVertexUpload/hyperion/{vesselId} - POST
     * @param {string} vesselId 
     * @param {RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto} [rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postValidatevertexuploadHyperionVesselid(vesselId: string, rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto?: RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, options?: RawAxiosRequestConfig) {
        return ValidateApiFp(this.configuration).postValidatevertexuploadHyperionVesselid(vesselId, rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary /ValidateVertexUpload/lcs/{vesselId} - POST
     * @param {string} vesselId 
     * @param {RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto} [rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postValidatevertexuploadLcsVesselid(vesselId: string, rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto?: RHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, options?: RawAxiosRequestConfig) {
        return ValidateApiFp(this.configuration).postValidatevertexuploadLcsVesselid(vesselId, rHIMMeasurementServiceApiV1ModelsValidateMeasurementUploadDto, options).then((request) => request(this.axios, this.basePath));
    }
}



